/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessModel
 */
export interface AccessModel {
    /**
     * 
     * @type {string}
     * @memberof AccessModel
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessModel
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {ProjectOfAccessModel}
     * @memberof AccessModel
     */
    'Project'?: ProjectOfAccessModel;
    /**
     * 
     * @type {TeamMemberOfAccessModel}
     * @memberof AccessModel
     */
    'TeamMember'?: TeamMemberOfAccessModel;
    /**
     * 
     * @type {string}
     * @memberof AccessModel
     */
    'Tool'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessModel
     */
    'Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessModel
     */
    'Notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessModel
     */
    'Email'?: string;
    /**
     * 
     * @type {object}
     * @memberof AccessModel
     */
    'GrantedOn'?: object;
    /**
     * 
     * @type {object}
     * @memberof AccessModel
     */
    'RevokedOn'?: object;
}
/**
 * 
 * @export
 * @interface AccountLedgerReportItem
 */
export interface AccountLedgerReportItem {
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerReportItem
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerReportItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerReportItem
     */
    'referenceNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountLedgerReportItem
     */
    'debit'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLedgerReportItem
     */
    'credit'?: number;
}
/**
 * 
 * @export
 * @interface AccountLedgerRequest
 */
export interface AccountLedgerRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountLedgerRequest
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLedgerRequest
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerRequest
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerRequest
     */
    'sortProperty'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLedgerRequest
     */
    'sortOrder'?: string;
}
/**
 * 
 * @export
 * @interface ActivityModel
 */
export interface ActivityModel {
    /**
     * 
     * @type {string}
     * @memberof ActivityModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityModel
     */
    'Value'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityModel
     */
    'DefaultTechnology'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityModel
     */
    'IconClass'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityModel
     */
    'Disabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ActivityReport
 */
export interface ActivityReport {
    /**
     * 
     * @type {string}
     * @memberof ActivityReport
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityReport
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityReport
     */
    'netEffort'?: number;
}
/**
 * 
 * @export
 * @interface ActivityWatchRequestVM
 */
export interface ActivityWatchRequestVM {
    /**
     * 
     * @type {string}
     * @memberof ActivityWatchRequestVM
     */
    'vmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityWatchRequestVM
     */
    'date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityWatchRequestVM
     */
    'includeAFK'?: boolean;
}
/**
 * 
 * @export
 * @interface AddresssModel
 */
export interface AddresssModel {
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'Name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddresssModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'Suburb'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'StreetAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'State'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddresssModel
     */
    'Postcode'?: string;
    /**
     * 
     * @type {object}
     * @memberof AddresssModel
     */
    'VerifiedOn'?: object;
    /**
     * 
     * @type {object}
     * @memberof AddresssModel
     */
    'StartTimerDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof AddresssModel
     */
    'EndTimerDate'?: object;
    /**
     * 
     * @type {number}
     * @memberof AddresssModel
     */
    'WrongCodeInputCount'?: number;
}
/**
 * 
 * @export
 * @interface Adjustment
 */
export interface Adjustment {
    /**
     * 
     * @type {string}
     * @memberof Adjustment
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Adjustment
     */
    'adjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof Adjustment
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Adjustment
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface AdminSupportNotificationItemModel
 */
export interface AdminSupportNotificationItemModel {
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'CreatedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'LastReplyOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'Sender'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'SenderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'VmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationItemModel
     */
    'Status'?: string;
    /**
     * 
     * @type {Array<AdminSupportNotificationReplyItemModel>}
     * @memberof AdminSupportNotificationItemModel
     */
    'Replies'?: Array<AdminSupportNotificationReplyItemModel>;
}
/**
 * 
 * @export
 * @interface AdminSupportNotificationReplyItemModel
 */
export interface AdminSupportNotificationReplyItemModel {
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationReplyItemModel
     */
    'CreatedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationReplyItemModel
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationReplyItemModel
     */
    'Sender'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupportNotificationReplyItemModel
     */
    'SenderId'?: string;
}
/**
 * 
 * @export
 * @interface ApiObjectResult
 */
export interface ApiObjectResult {
    /**
     * 
     * @type {object}
     * @memberof ApiObjectResult
     */
    'value'?: object;
    /**
     * 
     * @type {number}
     * @memberof ApiObjectResult
     */
    'statusCode'?: number;
}
/**
 * 
 * @export
 * @interface AssessmentModel
 */
export interface AssessmentModel {
    /**
     * 
     * @type {string}
     * @memberof AssessmentModel
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof AssessmentModel
     */
    'AssessmentDate'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentModel
     */
    'CoreSkill'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssessmentModel
     */
    'Notes'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentModel
     */
    'Platform'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AssessmentModel
     */
    'Score'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentModel
     */
    'TeammemberId'?: string;
}
/**
 * 
 * @export
 * @interface AuditTrailModel
 */
export interface AuditTrailModel {
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'id'?: string;
    /**
     * 
     * @type {RecordTypeModel}
     * @memberof AuditTrailModel
     */
    'RecordType'?: RecordTypeModel;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'Event'?: string;
    /**
     * 
     * @type {object}
     * @memberof AuditTrailModel
     */
    'DateTime'?: object;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'UserId'?: string;
}
/**
 * 
 * @export
 * @interface AuthenticateResponse
 */
export interface AuthenticateResponse {
    /**
     * 
     * @type {UserModel}
     * @memberof AuthenticateResponse
     */
    'user'?: UserModel;
    /**
     * 
     * @type {string}
     * @memberof AuthenticateResponse
     */
    'jwtToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticateResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticateResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {IpToLocationResponseModel}
     * @memberof AuthenticateResponse
     */
    'ipDetail'?: IpToLocationResponseModel;
}
/**
 * 
 * @export
 * @interface AuthorModel
 */
export interface AuthorModel {
    /**
     * 
     * @type {string}
     * @memberof AuthorModel
     */
    'Author'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorModel
     */
    'TeamMemberName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthorModel
     */
    'IgnoredByLineManagers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AzureAISearchTeammemberByClientResponseModel
 */
export interface AzureAISearchTeammemberByClientResponseModel {
    /**
     * 
     * @type {number}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'Age'?: number;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'ExperienceYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'JobTitle'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'Skills'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AzureAISearchTeammemberByClientResponseModel
     */
    'Roles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AzureAISearchTeammemberRequestModel
 */
export interface AzureAISearchTeammemberRequestModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'age'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'jobRoles'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'locations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'skills'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'totalExperience'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureAISearchTeammemberRequestModel
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface AzureStorageUrl
 */
export interface AzureStorageUrl {
    /**
     * 
     * @type {string}
     * @memberof AzureStorageUrl
     */
    'Extension'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureStorageUrl
     */
    'FileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AzureStorageUrl
     */
    'Url'?: string;
}
/**
 * 
 * @export
 * @interface BankAccountModel
 */
export interface BankAccountModel {
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'BankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'ShebaNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'BSB'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'AccountName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'AccountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountModel
     */
    'CreatedAt'?: string;
}
/**
 * 
 * @export
 * @interface BatchModel
 */
export interface BatchModel {
    /**
     * 
     * @type {string}
     * @memberof BatchModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchModel
     */
    'Title'?: string;
    /**
     * 
     * @type {object}
     * @memberof BatchModel
     */
    'CreationDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof BatchModel
     */
    'ScheduledDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof BatchModel
     */
    'Description'?: string;
}
/**
 * 
 * @export
 * @interface BillableItemMin
 */
export interface BillableItemMin {
    /**
     * 
     * @type {string}
     * @memberof BillableItemMin
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemMin
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemMin
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemMin
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface BillableItemModel
 */
export interface BillableItemModel {
    /**
     * 
     * @type {string}
     * @memberof BillableItemModel
     */
    'Code'?: BillableItemModelCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof BillableItemModel
     */
    'Fee'?: number;
    /**
     * 
     * @type {string}
     * @memberof BillableItemModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemModel
     */
    'Interval'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillableItemModel
     */
    'Type'?: BillableItemModelTypeEnum;
}

export const BillableItemModelCodeEnum = {
    Ciaa: 'CIAA',
    Ciaar: 'CIAAR',
    Crmg: 'CRMG',
    Crmgr: 'CRMGR',
    Lims: 'LIMS',
    Limsr: 'LIMSR',
    Ofsp: 'OFSP',
    Ofspr: 'OFSPR',
    Prmg: 'PRMG',
    Prmgr: 'PRMGR',
    Slry: 'SLRY',
    Slryr: 'SLRYR',
    Tdmg: 'TDMG',
    Tdmgr: 'TDMGR',
    Trmp: 'TRMP',
    Trmpr: 'TRMPR',
    Tsmg: 'TSMG',
    Tsmgr: 'TSMGR',
    Vdic: 'VDIC',
    Vdicr: 'VDICR'
} as const;

export type BillableItemModelCodeEnum = typeof BillableItemModelCodeEnum[keyof typeof BillableItemModelCodeEnum];
export const BillableItemModelTypeEnum = {
    Payable: 'Payable',
    Receivable: 'Receivable'
} as const;

export type BillableItemModelTypeEnum = typeof BillableItemModelTypeEnum[keyof typeof BillableItemModelTypeEnum];

/**
 * 
 * @export
 * @interface CaptchaRequestModel
 */
export interface CaptchaRequestModel {
    /**
     * 
     * @type {string}
     * @memberof CaptchaRequestModel
     */
    'captchaToken'?: string;
}
/**
 * 
 * @export
 * @interface CareerHistoryModel
 */
export interface CareerHistoryModel {
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'CompanyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'Description'?: string;
    /**
     * 
     * @type {object}
     * @memberof CareerHistoryModel
     */
    'EndDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof CareerHistoryModel
     */
    'StartDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'JobTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CareerHistoryModel
     */
    'StillWorking'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'EmploymentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'Location'?: string;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'LocationType'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CareerHistoryModel
     */
    'JobSkills'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryModel
     */
    'JobRole'?: string;
}
/**
 * 
 * @export
 * @interface CareerHistoryRequestModel
 */
export interface CareerHistoryRequestModel {
    /**
     * 
     * @type {string}
     * @memberof CareerHistoryRequestModel
     */
    'description'?: string;
    /**
     * 
     * @type {CareerHistoryModel}
     * @memberof CareerHistoryRequestModel
     */
    'careerHistory'?: CareerHistoryModel;
}
/**
 * 
 * @export
 * @interface CareerHistoryResponseModel
 */
export interface CareerHistoryResponseModel {
    /**
     * 
     * @type {Array<CareerHistoryModel>}
     * @memberof CareerHistoryResponseModel
     */
    'CareerHistoryModel'?: Array<CareerHistoryModel>;
    /**
     * 
     * @type {Array<CoreSkillModel>}
     * @memberof CareerHistoryResponseModel
     */
    'NewAddedSkills'?: Array<CoreSkillModel>;
}
/**
 * 
 * @export
 * @interface CertificateModel
 */
export interface CertificateModel {
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'Name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CertificateModel
     */
    'SkillIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'Organization'?: string;
    /**
     * 
     * @type {number}
     * @memberof CertificateModel
     */
    'Year'?: number;
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'CertificateFile'?: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateModel
     */
    'DownloadCertificateUrl'?: string;
    /**
     * 
     * @type {AzureStorageUrl}
     * @memberof CertificateModel
     */
    'UploadCertificateUrl'?: AzureStorageUrl;
}
/**
 * 
 * @export
 * @interface CityModel
 */
export interface CityModel {
    /**
     * 
     * @type {string}
     * @memberof CityModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CityModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CityModel
     */
    'CountryId'?: string;
}
/**
 * 
 * @export
 * @interface ClientAssessmentModel
 */
export interface ClientAssessmentModel {
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'EndTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientAssessmentModel
     */
    'IsRestartable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'Objective'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAssessmentModel
     */
    'PassScore'?: number;
    /**
     * 
     * @type {Array<ClientAssessmentQuestionModel>}
     * @memberof ClientAssessmentModel
     */
    'Questions'?: Array<ClientAssessmentQuestionModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'StartedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'SubmitTime'?: string;
    /**
     * 
     * @type {Array<TagModel>}
     * @memberof ClientAssessmentModel
     */
    'Tags'?: Array<TagModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentModel
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface ClientAssessmentQuestionEvaluationModel
 */
export interface ClientAssessmentQuestionEvaluationModel {
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionEvaluationModel
     */
    'Criteria'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionEvaluationModel
     */
    'Id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAssessmentQuestionEvaluationModel
     */
    'Point'?: number;
}
/**
 * 
 * @export
 * @interface ClientAssessmentQuestionModel
 */
export interface ClientAssessmentQuestionModel {
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Answer'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAssessmentQuestionModel
     */
    'Duration'?: number;
    /**
     * 
     * @type {Array<EditorModel>}
     * @memberof ClientAssessmentQuestionModel
     */
    'Editors'?: Array<EditorModel>;
    /**
     * 
     * @type {Array<ClientAssessmentQuestionEvaluationModel>}
     * @memberof ClientAssessmentQuestionModel
     */
    'Evaluations'?: Array<ClientAssessmentQuestionEvaluationModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Level'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClientAssessmentQuestionModel
     */
    'Order'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Question'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'TalentAnswer'?: string;
    /**
     * 
     * @type {Array<CoreSkillModel>}
     * @memberof ClientAssessmentQuestionModel
     */
    'Technologies'?: Array<CoreSkillModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientAssessmentQuestionModel
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface ClientCreateVMRequest
 */
export interface ClientCreateVMRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ClientCreateVMRequest
     */
    'EnableTimesheetProcessing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'JobRoleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'TmFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'TmLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'TmEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'TmMobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'TmCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentTimeZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentProjectLeadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentPortfolioManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentPublicHolidayZoneId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentHoursPerWeekRadio'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentHoursPerWeek'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentWorkingDays'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateVMRequest
     */
    'CommitmentTo'?: string;
    /**
     * 
     * @type {VirtualDesktopSpec}
     * @memberof ClientCreateVMRequest
     */
    'VirtualDesktopSpec'?: VirtualDesktopSpec;
}
/**
 * 
 * @export
 * @interface ClientGetCommitmentByIdResponseModel
 */
export interface ClientGetCommitmentByIdResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'AdminApproval'?: ClientGetCommitmentByIdResponseModelAdminApprovalEnum;
    /**
     * 
     * @type {Array<CommitmentActionWithAltItem>}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'AllowedActions'?: Array<CommitmentActionWithAltItem>;
    /**
     * 
     * @type {CommitmentActionModel}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'CommitmentActions'?: CommitmentActionModel;
    /**
     * 
     * @type {boolean}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ContractManagement'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ContactVerification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'CustomerApproval'?: ClientGetCommitmentByIdResponseModelCustomerApprovalEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'EndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'IDVerification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'LineManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'LocationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'OfficeLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'OfficeSpaceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'PortfolioManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'PortfolioManagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ProjectLeadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ProjectLeadName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'PublicHolidayZoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'PublicHolidayZoneName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'SalaryCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'Status'?: ClientGetCommitmentByIdResponseModelStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'TeamMemberApproval'?: ClientGetCommitmentByIdResponseModelTeamMemberApprovalEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'TDMId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'TeammemberName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'TimesheetProcessing'?: boolean;
    /**
     * 
     * @type {VirtualDesktopSpec}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'VirtualDesktopSpec'?: VirtualDesktopSpec;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'VmId'?: string;
    /**
     * 
     * @type {Array<ClientGetCommitmentResponseRelatedActions>}
     * @memberof ClientGetCommitmentByIdResponseModel
     */
    'RelatedActions'?: Array<ClientGetCommitmentResponseRelatedActions>;
}

export const ClientGetCommitmentByIdResponseModelAdminApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type ClientGetCommitmentByIdResponseModelAdminApprovalEnum = typeof ClientGetCommitmentByIdResponseModelAdminApprovalEnum[keyof typeof ClientGetCommitmentByIdResponseModelAdminApprovalEnum];
export const ClientGetCommitmentByIdResponseModelCustomerApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type ClientGetCommitmentByIdResponseModelCustomerApprovalEnum = typeof ClientGetCommitmentByIdResponseModelCustomerApprovalEnum[keyof typeof ClientGetCommitmentByIdResponseModelCustomerApprovalEnum];
export const ClientGetCommitmentByIdResponseModelStatusEnum = {
    Active: 'Active',
    Expired: 'Expired',
    AdminPending: 'AdminPending',
    CustomerPending: 'CustomerPending',
    TeammemberPending: 'TeammemberPending',
    AdminRejected: 'AdminRejected',
    CustomerRejected: 'CustomerRejected',
    TeammemberRejected: 'TeammemberRejected',
    Upcoming: 'Upcoming'
} as const;

export type ClientGetCommitmentByIdResponseModelStatusEnum = typeof ClientGetCommitmentByIdResponseModelStatusEnum[keyof typeof ClientGetCommitmentByIdResponseModelStatusEnum];
export const ClientGetCommitmentByIdResponseModelTeamMemberApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type ClientGetCommitmentByIdResponseModelTeamMemberApprovalEnum = typeof ClientGetCommitmentByIdResponseModelTeamMemberApprovalEnum[keyof typeof ClientGetCommitmentByIdResponseModelTeamMemberApprovalEnum];

/**
 * 
 * @export
 * @interface ClientGetCommitmentResponseCommitmentDetail
 */
export interface ClientGetCommitmentResponseCommitmentDetail {
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'AdminApproval'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'CustomerApproval'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'EndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'LocationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'PortfolioManagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'ProjectLeadName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'PublicHolidayZoneName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'Status'?: ClientGetCommitmentResponseCommitmentDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseCommitmentDetail
     */
    'TeamMemberApproval'?: string;
}

export const ClientGetCommitmentResponseCommitmentDetailStatusEnum = {
    Active: 'Active',
    Expired: 'Expired',
    AdminPending: 'AdminPending',
    CustomerPending: 'CustomerPending',
    TeammemberPending: 'TeammemberPending',
    AdminRejected: 'AdminRejected',
    CustomerRejected: 'CustomerRejected',
    TeammemberRejected: 'TeammemberRejected',
    Upcoming: 'Upcoming'
} as const;

export type ClientGetCommitmentResponseCommitmentDetailStatusEnum = typeof ClientGetCommitmentResponseCommitmentDetailStatusEnum[keyof typeof ClientGetCommitmentResponseCommitmentDetailStatusEnum];

/**
 * 
 * @export
 * @interface ClientGetCommitmentResponseRelatedActions
 */
export interface ClientGetCommitmentResponseRelatedActions {
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'CreatedAt'?: string;
    /**
     * 
     * @type {CommitmentActionDetails}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'Details'?: CommitmentActionDetails;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'DisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'EffectiveDate'?: string;
    /**
     * 
     * @type {ClientGetCommitmentResponseCommitmentDetail}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'FromCommitmentDetail'?: ClientGetCommitmentResponseCommitmentDetail;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'FromCommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'Status'?: ClientGetCommitmentResponseRelatedActionsStatusEnum;
    /**
     * 
     * @type {ClientGetCommitmentResponseCommitmentDetail}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'ToCommitmentDetail'?: ClientGetCommitmentResponseCommitmentDetail;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'ToCommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'Type'?: ClientGetCommitmentResponseRelatedActionsTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientGetCommitmentResponseRelatedActions
     */
    'UpdatedAt'?: string;
}

export const ClientGetCommitmentResponseRelatedActionsStatusEnum = {
    Pending: 'Pending',
    Applied: 'Applied'
} as const;

export type ClientGetCommitmentResponseRelatedActionsStatusEnum = typeof ClientGetCommitmentResponseRelatedActionsStatusEnum[keyof typeof ClientGetCommitmentResponseRelatedActionsStatusEnum];
export const ClientGetCommitmentResponseRelatedActionsTypeEnum = {
    CustomerAddVirtualDesktop: 'CustomerAddVirtualDesktop',
    CustomerModifyVirtualDesktop: 'CustomerModifyVirtualDesktop',
    CustomerTerminateVirtualDesktop: 'CustomerTerminateVirtualDesktop',
    CustomerVdSupport: 'CustomerVdSupport',
    CustomerExtendContract: 'CustomerExtendContract',
    CustomerTerminateContract: 'CustomerTerminateContract',
    CustomerTransferVirtualDesktop: 'CustomerTransferVirtualDesktop'
} as const;

export type ClientGetCommitmentResponseRelatedActionsTypeEnum = typeof ClientGetCommitmentResponseRelatedActionsTypeEnum[keyof typeof ClientGetCommitmentResponseRelatedActionsTypeEnum];

/**
 * 
 * @export
 * @interface ClientGetTeammemberEducationModel
 */
export interface ClientGetTeammemberEducationModel {
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberEducationModel
     */
    'Degree'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberEducationModel
     */
    'StudyField'?: string;
}
/**
 * 
 * @export
 * @interface ClientGetTeammemberJobTitleModel
 */
export interface ClientGetTeammemberJobTitleModel {
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberJobTitleModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberJobTitleModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface ClientGetTeammemberProfessionalDetailModel
 */
export interface ClientGetTeammemberProfessionalDetailModel {
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberProfessionalDetailModel
     */
    'Personality'?: string;
    /**
     * 
     * @type {ClientGetTeammemberJobTitleModel}
     * @memberof ClientGetTeammemberProfessionalDetailModel
     */
    'JobTitle'?: ClientGetTeammemberJobTitleModel;
}
/**
 * 
 * @export
 * @interface ClientGetTeammemberResponseModel
 */
export interface ClientGetTeammemberResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'BirthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'CareerHistoryDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'CodeClanCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'Description'?: string;
    /**
     * 
     * @type {Array<ClientGetTeammemberEducationModel>}
     * @memberof ClientGetTeammemberResponseModel
     */
    'Educations'?: Array<ClientGetTeammemberEducationModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {Array<ClientGetTeammemberSkillModel>}
     * @memberof ClientGetTeammemberResponseModel
     */
    'Skills'?: Array<ClientGetTeammemberSkillModel>;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberResponseModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {ClientGetTeammemberProfessionalDetailModel}
     * @memberof ClientGetTeammemberResponseModel
     */
    'ProfessionalDetail'?: ClientGetTeammemberProfessionalDetailModel;
}
/**
 * 
 * @export
 * @interface ClientGetTeammemberSkillModel
 */
export interface ClientGetTeammemberSkillModel {
    /**
     * 
     * @type {boolean}
     * @memberof ClientGetTeammemberSkillModel
     */
    'IsTopSkill'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientGetTeammemberSkillModel
     */
    'SkillId'?: string;
}
/**
 * 
 * @export
 * @interface ClientInviteTeammemberRequest
 */
export interface ClientInviteTeammemberRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientInviteTeammemberRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInviteTeammemberRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInviteTeammemberRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInviteTeammemberRequest
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientInviteTeammemberRequest
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface ClientProjectWithDetailsResponseModel
 */
export interface ClientProjectWithDetailsResponseModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientProjectWithDetailsResponseModel
     */
    'Epics'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectWithDetailsResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectWithDetailsResponseModel
     */
    'Name'?: string;
    /**
     * 
     * @type {Array<ProjectPositionResponseModel>}
     * @memberof ClientProjectWithDetailsResponseModel
     */
    'Positions'?: Array<ProjectPositionResponseModel>;
    /**
     * 
     * @type {Array<TeammemberWithVmDetails>}
     * @memberof ClientProjectWithDetailsResponseModel
     */
    'Teammembers'?: Array<TeammemberWithVmDetails>;
}
/**
 * 
 * @export
 * @interface ClientSearchTeammemberResponseModel
 */
export interface ClientSearchTeammemberResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ClientSearchTeammemberResponseModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchTeammemberResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchTeammemberResponseModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchTeammemberResponseModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSearchTeammemberResponseModel
     */
    'SpecificTitle'?: string;
}
/**
 * 
 * @export
 * @interface ClientTimesheetReactionRequest
 */
export interface ClientTimesheetReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientTimesheetReactionRequest
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTimesheetReactionRequest
     */
    'creatorUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTimesheetReactionRequest
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTimesheetReactionRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTimesheetReactionRequest
     */
    'timesheetId'?: string;
}
/**
 * 
 * @export
 * @interface ClientValidateTeammemberResponseModel
 */
export interface ClientValidateTeammemberResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ClientValidateTeammemberResponseModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientValidateTeammemberResponseModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientValidateTeammemberResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientValidateTeammemberResponseModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientValidateTeammemberResponseModel
     */
    'Mobile'?: string;
}
/**
 * 
 * @export
 * @interface ClientVmSupportRequest
 */
export interface ClientVmSupportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientVmSupportRequest
     */
    'AttachmentNames'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientVmSupportRequest
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientVmSupportRequest
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentActionDetails
 */
export interface CommitmentActionDetails {
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionDetails
     */
    'ExtendContractDate'?: string;
    /**
     * 
     * @type {CommitmentActionVirtualDesktopDetails}
     * @memberof CommitmentActionDetails
     */
    'VirtualDesktop'?: CommitmentActionVirtualDesktopDetails;
    /**
     * 
     * @type {CommitmentActionTerminateContractDetails}
     * @memberof CommitmentActionDetails
     */
    'TerminateContract'?: CommitmentActionTerminateContractDetails;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionDetails
     */
    'TransferVirtualDesktopId'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentActionItem
 */
export interface CommitmentActionItem {
    /**
     * 
     * @type {CommitmentActionDetails}
     * @memberof CommitmentActionItem
     */
    'Details'?: CommitmentActionDetails;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionItem
     */
    'DisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionItem
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionItem
     */
    'Type'?: CommitmentActionItemTypeEnum;
}

export const CommitmentActionItemTypeEnum = {
    CustomerAddVirtualDesktop: 'CustomerAddVirtualDesktop',
    CustomerModifyVirtualDesktop: 'CustomerModifyVirtualDesktop',
    CustomerTerminateVirtualDesktop: 'CustomerTerminateVirtualDesktop',
    CustomerVdSupport: 'CustomerVdSupport',
    CustomerExtendContract: 'CustomerExtendContract',
    CustomerTerminateContract: 'CustomerTerminateContract',
    CustomerTransferVirtualDesktop: 'CustomerTransferVirtualDesktop'
} as const;

export type CommitmentActionItemTypeEnum = typeof CommitmentActionItemTypeEnum[keyof typeof CommitmentActionItemTypeEnum];

/**
 * 
 * @export
 * @interface CommitmentActionModel
 */
export interface CommitmentActionModel {
    /**
     * 
     * @type {Array<CommitmentActionItem>}
     * @memberof CommitmentActionModel
     */
    'ActionItems'?: Array<CommitmentActionItem>;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionModel
     */
    'EffectiveDate'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentActionTerminateContractDetails
 */
export interface CommitmentActionTerminateContractDetails {
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentActionTerminateContractDetails
     */
    'TransferVirtualDesktop'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionTerminateContractDetails
     */
    'ToCommitmentId'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentActionVirtualDesktopDetails
 */
export interface CommitmentActionVirtualDesktopDetails {
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'AdditionalSecurityBL'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'AdditionalSecurityNG'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Cpu'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Disk'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Level'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Location'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'OperatingSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Policy'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentActionVirtualDesktopDetails
     */
    'Ram'?: number;
}
/**
 * 
 * @export
 * @interface CommitmentActionWithAltItem
 */
export interface CommitmentActionWithAltItem {
    /**
     * 
     * @type {number}
     * @memberof CommitmentActionWithAltItem
     */
    'Alt'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionWithAltItem
     */
    'DisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentActionWithAltItem
     */
    'Type'?: CommitmentActionWithAltItemTypeEnum;
}

export const CommitmentActionWithAltItemTypeEnum = {
    CustomerAddVirtualDesktop: 'CustomerAddVirtualDesktop',
    CustomerModifyVirtualDesktop: 'CustomerModifyVirtualDesktop',
    CustomerTerminateVirtualDesktop: 'CustomerTerminateVirtualDesktop',
    CustomerVdSupport: 'CustomerVdSupport',
    CustomerExtendContract: 'CustomerExtendContract',
    CustomerTerminateContract: 'CustomerTerminateContract',
    CustomerTransferVirtualDesktop: 'CustomerTransferVirtualDesktop'
} as const;

export type CommitmentActionWithAltItemTypeEnum = typeof CommitmentActionWithAltItemTypeEnum[keyof typeof CommitmentActionWithAltItemTypeEnum];

/**
 * 
 * @export
 * @interface CommitmentBillableItemModel
 */
export interface CommitmentBillableItemModel {
    /**
     * 
     * @type {string}
     * @memberof CommitmentBillableItemModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentBillableItemModel
     */
    'billableItemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentBillableItemModel
     */
    'commitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentBillableItemModel
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentBillableItemModel
     */
    'fee'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentBillableItemModel
     */
    'interval'?: string;
    /**
     * 
     * @type {CommitmentModel}
     * @memberof CommitmentBillableItemModel
     */
    'commitment'?: CommitmentModel;
    /**
     * 
     * @type {BillableItemMin}
     * @memberof CommitmentBillableItemModel
     */
    'billableItem'?: BillableItemMin;
    /**
     * 
     * @type {Array<CommitmentChargeModel>}
     * @memberof CommitmentBillableItemModel
     */
    'commitmentCharges'?: Array<CommitmentChargeModel>;
    /**
     * 
     * @type {Array<TimesheetModel>}
     * @memberof CommitmentBillableItemModel
     */
    'timesheets'?: Array<TimesheetModel>;
}
/**
 * 
 * @export
 * @interface CommitmentChargeModel
 */
export interface CommitmentChargeModel {
    /**
     * 
     * @type {string}
     * @memberof CommitmentChargeModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentChargeModel
     */
    'commitmentBillableItemId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentChargeModel
     */
    'fee'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentChargeModel
     */
    'from'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentChargeModel
     */
    'locked'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CommitmentChargeModel
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentChargeModel
     */
    'to'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentChargeModel
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CommitmentMinModel
 */
export interface CommitmentMinModel {
    /**
     * 
     * @type {string}
     * @memberof CommitmentMinModel
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentMinModel
     */
    'HoursPerWeekMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitmentMinModel
     */
    'HoursPerWeekMin'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentMinModel
     */
    'Name'?: string;
    /**
     * 
     * @type {TeamMemberOfCommitmentModel}
     * @memberof CommitmentMinModel
     */
    'TeamMember'?: TeamMemberOfCommitmentModel;
}
/**
 * 
 * @export
 * @interface CommitmentModel
 */
export interface CommitmentModel {
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'AdminApproval'?: CommitmentModelAdminApprovalEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'ContactVerification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'ContractManagement'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'CustomerApproval'?: CommitmentModelCustomerApprovalEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'DaysOfWeekInOffice'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'EndWorkClock'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'IDVerification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'LocationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'OfficeDaysPerWeek'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'OfficeLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'OfficeLocationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'OfficeSpaceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'OfficeSpaceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'SalaryCurrency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'SalaryMonthly'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'StartWorkClock'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'TeamMemberApproval'?: CommitmentModelTeamMemberApprovalEnum;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'TimeZone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'TimesheetProcessing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'PublicHolidayZoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'PublicHolidayZoneName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'CustomerIds'?: Array<string>;
    /**
     * 
     * @type {Array<CustomerOfCommitmentModel>}
     * @memberof CommitmentModel
     */
    'Customers'?: Array<CustomerOfCommitmentModel>;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'EndDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'FeeBase'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'FeeCoef'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'HoursPerWeekMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'HoursPerWeekMin'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'HoursPerWeekRadio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'PositionId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'ProjectIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'SeniorityLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'TeamMemberIds'?: Array<string>;
    /**
     * 
     * @type {Array<TeamMemberOfCommitmentModel>}
     * @memberof CommitmentModel
     */
    'TeamMembers'?: Array<TeamMemberOfCommitmentModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'WokingDays'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'LineManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'LineManagerName'?: string;
    /**
     * 
     * @type {CommitmentTeammemberWithPhotoModel}
     * @memberof CommitmentModel
     */
    'LineManagerDetail'?: CommitmentTeammemberWithPhotoModel;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'TDMId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'ProjectLeadId'?: string;
    /**
     * 
     * @type {CommitmentTeammemberWithPhotoModel}
     * @memberof CommitmentModel
     */
    'ProjectLeadDetail'?: CommitmentTeammemberWithPhotoModel;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'PortfolioManagerId'?: string;
    /**
     * 
     * @type {CommitmentTeammemberWithPhotoModel}
     * @memberof CommitmentModel
     */
    'PortfolioManagerDetail'?: CommitmentTeammemberWithPhotoModel;
    /**
     * 
     * @type {RateModel}
     * @memberof CommitmentModel
     */
    'Rate'?: RateModel;
    /**
     * 
     * @type {boolean}
     * @memberof CommitmentModel
     */
    'HasTimesheet'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'ProjectNames'?: Array<string>;
    /**
     * 
     * @type {Array<ProjectModel>}
     * @memberof CommitmentModel
     */
    'ProjectDetails'?: Array<ProjectModel>;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'StatusV2'?: CommitmentModelStatusV2Enum;
    /**
     * 
     * @type {number}
     * @memberof CommitmentModel
     */
    'VirtualDesktopRate'?: number;
    /**
     * 
     * @type {VirtualDesktopSpec}
     * @memberof CommitmentModel
     */
    'VirtualDesktopSpec'?: VirtualDesktopSpec;
    /**
     * 
     * @type {string}
     * @memberof CommitmentModel
     */
    'VmId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommitmentModel
     */
    'Repositories'?: Array<string>;
}

export const CommitmentModelAdminApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type CommitmentModelAdminApprovalEnum = typeof CommitmentModelAdminApprovalEnum[keyof typeof CommitmentModelAdminApprovalEnum];
export const CommitmentModelCustomerApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type CommitmentModelCustomerApprovalEnum = typeof CommitmentModelCustomerApprovalEnum[keyof typeof CommitmentModelCustomerApprovalEnum];
export const CommitmentModelTeamMemberApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type CommitmentModelTeamMemberApprovalEnum = typeof CommitmentModelTeamMemberApprovalEnum[keyof typeof CommitmentModelTeamMemberApprovalEnum];
export const CommitmentModelStatusV2Enum = {
    Active: 'Active',
    Expired: 'Expired',
    AdminPending: 'AdminPending',
    CustomerPending: 'CustomerPending',
    TeammemberPending: 'TeammemberPending',
    AdminRejected: 'AdminRejected',
    CustomerRejected: 'CustomerRejected',
    TeammemberRejected: 'TeammemberRejected',
    Upcoming: 'Upcoming'
} as const;

export type CommitmentModelStatusV2Enum = typeof CommitmentModelStatusV2Enum[keyof typeof CommitmentModelStatusV2Enum];

/**
 * 
 * @export
 * @interface CommitmentOfPayRunItem
 */
export interface CommitmentOfPayRunItem {
    /**
     * 
     * @type {string}
     * @memberof CommitmentOfPayRunItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentOfPayRunItem
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentTeammemberWithPhotoModel
 */
export interface CommitmentTeammemberWithPhotoModel {
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommitmentTeammemberWithPhotoModel
     */
    'NickName'?: string;
}
/**
 * 
 * @export
 * @interface CommitmentWithRelationsModel
 */
export interface CommitmentWithRelationsModel {
    /**
     * 
     * @type {Array<CommitmentMinModel>}
     * @memberof CommitmentWithRelationsModel
     */
    'commitments'?: Array<CommitmentMinModel>;
    /**
     * 
     * @type {Array<TimesheetModel>}
     * @memberof CommitmentWithRelationsModel
     */
    'timesheets'?: Array<TimesheetModel>;
    /**
     * 
     * @type {Array<LeaveModel>}
     * @memberof CommitmentWithRelationsModel
     */
    'leaves'?: Array<LeaveModel>;
}
/**
 * 
 * @export
 * @interface ContactResponseModel
 */
export interface ContactResponseModel {
    /**
     * 
     * @type {Array<AddresssModel>}
     * @memberof ContactResponseModel
     */
    'Addresses'?: Array<AddresssModel>;
    /**
     * 
     * @type {Array<PhoneModel>}
     * @memberof ContactResponseModel
     */
    'PhoneNumbers'?: Array<PhoneModel>;
}
/**
 * 
 * @export
 * @interface ContactUsRequestModel
 */
export interface ContactUsRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ContactUsRequestModel
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsRequestModel
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsRequestModel
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsRequestModel
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ContactVerificationRequest
 */
export interface ContactVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactVerificationRequest
     */
    'verificationCode'?: string;
}
/**
 * 
 * @export
 * @interface ContributionReportVM
 */
export interface ContributionReportVM {
    /**
     * 
     * @type {Array<CustomerModel>}
     * @memberof ContributionReportVM
     */
    'Customers'?: Array<CustomerModel>;
    /**
     * 
     * @type {Array<CommitmentModel>}
     * @memberof ContributionReportVM
     */
    'Commitments'?: Array<CommitmentModel>;
    /**
     * 
     * @type {Array<AuthorModel>}
     * @memberof ContributionReportVM
     */
    'Authors'?: Array<AuthorModel>;
}
/**
 * 
 * @export
 * @interface CoreSkillFullModel
 */
export interface CoreSkillFullModel {
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'CreatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CoreSkillFullModel
     */
    'IsRequested'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'UpdatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillFullModel
     */
    'Value'?: string;
}
/**
 * 
 * @export
 * @interface CoreSkillModel
 */
export interface CoreSkillModel {
    /**
     * 
     * @type {string}
     * @memberof CoreSkillModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillModel
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof CoreSkillModel
     */
    'Value'?: string;
}
/**
 * 
 * @export
 * @interface CostAnalysisReportResponseModel
 */
export interface CostAnalysisReportResponseModel {
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemCommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemFee'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemQuantity'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'BillableItemTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'CustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'CustomerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CostAnalysisReportResponseModel
     */
    'TeammemberName'?: string;
}
/**
 * 
 * @export
 * @interface CountryModel
 */
export interface CountryModel {
    /**
     * 
     * @type {string}
     * @memberof CountryModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface CourseDependecyModel
 */
export interface CourseDependecyModel {
    /**
     * 
     * @type {string}
     * @memberof CourseDependecyModel
     */
    'DependencyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseDependecyModel
     */
    'Text'?: string;
}
/**
 * 
 * @export
 * @interface CourseModel
 */
export interface CourseModel {
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Author'?: string;
    /**
     * 
     * @type {Array<CourseDependecyModel>}
     * @memberof CourseModel
     */
    'Dependencies'?: Array<CourseDependecyModel>;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CourseModel
     */
    'Duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Image'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'ImageDownloadUrl'?: string;
    /**
     * 
     * @type {AzureStorageUrl}
     * @memberof CourseModel
     */
    'ImageUploadUrl'?: AzureStorageUrl;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Level'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CourseModel
     */
    'Skills'?: Array<string>;
    /**
     * 
     * @type {Array<CourseStepsModel>}
     * @memberof CourseModel
     */
    'Steps'?: Array<CourseStepsModel>;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Summary'?: string;
    /**
     * 
     * @type {Array<TagModel>}
     * @memberof CourseModel
     */
    'Tags'?: Array<TagModel>;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseModel
     */
    'UpdatedAt'?: string;
}
/**
 * 
 * @export
 * @interface CourseStepsModel
 */
export interface CourseStepsModel {
    /**
     * 
     * @type {ClientAssessmentModel}
     * @memberof CourseStepsModel
     */
    'AssessmentDetails'?: ClientAssessmentModel;
    /**
     * 
     * @type {string}
     * @memberof CourseStepsModel
     */
    'Content'?: string;
    /**
     * 
     * @type {number}
     * @memberof CourseStepsModel
     */
    'Duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof CourseStepsModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CourseStepsModel
     */
    'IsCompeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CourseStepsModel
     */
    'Order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CourseStepsModel
     */
    'ShowEditor'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseStepsModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CourseStepsModel
     */
    'Type'?: string;
}
/**
 * 
 * @export
 * @interface CryptoCurrencyModel
 */
export interface CryptoCurrencyModel {
    /**
     * 
     * @type {string}
     * @memberof CryptoCurrencyModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CryptoCurrencyModel
     */
    'WalletAddress'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CryptoCurrencyModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CryptoCurrencyModel
     */
    'CreatedAt'?: string;
}
/**
 * 
 * @export
 * @interface CustomerInvoiceItemVM
 */
export interface CustomerInvoiceItemVM {
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'chargeId'?: string;
    /**
     * 
     * @type {BillableItemMin}
     * @memberof CustomerInvoiceItemVM
     */
    'billableItem'?: BillableItemMin;
    /**
     * 
     * @type {CommitmentMinModel}
     * @memberof CustomerInvoiceItemVM
     */
    'commitment'?: CommitmentMinModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'commitmentBillableItemId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceItemVM
     */
    'fee'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'from'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerInvoiceItemVM
     */
    'locked'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceItemVM
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceItemVM
     */
    'to'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceItemVM
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CustomerInvoicePaymentVM
 */
export interface CustomerInvoicePaymentVM {
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoicePaymentVM
     */
    'paymentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoicePaymentVM
     */
    'paymentRefNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoicePaymentVM
     */
    'audTotalPay'?: number;
}
/**
 * 
 * @export
 * @interface CustomerInvoiceVM
 */
export interface CustomerInvoiceVM {
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'id'?: string;
    /**
     * 
     * @type {CustomerOfCommitmentModel}
     * @memberof CustomerInvoiceVM
     */
    'customer'?: CustomerOfCommitmentModel;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'dueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoiceVM
     */
    'toDate'?: string;
    /**
     * 
     * @type {Array<CustomerInvoiceItemVM>}
     * @memberof CustomerInvoiceVM
     */
    'items'?: Array<CustomerInvoiceItemVM>;
    /**
     * 
     * @type {Array<CustomerInvoicePaymentVM>}
     * @memberof CustomerInvoiceVM
     */
    'payments'?: Array<CustomerInvoicePaymentVM>;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceVM
     */
    'calculatedAUDTotalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceVM
     */
    'audTotalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoiceVM
     */
    'totalPaymentAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerInvoiceVM
     */
    'adminApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerInvoiceVM
     */
    'customerApproved'?: boolean;
}
/**
 * 
 * @export
 * @interface CustomerModel
 */
export interface CustomerModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerModel
     */
    'Email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerModel
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerModel
     */
    'FullName'?: string;
}
/**
 * 
 * @export
 * @interface CustomerOfCommitmentModel
 */
export interface CustomerOfCommitmentModel {
    /**
     * 
     * @type {string}
     * @memberof CustomerOfCommitmentModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOfCommitmentModel
     */
    'CuFullName'?: string;
}
/**
 * 
 * @export
 * @interface DailyTotalWork
 */
export interface DailyTotalWork {
    /**
     * 
     * @type {string}
     * @memberof DailyTotalWork
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof DailyTotalWork
     */
    'totalSecounds'?: number;
}
/**
 * 
 * @export
 * @interface DashboardRequestModel
 */
export interface DashboardRequestModel {
    /**
     * 
     * @type {string}
     * @memberof DashboardRequestModel
     */
    'teammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRequestModel
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRequestModel
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface DateRangeRequestModel
 */
export interface DateRangeRequestModel {
    /**
     * 
     * @type {string}
     * @memberof DateRangeRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateRangeRequestModel
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface DetailsModel
 */
export interface DetailsModel {
    /**
     * 
     * @type {string}
     * @memberof DetailsModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsModel
     */
    'RoleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsModel
     */
    'Type'?: string;
}
/**
 * 
 * @export
 * @interface EditorModel
 */
export interface EditorModel {
    /**
     * 
     * @type {string}
     * @memberof EditorModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditorModel
     */
    'Value'?: string;
}
/**
 * 
 * @export
 * @interface EducationModel
 */
export interface EducationModel {
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'University'?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'Degree'?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationModel
     */
    'StudyField'?: string;
    /**
     * 
     * @type {object}
     * @memberof EducationModel
     */
    'EndDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof EducationModel
     */
    'StartDate'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof EducationModel
     */
    'StillStudying'?: boolean;
}
/**
 * 
 * @export
 * @interface EntitySummaryModel
 */
export interface EntitySummaryModel {
    /**
     * 
     * @type {string}
     * @memberof EntitySummaryModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EntitySummaryModel
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface EpicItemModel
 */
export interface EpicItemModel {
    /**
     * 
     * @type {string}
     * @memberof EpicItemModel
     */
    'Name'?: string;
    /**
     * 
     * @type {object}
     * @memberof EpicItemModel
     */
    'CreatedDate'?: object;
}
/**
 * 
 * @export
 * @interface EpicModel
 */
export interface EpicModel {
    /**
     * 
     * @type {string}
     * @memberof EpicModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EpicModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {Array<EpicItemModel>}
     * @memberof EpicModel
     */
    'Items'?: Array<EpicItemModel>;
}
/**
 * 
 * @export
 * @interface EpicReport
 */
export interface EpicReport {
    /**
     * 
     * @type {string}
     * @memberof EpicReport
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof EpicReport
     */
    'netEffort'?: number;
}
/**
 * 
 * @export
 * @interface EpicRequestModel
 */
export interface EpicRequestModel {
    /**
     * 
     * @type {string}
     * @memberof EpicRequestModel
     */
    'EpicTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof EpicRequestModel
     */
    'ProjectId'?: string;
}
/**
 * 
 * @export
 * @interface ExpenseAnalysisRequestModel
 */
export interface ExpenseAnalysisRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ExpenseAnalysisRequestModel
     */
    'teammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseAnalysisRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpenseAnalysisRequestModel
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface ExpenseAnalysisVM
 */
export interface ExpenseAnalysisVM {
    /**
     * 
     * @type {Array<PaymentUnit>}
     * @memberof ExpenseAnalysisVM
     */
    'TotalPaymentUnit'?: Array<PaymentUnit>;
    /**
     * 
     * @type {Array<PayrunDetailByTeammember>}
     * @memberof ExpenseAnalysisVM
     */
    'PayrunDetailByTeammember'?: Array<PayrunDetailByTeammember>;
}
/**
 * 
 * @export
 * @interface FindAssessmentRequestModel
 */
export interface FindAssessmentRequestModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof FindAssessmentRequestModel
     */
    'duration'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAssessmentRequestModel
     */
    'level'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAssessmentRequestModel
     */
    'tag'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindAssessmentRequestModel
     */
    'technology'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FindAssessmentRequestModel
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface FindCoursesRequestModel
 */
export interface FindCoursesRequestModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof FindCoursesRequestModel
     */
    'duration'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindCoursesRequestModel
     */
    'level'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FindCoursesRequestModel
     */
    'skill'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FindCoursesRequestModel
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface FindRoadMapsRequestModel
 */
export interface FindRoadMapsRequestModel {
    /**
     * 
     * @type {string}
     * @memberof FindRoadMapsRequestModel
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface FirebaseAuthLink
 */
export interface FirebaseAuthLink {
    /**
     * 
     * @type {string}
     * @memberof FirebaseAuthLink
     */
    'idToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirebaseAuthLink
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof FirebaseAuthLink
     */
    'expiresIn'?: number;
    /**
     * 
     * @type {string}
     * @memberof FirebaseAuthLink
     */
    'created'?: string;
    /**
     * 
     * @type {User}
     * @memberof FirebaseAuthLink
     */
    'user'?: User;
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequestModel
 */
export interface ForgotPasswordRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequestModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequestModel
     */
    'callbackUrl': string;
}
/**
 * 
 * @export
 * @interface GetProjectWithDetailsRequestModel
 */
export interface GetProjectWithDetailsRequestModel {
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithDetailsRequestModel
     */
    'startDate'?: string;
}
/**
 * 
 * @export
 * @interface GetReviewCommitmentModel
 */
export interface GetReviewCommitmentModel {
    /**
     * 
     * @type {CommitmentActionModel}
     * @memberof GetReviewCommitmentModel
     */
    'Actions'?: CommitmentActionModel;
    /**
     * 
     * @type {CommitmentModel}
     * @memberof GetReviewCommitmentModel
     */
    'FromCommitment'?: CommitmentModel;
    /**
     * 
     * @type {CommitmentModel}
     * @memberof GetReviewCommitmentModel
     */
    'ToCommitment'?: CommitmentModel;
}
/**
 * 
 * @export
 * @interface GitConnectionIssues
 */
export interface GitConnectionIssues {
    /**
     * 
     * @type {string}
     * @memberof GitConnectionIssues
     */
    'repositoryHttpsLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof GitConnectionIssues
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GitConnectionIssues
     */
    'errorMessage'?: string;
}
/**
 * 
 * @export
 * @interface GrantRevokeAccessModel
 */
export interface GrantRevokeAccessModel {
    /**
     * 
     * @type {string}
     * @memberof GrantRevokeAccessModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantRevokeAccessModel
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface HolidayDateModel
 */
export interface HolidayDateModel {
    /**
     * 
     * @type {string}
     * @memberof HolidayDateModel
     */
    'Title'?: string;
    /**
     * 
     * @type {object}
     * @memberof HolidayDateModel
     */
    'Date'?: object;
}
/**
 * 
 * @export
 * @interface HrCommitmentsReportRequestModel
 */
export interface HrCommitmentsReportRequestModel {
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportRequestModel
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportRequestModel
     */
    'selectedCustomer'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportRequestModel
     */
    'selectedCommitment'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportRequestModel
     */
    'selectedTeammember'?: string;
}
/**
 * 
 * @export
 * @interface HrCommitmentsReportVM
 */
export interface HrCommitmentsReportVM {
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'TeammemberName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'CustomerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'CustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'CommitmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HrCommitmentsReportVM
     */
    'CommitmentType'?: string;
    /**
     * 
     * @type {number}
     * @memberof HrCommitmentsReportVM
     */
    'CommitmentMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof HrCommitmentsReportVM
     */
    'CommitmentMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof HrCommitmentsReportVM
     */
    'TotalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof HrCommitmentsReportVM
     */
    'Adjustment'?: number;
}
/**
 * 
 * @export
 * @interface IUserInfo
 */
export interface IUserInfo {
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'uid'?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof IUserInfo
     */
    'providerId'?: string;
}
/**
 * 
 * @export
 * @interface IdentityGetStatusResponseModel
 */
export interface IdentityGetStatusResponseModel {
    /**
     * 
     * @type {number}
     * @memberof IdentityGetStatusResponseModel
     */
    'imageType'?: IdentityGetStatusResponseModelImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IdentityGetStatusResponseModel
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityGetStatusResponseModel
     */
    'isVerified'?: boolean;
}

export const IdentityGetStatusResponseModelImageTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type IdentityGetStatusResponseModelImageTypeEnum = typeof IdentityGetStatusResponseModelImageTypeEnum[keyof typeof IdentityGetStatusResponseModelImageTypeEnum];

/**
 * 
 * @export
 * @interface IdentityImageTypeRequestModel
 */
export interface IdentityImageTypeRequestModel {
    /**
     * 
     * @type {number}
     * @memberof IdentityImageTypeRequestModel
     */
    'imageType'?: IdentityImageTypeRequestModelImageTypeEnum;
}

export const IdentityImageTypeRequestModelImageTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type IdentityImageTypeRequestModelImageTypeEnum = typeof IdentityImageTypeRequestModelImageTypeEnum[keyof typeof IdentityImageTypeRequestModelImageTypeEnum];

/**
 * 
 * @export
 * @interface IdentityImageUrlRequestModel
 */
export interface IdentityImageUrlRequestModel {
    /**
     * 
     * @type {number}
     * @memberof IdentityImageUrlRequestModel
     */
    'imageType'?: IdentityImageUrlRequestModelImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IdentityImageUrlRequestModel
     */
    'url'?: string;
}

export const IdentityImageUrlRequestModelImageTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type IdentityImageUrlRequestModelImageTypeEnum = typeof IdentityImageUrlRequestModelImageTypeEnum[keyof typeof IdentityImageUrlRequestModelImageTypeEnum];

/**
 * 
 * @export
 * @interface IdentityImageUrlsResponseModel
 */
export interface IdentityImageUrlsResponseModel {
    /**
     * 
     * @type {string}
     * @memberof IdentityImageUrlsResponseModel
     */
    'faceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityImageUrlsResponseModel
     */
    'signatureUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityImageUrlsResponseModel
     */
    'passportUrl'?: string;
}
/**
 * 
 * @export
 * @interface IpLocationCountryFlagModel
 */
export interface IpLocationCountryFlagModel {
    /**
     * 
     * @type {string}
     * @memberof IpLocationCountryFlagModel
     */
    'emojitwo'?: string;
}
/**
 * 
 * @export
 * @interface IpLocationCountryModel
 */
export interface IpLocationCountryModel {
    /**
     * 
     * @type {string}
     * @memberof IpLocationCountryModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IpLocationCountryModel
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof IpLocationCountryModel
     */
    'capital'?: string;
    /**
     * 
     * @type {IpLocationCountryFlagModel}
     * @memberof IpLocationCountryModel
     */
    'flag'?: IpLocationCountryFlagModel;
}
/**
 * 
 * @export
 * @interface IpLocationModel
 */
export interface IpLocationModel {
    /**
     * 
     * @type {IpLocationCountryModel}
     * @memberof IpLocationModel
     */
    'country'?: IpLocationCountryModel;
    /**
     * 
     * @type {IpLocationRegionModel}
     * @memberof IpLocationModel
     */
    'region'?: IpLocationRegionModel;
    /**
     * 
     * @type {string}
     * @memberof IpLocationModel
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface IpLocationRegionModel
 */
export interface IpLocationRegionModel {
    /**
     * 
     * @type {string}
     * @memberof IpLocationRegionModel
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface IpToLocationResponseModel
 */
export interface IpToLocationResponseModel {
    /**
     * 
     * @type {string}
     * @memberof IpToLocationResponseModel
     */
    'ip'?: string;
    /**
     * 
     * @type {IpLocationModel}
     * @memberof IpToLocationResponseModel
     */
    'location'?: IpLocationModel;
}
/**
 * 
 * @export
 * @interface JobPreferencesModel
 */
export interface JobPreferencesModel {
    /**
     * 
     * @type {number}
     * @memberof JobPreferencesModel
     */
    'Amount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPreferencesModel
     */
    'EmploymentType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobPreferencesModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JobPreferencesModel
     */
    'IsNegotiable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPreferencesModel
     */
    'PositionExperienceYear'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPreferencesModel
     */
    'PreferredLocation'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobPreferencesModel
     */
    'SeiorityLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobPreferencesModel
     */
    'WorkingPosition'?: string;
}
/**
 * 
 * @export
 * @interface LanguageSkillModel
 */
export interface LanguageSkillModel {
    /**
     * 
     * @type {string}
     * @memberof LanguageSkillModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageSkillModel
     */
    'Language'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageSkillModel
     */
    'Level'?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageSkillModel
     */
    'Description'?: string;
}
/**
 * 
 * @export
 * @interface LeaveDetailResponseModel
 */
export interface LeaveDetailResponseModel {
    /**
     * 
     * @type {string}
     * @memberof LeaveDetailResponseModel
     */
    'id'?: string;
    /**
     * 
     * @type {LeaveTeammember}
     * @memberof LeaveDetailResponseModel
     */
    'Teammember'?: LeaveTeammember;
    /**
     * 
     * @type {object}
     * @memberof LeaveDetailResponseModel
     */
    'Date'?: object;
    /**
     * 
     * @type {string}
     * @memberof LeaveDetailResponseModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaveDetailResponseModel
     */
    'Hours'?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaveDetailResponseModel
     */
    'Type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveDetailResponseModel
     */
    'Description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveDetailResponseModel
     */
    'IsLocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveDetailResponseModel
     */
    'Message'?: string;
}
/**
 * 
 * @export
 * @interface LeaveModel
 */
export interface LeaveModel {
    /**
     * 
     * @type {string}
     * @memberof LeaveModel
     */
    'id'?: string;
    /**
     * 
     * @type {LeaveTeammember}
     * @memberof LeaveModel
     */
    'Teammember'?: LeaveTeammember;
    /**
     * 
     * @type {object}
     * @memberof LeaveModel
     */
    'Date'?: object;
    /**
     * 
     * @type {string}
     * @memberof LeaveModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaveModel
     */
    'TimezoneOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveModel
     */
    'Hours'?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaveModel
     */
    'Type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaveModel
     */
    'Sort'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LeaveModel
     */
    'isLocked'?: boolean;
}
/**
 * 
 * @export
 * @interface LeaveTeammember
 */
export interface LeaveTeammember {
    /**
     * 
     * @type {string}
     * @memberof LeaveTeammember
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaveTeammember
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface LineManagerModel
 */
export interface LineManagerModel {
    /**
     * 
     * @type {string}
     * @memberof LineManagerModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineManagerModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineManagerModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof LineManagerModel
     */
    'Email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LineManagerModel
     */
    'IsActive'?: boolean;
}
/**
 * 
 * @export
 * @interface ListResultNotificationItem
 */
export interface ListResultNotificationItem {
    /**
     * 
     * @type {Array<NotificationItem>}
     * @memberof ListResultNotificationItem
     */
    'data'?: Array<NotificationItem>;
    /**
     * 
     * @type {number}
     * @memberof ListResultNotificationItem
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ListResultNotificationItem
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ListResultNotificationItem
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof ListResultNotificationItem
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface LoanApprovalModel
 */
export interface LoanApprovalModel {
    /**
     * 
     * @type {string}
     * @memberof LoanApprovalModel
     */
    'LoanId'?: string;
    /**
     * 
     * @type {object}
     * @memberof LoanApprovalModel
     */
    'StartPaymentDate'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof LoanApprovalModel
     */
    'IsRejected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanApprovalModel
     */
    'RejectionReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanApprovalModel
     */
    'PaymentReference'?: string;
}
/**
 * 
 * @export
 * @interface LoanItemModel
 */
export interface LoanItemModel {
    /**
     * 
     * @type {string}
     * @memberof LoanItemModel
     */
    'LoanId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModel
     */
    'LoanTotalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModel
     */
    'LoanTotalPaidAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModel
     */
    'LoanTotalUnPaidAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModel
     */
    'LoanLastPaidInstallmentAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanItemModel
     */
    'PayRunId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanItemModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModel
     */
    'Amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LoanItemModel
     */
    'IsDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanItemModel
     */
    'PaidDate'?: string;
}
/**
 * 
 * @export
 * @interface LoanItemModelOverview
 */
export interface LoanItemModelOverview {
    /**
     * 
     * @type {string}
     * @memberof LoanItemModelOverview
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanItemModelOverview
     */
    'Amount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LoanItemModelOverview
     */
    'IsPaid'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof LoanItemModelOverview
     */
    'PaidDate'?: object;
}
/**
 * 
 * @export
 * @interface LoanListResult
 */
export interface LoanListResult {
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'TotalAmountAUD'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'TotalRemainingAmountAUD'?: number;
    /**
     * 
     * @type {Array<LoanModel>}
     * @memberof LoanListResult
     */
    'data'?: Array<LoanModel>;
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanListResult
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface LoanModel
 */
export interface LoanModel {
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'TeamMemberName'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'Installment'?: number;
    /**
     * 
     * @type {object}
     * @memberof LoanModel
     */
    'CreatedDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof LoanModel
     */
    'LastActionDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof LoanModel
     */
    'ProposedPaymentDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof LoanModel
     */
    'StartPaymentDate'?: object;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'Reference'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'PaymentReference'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'Amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'AmountHasToPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'PaidAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'UnPaidAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanModel
     */
    'RejectReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanModel
     */
    'Status'?: LoanModelStatusEnum;
    /**
     * 
     * @type {Array<LoanItemModel>}
     * @memberof LoanModel
     */
    'PaidItems'?: Array<LoanItemModel>;
    /**
     * 
     * @type {Array<LoanItemModelOverview>}
     * @memberof LoanModel
     */
    'PaymentOverview'?: Array<LoanItemModelOverview>;
}

export const LoanModelStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type LoanModelStatusEnum = typeof LoanModelStatusEnum[keyof typeof LoanModelStatusEnum];

/**
 * 
 * @export
 * @interface LoanRequestModel
 */
export interface LoanRequestModel {
    /**
     * 
     * @type {string}
     * @memberof LoanRequestModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanRequestModel
     */
    'Status'?: number;
    /**
     * 
     * @type {PaginationRequestModel}
     * @memberof LoanRequestModel
     */
    'paginationModel'?: PaginationRequestModel;
}
/**
 * 
 * @export
 * @interface LoginRequestModel
 */
export interface LoginRequestModel {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestModel
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestModel
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface ManagerCustomerModel
 */
export interface ManagerCustomerModel {
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'AppliedCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'AppliedCustomerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'Email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerCustomerModel
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagerCustomerModel
     */
    'FullName'?: string;
}
/**
 * 
 * @export
 * @interface ManagerModel
 */
export interface ManagerModel {
    /**
     * 
     * @type {string}
     * @memberof ManagerModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModel
     */
    'Email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerModel
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagerModel
     */
    'FullName'?: string;
}
/**
 * 
 * @export
 * @interface ManagerModelLoginVM
 */
export interface ManagerModelLoginVM {
    /**
     * 
     * @type {Array<string>}
     * @memberof ManagerModelLoginVM
     */
    'Roles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'UserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'Email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerModelLoginVM
     */
    'IsActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagerModelLoginVM
     */
    'FullName'?: string;
}
/**
 * 
 * @export
 * @interface NotificationItem
 */
export interface NotificationItem {
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'PushText'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'Type'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'Section'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'relatedEntityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'relatedEntityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'ShortDesc'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'NotificationId'?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationItem
     */
    'CreationDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'UserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'UserFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'Status'?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationItem
     */
    'SeenDate'?: object;
    /**
     * 
     * @type {Array<NotificationItemReply>}
     * @memberof NotificationItem
     */
    'Replies'?: Array<NotificationItemReply>;
    /**
     * 
     * @type {number}
     * @memberof NotificationItem
     */
    'RepliesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'CreatorUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItem
     */
    'CreatorUserFullName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationItem
     */
    'IsWithdrawn'?: boolean;
}
/**
 * 
 * @export
 * @interface NotificationItemReply
 */
export interface NotificationItemReply {
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'NotificationItemId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationItemReply
     */
    'SentByCreator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'SeenDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReply
     */
    'CreatedAt'?: string;
}
/**
 * 
 * @export
 * @interface NotificationItemReplyRequestModel
 */
export interface NotificationItemReplyRequestModel {
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReplyRequestModel
     */
    'notificationItemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationItemReplyRequestModel
     */
    'text'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationItemReplyRequestModel
     */
    'sentByCreator'?: boolean;
}
/**
 * 
 * @export
 * @interface NotificationModel
 */
export interface NotificationModel {
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'PushText'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'ShortDesc'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'SmsText'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'EmailText'?: string;
    /**
     * 
     * @type {object}
     * @memberof NotificationModel
     */
    'CreationDate'?: object;
    /**
     * 
     * @type {UserOfNotification}
     * @memberof NotificationModel
     */
    'CreatorUser'?: UserOfNotification;
    /**
     * 
     * @type {Array<UserOfNotification>}
     * @memberof NotificationModel
     */
    'Users'?: Array<UserOfNotification>;
    /**
     * 
     * @type {object}
     * @memberof NotificationModel
     */
    'StartDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof NotificationModel
     */
    'Schedule'?: object;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'Type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationModel
     */
    'Seen'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof NotificationModel
     */
    'SeenDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'Section'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'Url'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'relatedEntityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'relatedEntityId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationModel
     */
    'SendNow'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationModel
     */
    'CreatorUserId'?: string;
}
/**
 * 
 * @export
 * @interface NotificationRequestModel
 */
export interface NotificationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof NotificationRequestModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationRequestModel
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationRequestModel
     */
    'readDate'?: string;
}
/**
 * 
 * @export
 * @interface OfficeLocationModel
 */
export interface OfficeLocationModel {
    /**
     * 
     * @type {string}
     * @memberof OfficeLocationModel
     */
    'Address'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeLocationModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeLocationModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface OfficeSpaceModel
 */
export interface OfficeSpaceModel {
    /**
     * 
     * @type {string}
     * @memberof OfficeSpaceModel
     */
    'Address'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeSpaceModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfficeSpaceModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface PaginationRequestModel
 */
export interface PaginationRequestModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationRequestModel
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationRequestModel
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginationRequestModel
     */
    'sortProp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginationRequestModel
     */
    'sortOrder'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaginationRequestModel
     */
    'filters'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PaginationRequestModelV2
 */
export interface PaginationRequestModelV2 {
    /**
     * 
     * @type {number}
     * @memberof PaginationRequestModelV2
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationRequestModelV2
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof PaginationRequestModelV2
     */
    'sortProps'?: Array<{ [key: string]: string; }>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaginationRequestModelV2
     */
    'filters'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PaginationResponseModelAdminSupportNotificationItemModel
 */
export interface PaginationResponseModelAdminSupportNotificationItemModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelAdminSupportNotificationItemModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelAdminSupportNotificationItemModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelAdminSupportNotificationItemModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<AdminSupportNotificationItemModel>}
     * @memberof PaginationResponseModelAdminSupportNotificationItemModel
     */
    'Items'?: Array<AdminSupportNotificationItemModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelCommitmentModel
 */
export interface PaginationResponseModelCommitmentModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCommitmentModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCommitmentModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCommitmentModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<CommitmentModel>}
     * @memberof PaginationResponseModelCommitmentModel
     */
    'Items'?: Array<CommitmentModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelCostAnalysisReportResponseModel
 */
export interface PaginationResponseModelCostAnalysisReportResponseModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCostAnalysisReportResponseModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCostAnalysisReportResponseModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelCostAnalysisReportResponseModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<CostAnalysisReportResponseModel>}
     * @memberof PaginationResponseModelCostAnalysisReportResponseModel
     */
    'Items'?: Array<CostAnalysisReportResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelPayRunModel
 */
export interface PaginationResponseModelPayRunModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPayRunModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPayRunModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPayRunModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<PayRunModel>}
     * @memberof PaginationResponseModelPayRunModel
     */
    'Items'?: Array<PayRunModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelPositionResponseModel
 */
export interface PaginationResponseModelPositionResponseModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionResponseModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionResponseModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionResponseModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<PositionResponseModel>}
     * @memberof PaginationResponseModelPositionResponseModel
     */
    'Items'?: Array<PositionResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelPositionTaskResponseModel
 */
export interface PaginationResponseModelPositionTaskResponseModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionTaskResponseModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionTaskResponseModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelPositionTaskResponseModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<PositionTaskResponseModel>}
     * @memberof PaginationResponseModelPositionTaskResponseModel
     */
    'Items'?: Array<PositionTaskResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelTaskTemplateModel
 */
export interface PaginationResponseModelTaskTemplateModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTaskTemplateModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTaskTemplateModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTaskTemplateModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<TaskTemplateModel>}
     * @memberof PaginationResponseModelTaskTemplateModel
     */
    'Items'?: Array<TaskTemplateModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelTeammemberByRateResponseModel
 */
export interface PaginationResponseModelTeammemberByRateResponseModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTeammemberByRateResponseModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTeammemberByRateResponseModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelTeammemberByRateResponseModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<TeammemberByRateResponseModel>}
     * @memberof PaginationResponseModelTeammemberByRateResponseModel
     */
    'Items'?: Array<TeammemberByRateResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelVmActionLogResponseModel
 */
export interface PaginationResponseModelVmActionLogResponseModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmActionLogResponseModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmActionLogResponseModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmActionLogResponseModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<VmActionLogResponseModel>}
     * @memberof PaginationResponseModelVmActionLogResponseModel
     */
    'Items'?: Array<VmActionLogResponseModel>;
}
/**
 * 
 * @export
 * @interface PaginationResponseModelVmModel
 */
export interface PaginationResponseModelVmModel {
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmModel
     */
    'Page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmModel
     */
    'PageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationResponseModelVmModel
     */
    'Total'?: number;
    /**
     * 
     * @type {Array<VmModel>}
     * @memberof PaginationResponseModelVmModel
     */
    'Items'?: Array<VmModel>;
}
/**
 * 
 * @export
 * @interface PayRoll
 */
export interface PayRoll {
    /**
     * 
     * @type {string}
     * @memberof PayRoll
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRoll
     */
    'toDate'?: string;
    /**
     * 
     * @type {TeamMemberMinVM}
     * @memberof PayRoll
     */
    'teamMember'?: TeamMemberMinVM;
    /**
     * 
     * @type {string}
     * @memberof PayRoll
     */
    'teamMemberName'?: string;
    /**
     * 
     * @type {PayRunMinVM}
     * @memberof PayRoll
     */
    'payRun'?: PayRunMinVM;
    /**
     * 
     * @type {number}
     * @memberof PayRoll
     */
    'paymentMethodType'?: PayRollPaymentMethodTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof PayRoll
     */
    'paymentMethodDetails'?: object;
    /**
     * 
     * @type {number}
     * @memberof PayRoll
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRoll
     */
    'lcAmount'?: number;
}

export const PayRollPaymentMethodTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type PayRollPaymentMethodTypeEnum = typeof PayRollPaymentMethodTypeEnum[keyof typeof PayRollPaymentMethodTypeEnum];

/**
 * 
 * @export
 * @interface PayRunItemModel
 */
export interface PayRunItemModel {
    /**
     * 
     * @type {CommitmentOfPayRunItem}
     * @memberof PayRunItemModel
     */
    'Commitment'?: CommitmentOfPayRunItem;
    /**
     * 
     * @type {Array<WeekOfPayRunItem>}
     * @memberof PayRunItemModel
     */
    'Weeks'?: Array<WeekOfPayRunItem>;
    /**
     * 
     * @type {number}
     * @memberof PayRunItemModel
     */
    'TotalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRunItemModel
     */
    'AdjustmentHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRunItemModel
     */
    'Fee'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRunItemModel
     */
    'TotalPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRunItemModel
     */
    'SeniorityLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayRunItemModel
     */
    'PayrunItemType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunItemModel
     */
    'CommitmentChargeId'?: string;
}
/**
 * 
 * @export
 * @interface PayRunMinVM
 */
export interface PayRunMinVM {
    /**
     * 
     * @type {string}
     * @memberof PayRunMinVM
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof PayRunMinVM
     */
    'fromDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof PayRunMinVM
     */
    'toDate'?: object;
    /**
     * 
     * @type {TeamMemberMinVM}
     * @memberof PayRunMinVM
     */
    'teamMember'?: TeamMemberMinVM;
    /**
     * 
     * @type {number}
     * @memberof PayRunMinVM
     */
    'audTotalPay'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayRunMinVM
     */
    'adminApproved'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PayRunMinVM
     */
    'lcTotalPay'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayRunMinVM
     */
    'exchangeCurrency'?: string;
    /**
     * 
     * @type {Array<PayrunPayment>}
     * @memberof PayRunMinVM
     */
    'payments'?: Array<PayrunPayment>;
}
/**
 * 
 * @export
 * @interface PayRunModel
 */
export interface PayRunModel {
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'FromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'ToDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PayRunModel
     */
    'PaymentMethodType'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {TeammemberOfPayRun}
     * @memberof PayRunModel
     */
    'TeamMember'?: TeammemberOfPayRun;
    /**
     * 
     * @type {Array<PayRunItemModel>}
     * @memberof PayRunModel
     */
    'Items'?: Array<PayRunItemModel>;
    /**
     * 
     * @type {Array<Adjustment>}
     * @memberof PayRunModel
     */
    'Adjustments'?: Array<Adjustment>;
    /**
     * 
     * @type {Array<LoanItemModel>}
     * @memberof PayRunModel
     */
    'LoanItems'?: Array<LoanItemModel>;
    /**
     * 
     * @type {number}
     * @memberof PayRunModel
     */
    'ExchangeRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'CryptoCurrencyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'BankAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'WiseAccountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'PaypalId'?: string;
    /**
     * 
     * @type {CryptoCurrencyModel}
     * @memberof PayRunModel
     */
    'CryptoCurrency'?: CryptoCurrencyModel;
    /**
     * 
     * @type {BankAccountModel}
     * @memberof PayRunModel
     */
    'BankAccount'?: BankAccountModel;
    /**
     * 
     * @type {WiseAccountModel}
     * @memberof PayRunModel
     */
    'WiseAccount'?: WiseAccountModel;
    /**
     * 
     * @type {PaypalModel}
     * @memberof PayRunModel
     */
    'Paypal'?: PaypalModel;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'ExchangeCurrency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PayRunModel
     */
    'AUDTotalPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayRunModel
     */
    'LCTotalPay'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PayRunModel
     */
    'AdminApproved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PayRunModel
     */
    'TMApproved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'PaymentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayRunModel
     */
    'PaymentRefNo'?: string;
    /**
     * 
     * @type {Array<PayrunPayment>}
     * @memberof PayRunModel
     */
    'Payments'?: Array<PayrunPayment>;
}
/**
 * 
 * @export
 * @interface PaymentUnit
 */
export interface PaymentUnit {
    /**
     * 
     * @type {string}
     * @memberof PaymentUnit
     */
    'Unit'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentUnit
     */
    'Value'?: number;
}
/**
 * 
 * @export
 * @interface PaypalModel
 */
export interface PaypalModel {
    /**
     * 
     * @type {string}
     * @memberof PaypalModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaypalModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaypalModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaypalModel
     */
    'CreatedAt'?: string;
}
/**
 * 
 * @export
 * @interface PayrunBillableItem
 */
export interface PayrunBillableItem {
    /**
     * 
     * @type {Array<CommitmentBillableItemModel>}
     * @memberof PayrunBillableItem
     */
    'commitmentBillableItems'?: Array<CommitmentBillableItemModel>;
    /**
     * 
     * @type {string}
     * @memberof PayrunBillableItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrunBillableItem
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrunBillableItem
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrunBillableItem
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface PayrunDetailByMonth
 */
export interface PayrunDetailByMonth {
    /**
     * 
     * @type {number}
     * @memberof PayrunDetailByMonth
     */
    'MonthNumber'?: number;
    /**
     * 
     * @type {Array<PaymentUnit>}
     * @memberof PayrunDetailByMonth
     */
    'BasePaymentUnit'?: Array<PaymentUnit>;
    /**
     * 
     * @type {Array<PaymentUnit>}
     * @memberof PayrunDetailByMonth
     */
    'ConvertedPaymentUnit'?: Array<PaymentUnit>;
}
/**
 * 
 * @export
 * @interface PayrunDetailByTeammember
 */
export interface PayrunDetailByTeammember {
    /**
     * 
     * @type {string}
     * @memberof PayrunDetailByTeammember
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {Array<PayrunDetailByMonth>}
     * @memberof PayrunDetailByTeammember
     */
    'PayrunDetailByMonth'?: Array<PayrunDetailByMonth>;
    /**
     * 
     * @type {Array<PaymentUnit>}
     * @memberof PayrunDetailByTeammember
     */
    'TeammemberTotalPayments'?: Array<PaymentUnit>;
}
/**
 * 
 * @export
 * @interface PayrunPayment
 */
export interface PayrunPayment {
    /**
     * 
     * @type {string}
     * @memberof PayrunPayment
     */
    'PaymentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PayrunPayment
     */
    'PaymentRefNo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PayrunPayment
     */
    'LCTotalPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PayrunPayment
     */
    'AUDTotalPay'?: number;
}
/**
 * 
 * @export
 * @interface PersonalDetailModel
 */
export interface PersonalDetailModel {
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Id'?: string;
    /**
     * 
     * @type {object}
     * @memberof PersonalDetailModel
     */
    'BirthDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'CV'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'GitHub'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'LinkedIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'MaritalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'MilitaryServiceSituation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Nationality'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'NickName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'Phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'SecondaryEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'StillStudying'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalDetailModel
     */
    'WebSite'?: string;
}
/**
 * 
 * @export
 * @interface PhoneModel
 */
export interface PhoneModel {
    /**
     * 
     * @type {string}
     * @memberof PhoneModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneModel
     */
    'Name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PhoneModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PhoneModel
     */
    'Phone'?: string;
    /**
     * 
     * @type {object}
     * @memberof PhoneModel
     */
    'VerifiedOn'?: object;
    /**
     * 
     * @type {object}
     * @memberof PhoneModel
     */
    'StartTimerDate'?: object;
    /**
     * 
     * @type {object}
     * @memberof PhoneModel
     */
    'EndTimerDate'?: object;
    /**
     * 
     * @type {number}
     * @memberof PhoneModel
     */
    'WrongCodeInputCount'?: number;
}
/**
 * 
 * @export
 * @interface PositionDetailResponseModel
 */
export interface PositionDetailResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'CreatedAt'?: string;
    /**
     * 
     * @type {Array<CommitmentMinModel>}
     * @memberof PositionDetailResponseModel
     */
    'Commitments'?: Array<CommitmentMinModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionDetailResponseModel
     */
    'CountryId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'HiringContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'HiringmanagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'HiringmanagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'JobDescription'?: string;
    /**
     * 
     * @type {Array<DetailsModel>}
     * @memberof PositionDetailResponseModel
     */
    'JobTitles'?: Array<DetailsModel>;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'JobRole'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionDetailResponseModel
     */
    'NoOfPositions'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionDetailResponseModel
     */
    'SeatUnfilled'?: number;
    /**
     * 
     * @type {Array<CoreSkillModel>}
     * @memberof PositionDetailResponseModel
     */
    'Skills'?: Array<CoreSkillModel>;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailResponseModel
     */
    'Status'?: string;
    /**
     * 
     * @type {Array<PositionTaskModel>}
     * @memberof PositionDetailResponseModel
     */
    'Tasks'?: Array<PositionTaskModel>;
}
/**
 * 
 * @export
 * @interface PositionDetailsModel
 */
export interface PositionDetailsModel {
    /**
     * 
     * @type {boolean}
     * @memberof PositionDetailsModel
     */
    'contactVerification'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PositionDetailsModel
     */
    'contractManagement'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionDetailsModel
     */
    'daysOfWeekInOffice'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'endWorkClock'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionDetailsModel
     */
    'hoursPerWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PositionDetailsModel
     */
    'hoursPerWeekCasual'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PositionDetailsModel
     */
    'idVerification'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'lineManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'locationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'officeDaysPerWeek'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'officeLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'projectLeadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'publicHolidayZoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'salaryCurrency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionDetailsModel
     */
    'salaryMonthly'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionDetailsModel
     */
    'seniorityLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'startWorkClock'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionDetailsModel
     */
    'timeZone'?: string;
    /**
     * 
     * @type {VirtualDesktopSpec}
     * @memberof PositionDetailsModel
     */
    'virtualDesktopSpec'?: VirtualDesktopSpec;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionDetailsModel
     */
    'workingDays'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PositionJDAndDetailsRequestModel
 */
export interface PositionJDAndDetailsRequestModel {
    /**
     * 
     * @type {string}
     * @memberof PositionJDAndDetailsRequestModel
     */
    'jobDescription'?: string;
    /**
     * 
     * @type {PositionDetailsModel}
     * @memberof PositionJDAndDetailsRequestModel
     */
    'positionDetails'?: PositionDetailsModel;
}
/**
 * 
 * @export
 * @interface PositionModel
 */
export interface PositionModel {
    /**
     * 
     * @type {Array<CommitmentMinModel>}
     * @memberof PositionModel
     */
    'Commitments'?: Array<CommitmentMinModel>;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'JobDescription'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionModel
     */
    'JobTitles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'JobRoleId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'NoOfPositions'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionModel
     */
    'Skills'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'HiringContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'HiringManagerId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionModel
     */
    'CountryId'?: Array<string>;
    /**
     * 
     * @type {Array<PositionTaskRequestModel>}
     * @memberof PositionModel
     */
    'Tasks'?: Array<PositionTaskRequestModel>;
}
/**
 * 
 * @export
 * @interface PositionRequestModel
 */
export interface PositionRequestModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionRequestModel
     */
    'countryId'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'hiringContact'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'hiringmanagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'jobDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'jobRoleId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionRequestModel
     */
    'jobTitles'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PositionRequestModel
     */
    'noOfPositions': number;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionRequestModel
     */
    'skills'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionRequestModel
     */
    'status'?: string;
    /**
     * 
     * @type {Array<PositionTaskModel>}
     * @memberof PositionRequestModel
     */
    'tasks'?: Array<PositionTaskModel>;
}
/**
 * 
 * @export
 * @interface PositionResponseModel
 */
export interface PositionResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'CustomerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'JobRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'JobRoleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionResponseModel
     */
    'JobTitles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'HiringmanagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionResponseModel
     */
    'Status'?: string;
}
/**
 * 
 * @export
 * @interface PositionTaskDetailResponseModel
 */
export interface PositionTaskDetailResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'PositionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTaskDetailResponseModel
     */
    'OrderNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'Date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'TaskTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'TaskTemplateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'HiringManagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskDetailResponseModel
     */
    'HiringManagerName'?: string;
}
/**
 * 
 * @export
 * @interface PositionTaskModel
 */
export interface PositionTaskModel {
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'PositionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'TaskTemplateName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'TaskTemplateId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'Title'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTaskModel
     */
    'OrderNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'Date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionTaskModel
     */
    'Status'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PositionTaskModel
     */
    'isDefault'?: boolean;
}
/**
 * 
 * @export
 * @interface PositionTaskRequestModel
 */
export interface PositionTaskRequestModel {
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'CustomerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'JobRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'JobRoleId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionTaskRequestModel
     */
    'JobTitles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'StartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'HiringmanagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskRequestModel
     */
    'Status'?: string;
}
/**
 * 
 * @export
 * @interface PositionTaskResponseModel
 */
export interface PositionTaskResponseModel {
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'PositionTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'TaskTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'Date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'HiringManagerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionTaskResponseModel
     */
    'Status'?: string;
}
/**
 * 
 * @export
 * @interface ProfessionalDetailCareerObjectiveModel
 */
export interface ProfessionalDetailCareerObjectiveModel {
    /**
     * 
     * @type {number}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'Amount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'EmploymentType'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'IsNegotiable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'PositionExperienceYear'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'PreferredLocation'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'SeiorityLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailCareerObjectiveModel
     */
    'WorkingPosition'?: string;
}
/**
 * 
 * @export
 * @interface ProfessionalDetailModel
 */
export interface ProfessionalDetailModel {
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'JobRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'JobTitleId'?: string;
    /**
     * 
     * @type {Array<ProfessionalDetailCareerObjectiveModel>}
     * @memberof ProfessionalDetailModel
     */
    'CareerObjectives'?: Array<ProfessionalDetailCareerObjectiveModel>;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'ExperienceYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfessionalDetailModel
     */
    'Personality'?: string;
}
/**
 * 
 * @export
 * @interface ProjectModel
 */
export interface ProjectModel {
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'ProjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectModel
     */
    'ProjectDesc'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectModel
     */
    'Epics'?: Array<string>;
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof ProjectModel
     */
    'Positions'?: Array<PositionModel>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectModel
     */
    'ProjectLead'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectModel
     */
    'Customerss'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ProjectOfAccessModel
 */
export interface ProjectOfAccessModel {
    /**
     * 
     * @type {string}
     * @memberof ProjectOfAccessModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectOfAccessModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface ProjectPositionResponseModel
 */
export interface ProjectPositionResponseModel {
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'CreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'CountryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'JobTitles'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'JobRoleName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectPositionResponseModel
     */
    'NoOfPositions'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'Skills'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectPositionResponseModel
     */
    'StartDate'?: string;
}
/**
 * 
 * @export
 * @interface PublicHolidayModel
 */
export interface PublicHolidayModel {
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicHolidayModel
     */
    'Title'?: string;
    /**
     * 
     * @type {Array<HolidayDateModel>}
     * @memberof PublicHolidayModel
     */
    'Dates'?: Array<HolidayDateModel>;
}
/**
 * 
 * @export
 * @interface RateModel
 */
export interface RateModel {
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'TeamMemberRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'LineManagerRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'SalesRepRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'TDMRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'ProjectLeadRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'PortfolioManagerRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'HrFinanceRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'CharityRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'OffshoreEntityRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'ToolsRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'FunctionalManagerRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'BusinessManagerRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'SubsidyRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof RateModel
     */
    'MiscRate'?: number;
}
/**
 * 
 * @export
 * @interface RecordTypeModel
 */
export interface RecordTypeModel {
    /**
     * 
     * @type {string}
     * @memberof RecordTypeModel
     */
    'Type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordTypeModel
     */
    'Id'?: string;
}
/**
 * 
 * @export
 * @interface RegisterModel
 */
export interface RegisterModel {
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'oAuthAccessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterModel
     */
    'wayToKnow'?: string;
}
/**
 * 
 * @export
 * @interface RegisterWithCustomTokenModel
 */
export interface RegisterWithCustomTokenModel {
    /**
     * 
     * @type {string}
     * @memberof RegisterWithCustomTokenModel
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface RepositoryModel
 */
export interface RepositoryModel {
    /**
     * 
     * @type {string}
     * @memberof RepositoryModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryModel
     */
    'HttpsLink'?: string;
}
/**
 * 
 * @export
 * @interface RepositoryTeammemberCommit
 */
export interface RepositoryTeammemberCommit {
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'Author'?: string;
    /**
     * 
     * @type {object}
     * @memberof RepositoryTeammemberCommit
     */
    'Date'?: object;
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'Hash'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepositoryTeammemberCommit
     */
    'linesAdded'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepositoryTeammemberCommit
     */
    'linesChanged'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepositoryTeammemberCommit
     */
    'linesDeleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'Repository'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepositoryTeammemberCommit
     */
    'MessageShort'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RepositoryTeammemberCommit
     */
    'IsSynced'?: boolean;
}
/**
 * 
 * @export
 * @interface Result
 */
export interface Result {
    /**
     * 
     * @type {boolean}
     * @memberof Result
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Result
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof Result
     */
    'errorType'?: ResultErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof Result
     */
    'exception'?: object;
}

export const ResultErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultErrorTypeEnum = typeof ResultErrorTypeEnum[keyof typeof ResultErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultBoolean
 */
export interface ResultBoolean {
    /**
     * 
     * @type {boolean}
     * @memberof ResultBoolean
     */
    'data'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResultBoolean
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultBoolean
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultBoolean
     */
    'errorType'?: ResultBooleanErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultBoolean
     */
    'exception'?: object;
}

export const ResultBooleanErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultBooleanErrorTypeEnum = typeof ResultBooleanErrorTypeEnum[keyof typeof ResultBooleanErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultClientAssessmentModel
 */
export interface ResultClientAssessmentModel {
    /**
     * 
     * @type {ClientAssessmentModel}
     * @memberof ResultClientAssessmentModel
     */
    'data'?: ClientAssessmentModel;
    /**
     * 
     * @type {boolean}
     * @memberof ResultClientAssessmentModel
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultClientAssessmentModel
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultClientAssessmentModel
     */
    'errorType'?: ResultClientAssessmentModelErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultClientAssessmentModel
     */
    'exception'?: object;
}

export const ResultClientAssessmentModelErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultClientAssessmentModelErrorTypeEnum = typeof ResultClientAssessmentModelErrorTypeEnum[keyof typeof ResultClientAssessmentModelErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultCourseModel
 */
export interface ResultCourseModel {
    /**
     * 
     * @type {CourseModel}
     * @memberof ResultCourseModel
     */
    'data'?: CourseModel;
    /**
     * 
     * @type {boolean}
     * @memberof ResultCourseModel
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultCourseModel
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultCourseModel
     */
    'errorType'?: ResultCourseModelErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultCourseModel
     */
    'exception'?: object;
}

export const ResultCourseModelErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultCourseModelErrorTypeEnum = typeof ResultCourseModelErrorTypeEnum[keyof typeof ResultCourseModelErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultDateTime
 */
export interface ResultDateTime {
    /**
     * 
     * @type {string}
     * @memberof ResultDateTime
     */
    'data'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResultDateTime
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultDateTime
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultDateTime
     */
    'errorType'?: ResultDateTimeErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultDateTime
     */
    'exception'?: object;
}

export const ResultDateTimeErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultDateTimeErrorTypeEnum = typeof ResultDateTimeErrorTypeEnum[keyof typeof ResultDateTimeErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultIActionResult
 */
export interface ResultIActionResult {
    /**
     * 
     * @type {object}
     * @memberof ResultIActionResult
     */
    'data'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof ResultIActionResult
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultIActionResult
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultIActionResult
     */
    'errorType'?: ResultIActionResultErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultIActionResult
     */
    'exception'?: object;
}

export const ResultIActionResultErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultIActionResultErrorTypeEnum = typeof ResultIActionResultErrorTypeEnum[keyof typeof ResultIActionResultErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultIEnumerable1
 */
export interface ResultIEnumerable1 {
    /**
     * 
     * @type {Array<VmLoginResponse>}
     * @memberof ResultIEnumerable1
     */
    'data'?: Array<VmLoginResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ResultIEnumerable1
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultIEnumerable1
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultIEnumerable1
     */
    'errorType'?: ResultIEnumerable1ErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultIEnumerable1
     */
    'exception'?: object;
}

export const ResultIEnumerable1ErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultIEnumerable1ErrorTypeEnum = typeof ResultIEnumerable1ErrorTypeEnum[keyof typeof ResultIEnumerable1ErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultList1
 */
export interface ResultList1 {
    /**
     * 
     * @type {Array<ClientAssessmentModel>}
     * @memberof ResultList1
     */
    'data'?: Array<ClientAssessmentModel>;
    /**
     * 
     * @type {boolean}
     * @memberof ResultList1
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultList1
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultList1
     */
    'errorType'?: ResultList1ErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultList1
     */
    'exception'?: object;
}

export const ResultList1ErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultList1ErrorTypeEnum = typeof ResultList1ErrorTypeEnum[keyof typeof ResultList1ErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultManagerModelLoginVM
 */
export interface ResultManagerModelLoginVM {
    /**
     * 
     * @type {ManagerModelLoginVM}
     * @memberof ResultManagerModelLoginVM
     */
    'data'?: ManagerModelLoginVM;
    /**
     * 
     * @type {boolean}
     * @memberof ResultManagerModelLoginVM
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultManagerModelLoginVM
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultManagerModelLoginVM
     */
    'errorType'?: ResultManagerModelLoginVMErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultManagerModelLoginVM
     */
    'exception'?: object;
}

export const ResultManagerModelLoginVMErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultManagerModelLoginVMErrorTypeEnum = typeof ResultManagerModelLoginVMErrorTypeEnum[keyof typeof ResultManagerModelLoginVMErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultNotificationItemReply
 */
export interface ResultNotificationItemReply {
    /**
     * 
     * @type {NotificationItemReply}
     * @memberof ResultNotificationItemReply
     */
    'data'?: NotificationItemReply;
    /**
     * 
     * @type {boolean}
     * @memberof ResultNotificationItemReply
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultNotificationItemReply
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultNotificationItemReply
     */
    'errorType'?: ResultNotificationItemReplyErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultNotificationItemReply
     */
    'exception'?: object;
}

export const ResultNotificationItemReplyErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultNotificationItemReplyErrorTypeEnum = typeof ResultNotificationItemReplyErrorTypeEnum[keyof typeof ResultNotificationItemReplyErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultRoadMapModel
 */
export interface ResultRoadMapModel {
    /**
     * 
     * @type {RoadMapModel}
     * @memberof ResultRoadMapModel
     */
    'data'?: RoadMapModel;
    /**
     * 
     * @type {boolean}
     * @memberof ResultRoadMapModel
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultRoadMapModel
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultRoadMapModel
     */
    'errorType'?: ResultRoadMapModelErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultRoadMapModel
     */
    'exception'?: object;
}

export const ResultRoadMapModelErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultRoadMapModelErrorTypeEnum = typeof ResultRoadMapModelErrorTypeEnum[keyof typeof ResultRoadMapModelErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultString
 */
export interface ResultString {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultString
     */
    'data'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ResultString
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultString
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultString
     */
    'errorType'?: ResultStringErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultString
     */
    'exception'?: object;
}

export const ResultStringErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultStringErrorTypeEnum = typeof ResultStringErrorTypeEnum[keyof typeof ResultStringErrorTypeEnum];

/**
 * 
 * @export
 * @interface ResultTmRoadMapModel
 */
export interface ResultTmRoadMapModel {
    /**
     * 
     * @type {TmRoadMapModel}
     * @memberof ResultTmRoadMapModel
     */
    'data'?: TmRoadMapModel;
    /**
     * 
     * @type {boolean}
     * @memberof ResultTmRoadMapModel
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultTmRoadMapModel
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultTmRoadMapModel
     */
    'errorType'?: ResultTmRoadMapModelErrorTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ResultTmRoadMapModel
     */
    'exception'?: object;
}

export const ResultTmRoadMapModelErrorTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ResultTmRoadMapModelErrorTypeEnum = typeof ResultTmRoadMapModelErrorTypeEnum[keyof typeof ResultTmRoadMapModelErrorTypeEnum];

/**
 * 
 * @export
 * @interface Revenue
 */
export interface Revenue {
    /**
     * 
     * @type {string}
     * @memberof Revenue
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Revenue
     */
    'toDate'?: string;
    /**
     * 
     * @type {ManagerModel}
     * @memberof Revenue
     */
    'customer'?: ManagerModel;
    /**
     * 
     * @type {string}
     * @memberof Revenue
     */
    'customerName'?: string;
    /**
     * 
     * @type {CustomerInvoiceVM}
     * @memberof Revenue
     */
    'customerInvoice'?: CustomerInvoiceVM;
    /**
     * 
     * @type {number}
     * @memberof Revenue
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface RoadMapModel
 */
export interface RoadMapModel {
    /**
     * 
     * @type {string}
     * @memberof RoadMapModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadMapModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadMapModel
     */
    'Status'?: string;
    /**
     * 
     * @type {Array<RoadMapStepModel>}
     * @memberof RoadMapModel
     */
    'Steps'?: Array<RoadMapStepModel>;
    /**
     * 
     * @type {Array<RoadMapTalentModel>}
     * @memberof RoadMapModel
     */
    'Talents'?: Array<RoadMapTalentModel>;
    /**
     * 
     * @type {string}
     * @memberof RoadMapModel
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface RoadMapStepModel
 */
export interface RoadMapStepModel {
    /**
     * 
     * @type {ClientAssessmentModel}
     * @memberof RoadMapStepModel
     */
    'AssessmentDetail'?: ClientAssessmentModel;
    /**
     * 
     * @type {CourseModel}
     * @memberof RoadMapStepModel
     */
    'CourseDetail'?: CourseModel;
    /**
     * 
     * @type {string}
     * @memberof RoadMapStepModel
     */
    'Id'?: string;
    /**
     * 
     * @type {number}
     * @memberof RoadMapStepModel
     */
    'Order'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoadMapStepModel
     */
    'TalentState'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadMapStepModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadMapStepModel
     */
    'Type'?: string;
}
/**
 * 
 * @export
 * @interface RoadMapTalentModel
 */
export interface RoadMapTalentModel {
    /**
     * 
     * @type {string}
     * @memberof RoadMapTalentModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadMapTalentModel
     */
    'Id'?: string;
}
/**
 * 
 * @export
 * @interface SaveTimesheetRequestModel
 */
export interface SaveTimesheetRequestModel {
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'id'?: string;
    /**
     * 
     * @type {object}
     * @memberof SaveTimesheetRequestModel
     */
    'Date'?: object;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'ActivityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveTimesheetRequestModel
     */
    'Effort'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'Epic'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveTimesheetRequestModel
     */
    'Adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof SaveTimesheetRequestModel
     */
    'EffortWithAdjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'IssueNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'TechnologyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveTimesheetRequestModel
     */
    'TeamMemberId'?: string;
}
/**
 * 
 * @export
 * @interface SearchTeammemberRequestModel
 */
export interface SearchTeammemberRequestModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchTeammemberRequestModel
     */
    'age'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SearchTeammemberRequestModel
     */
    'jobRole'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchTeammemberRequestModel
     */
    'locations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchTeammemberRequestModel
     */
    'skills'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchTeammemberRequestModel
     */
    'totalExperience'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTeammemberRequestModel
     */
    'sortBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchTeammemberRequestModel
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface SendCommitmentNotificationRequestModel
 */
export interface SendCommitmentNotificationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof SendCommitmentNotificationRequestModel
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendCommitmentNotificationRequestModel
     */
    'receiverType'?: string;
}
/**
 * 
 * @export
 * @interface SendNotificationRequestModel
 */
export interface SendNotificationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof SendNotificationRequestModel
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendNotificationRequestModel
     */
    'receiverType'?: string;
}
/**
 * 
 * @export
 * @interface SendTimesheetReportEmailRequestModel
 */
export interface SendTimesheetReportEmailRequestModel {
    /**
     * 
     * @type {Array<TeammemberReport>}
     * @memberof SendTimesheetReportEmailRequestModel
     */
    'teammemberReport'?: Array<TeammemberReport>;
}
/**
 * 
 * @export
 * @interface SetUserRoleModel
 */
export interface SetUserRoleModel {
    /**
     * 
     * @type {string}
     * @memberof SetUserRoleModel
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SetUserRoleModel
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface SonarQubeResultFlowModel
 */
export interface SonarQubeResultFlowModel {
    /**
     * 
     * @type {Array<SonarQubeResultLocationModel>}
     * @memberof SonarQubeResultFlowModel
     */
    'locations'?: Array<SonarQubeResultLocationModel>;
}
/**
 * 
 * @export
 * @interface SonarQubeResultImpactModel
 */
export interface SonarQubeResultImpactModel {
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultImpactModel
     */
    'softwareQuality'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultImpactModel
     */
    'severity'?: string;
}
/**
 * 
 * @export
 * @interface SonarQubeResultIssueModel
 */
export interface SonarQubeResultIssueModel {
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'rule'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'severity'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'component'?: string;
    /**
     * 
     * @type {number}
     * @memberof SonarQubeResultIssueModel
     */
    'line'?: number;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'hash'?: string;
    /**
     * 
     * @type {SonarQubeResultTextRangeModel}
     * @memberof SonarQubeResultIssueModel
     */
    'textRange'?: SonarQubeResultTextRangeModel;
    /**
     * 
     * @type {Array<SonarQubeResultFlowModel>}
     * @memberof SonarQubeResultIssueModel
     */
    'flows'?: Array<SonarQubeResultFlowModel>;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'effort'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'debt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'author'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SonarQubeResultIssueModel
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'scope'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SonarQubeResultIssueModel
     */
    'quickFixAvailable'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SonarQubeResultIssueModel
     */
    'messageFormattings'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SonarQubeResultIssueModel
     */
    'codeVariants'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'cleanCodeAttribute'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'cleanCodeAttributeCategory'?: string;
    /**
     * 
     * @type {Array<SonarQubeResultImpactModel>}
     * @memberof SonarQubeResultIssueModel
     */
    'impacts'?: Array<SonarQubeResultImpactModel>;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultIssueModel
     */
    'issueStatus'?: string;
}
/**
 * 
 * @export
 * @interface SonarQubeResultLocationModel
 */
export interface SonarQubeResultLocationModel {
    /**
     * 
     * @type {SonarQubeResultTextRangeModel}
     * @memberof SonarQubeResultLocationModel
     */
    'textRange'?: SonarQubeResultTextRangeModel;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultLocationModel
     */
    'msg'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SonarQubeResultLocationModel
     */
    'msgFormattings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SonarQubeResultModel
 */
export interface SonarQubeResultModel {
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultModel
     */
    'project'?: string;
    /**
     * 
     * @type {string}
     * @memberof SonarQubeResultModel
     */
    'vmId'?: string;
    /**
     * 
     * @type {Array<SonarQubeResultIssueModel>}
     * @memberof SonarQubeResultModel
     */
    'issues'?: Array<SonarQubeResultIssueModel>;
}
/**
 * 
 * @export
 * @interface SonarQubeResultTextRangeModel
 */
export interface SonarQubeResultTextRangeModel {
    /**
     * 
     * @type {number}
     * @memberof SonarQubeResultTextRangeModel
     */
    'startLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof SonarQubeResultTextRangeModel
     */
    'endLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof SonarQubeResultTextRangeModel
     */
    'startOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof SonarQubeResultTextRangeModel
     */
    'endOffset'?: number;
}
/**
 * 
 * @export
 * @interface StartRoadMapAssessmentRequestModel
 */
export interface StartRoadMapAssessmentRequestModel {
    /**
     * 
     * @type {string}
     * @memberof StartRoadMapAssessmentRequestModel
     */
    'assessmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StartRoadMapAssessmentRequestModel
     */
    'courseId'?: string;
}
/**
 * 
 * @export
 * @interface SubmitAssessmentQuestionRequestModel
 */
export interface SubmitAssessmentQuestionRequestModel {
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentQuestionRequestModel
     */
    'answer'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentQuestionRequestModel
     */
    'assessmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentQuestionRequestModel
     */
    'courseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentQuestionRequestModel
     */
    'questionId'?: string;
}
/**
 * 
 * @export
 * @interface SubmitAssessmentRequestModel
 */
export interface SubmitAssessmentRequestModel {
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentRequestModel
     */
    'assessmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitAssessmentRequestModel
     */
    'courseId'?: string;
}
/**
 * 
 * @export
 * @interface TagModel
 */
export interface TagModel {
    /**
     * 
     * @type {string}
     * @memberof TagModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TagModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TagModel
     */
    'Type'?: string;
}
/**
 * 
 * @export
 * @interface TaskTemplateModel
 */
export interface TaskTemplateModel {
    /**
     * 
     * @type {string}
     * @memberof TaskTemplateModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTemplateModel
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTemplateModel
     */
    'Description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTemplateModel
     */
    'Status'?: boolean;
}
/**
 * 
 * @export
 * @interface TeamMemberMinVM
 */
export interface TeamMemberMinVM {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinVM
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinVM
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinVM
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinVM
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberMinVM
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface TeamMemberOfAccessModel
 */
export interface TeamMemberOfAccessModel {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOfAccessModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOfAccessModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface TeamMemberOfCommitmentModel
 */
export interface TeamMemberOfCommitmentModel {
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOfCommitmentModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOfCommitmentModel
     */
    'TmFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberOfCommitmentModel
     */
    'UserId'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberByRateResponseModel
 */
export interface TeammemberByRateResponseModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberByRateResponseModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberByRateResponseModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberByRateResponseModel
     */
    'JobTitleName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeammemberByRateResponseModel
     */
    'TotalExperience'?: number;
    /**
     * 
     * @type {Array<TeammemberSkillModel>}
     * @memberof TeammemberByRateResponseModel
     */
    'Skills'?: Array<TeammemberSkillModel>;
    /**
     * 
     * @type {number}
     * @memberof TeammemberByRateResponseModel
     */
    'SkillPoint'?: number;
}
/**
 * 
 * @export
 * @interface TeammemberDahsboardReportVM
 */
export interface TeammemberDahsboardReportVM {
    /**
     * 
     * @type {Array<TimesheetModel>}
     * @memberof TeammemberDahsboardReportVM
     */
    'timesheets'?: Array<TimesheetModel>;
    /**
     * 
     * @type {Array<ActivityReport>}
     * @memberof TeammemberDahsboardReportVM
     */
    'activityReport'?: Array<ActivityReport>;
    /**
     * 
     * @type {Array<TechnologyReport>}
     * @memberof TeammemberDahsboardReportVM
     */
    'technologyReport'?: Array<TechnologyReport>;
    /**
     * 
     * @type {Array<EpicReport>}
     * @memberof TeammemberDahsboardReportVM
     */
    'epicReport'?: Array<EpicReport>;
}
/**
 * 
 * @export
 * @interface TeammemberInfoRAGRequestModel
 */
export interface TeammemberInfoRAGRequestModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'age'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'skills'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'biography'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'personality'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'experience'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberInfoRAGRequestModel
     */
    'education'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberModel
 */
export interface TeammemberModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'UserAccountsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'SecondaryEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'NickName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'LinkedIn'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Title'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'WayToKnow'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberModel
     */
    'EnglishWritetenLevel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberModel
     */
    'EnglishSpokenLevel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Description'?: string;
    /**
     * 
     * @type {Array<TeammemberSkillModel>}
     * @memberof TeammemberModel
     */
    'Skills'?: Array<TeammemberSkillModel>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Phone'?: string;
    /**
     * 
     * @type {object}
     * @memberof TeammemberModel
     */
    'BirthDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'MemberSince'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'CV'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeammemberModel
     */
    'ProjectIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Timezone'?: string;
    /**
     * 
     * @type {Array<TeammemberRepositoryModel>}
     * @memberof TeammemberModel
     */
    'Repositories'?: Array<TeammemberRepositoryModel>;
    /**
     * 
     * @type {Array<TeammemberRoleModel>}
     * @memberof TeammemberModel
     */
    'Role'?: Array<TeammemberRoleModel>;
    /**
     * 
     * @type {Array<CareerHistoryModel>}
     * @memberof TeammemberModel
     */
    'CareerHistories'?: Array<CareerHistoryModel>;
    /**
     * 
     * @type {Array<CertificateModel>}
     * @memberof TeammemberModel
     */
    'Certificates'?: Array<CertificateModel>;
    /**
     * 
     * @type {Array<EducationModel>}
     * @memberof TeammemberModel
     */
    'Educations'?: Array<EducationModel>;
    /**
     * 
     * @type {Array<LanguageSkillModel>}
     * @memberof TeammemberModel
     */
    'LanguageSkills'?: Array<LanguageSkillModel>;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberModel
     */
    'IsLinemanager'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'LinemanagerId'?: string;
    /**
     * 
     * @type {ProfessionalDetailModel}
     * @memberof TeammemberModel
     */
    'ProfessionalDetail'?: ProfessionalDetailModel;
    /**
     * 
     * @type {number}
     * @memberof TeammemberModel
     */
    'PaymentMethodType'?: number;
    /**
     * 
     * @type {object}
     * @memberof TeammemberModel
     */
    'UpdatedPaymentMethodDate'?: object;
    /**
     * 
     * @type {Array<AddresssModel>}
     * @memberof TeammemberModel
     */
    'Addresses'?: Array<AddresssModel>;
    /**
     * 
     * @type {Array<PhoneModel>}
     * @memberof TeammemberModel
     */
    'PhoneNumbers'?: Array<PhoneModel>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'Nationality'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'GitHub'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'MaritalStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'StillStudying'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'MilitaryServiceSituation'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'CareerHistoryDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'SpecificRoles'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'SpecificTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'CodeClanCode'?: string;
    /**
     * 
     * @type {Array<JobPreferencesModel>}
     * @memberof TeammemberModel
     */
    'JobPreferences'?: Array<JobPreferencesModel>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberModel
     */
    'WebSite'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberOfPayRun
 */
export interface TeammemberOfPayRun {
    /**
     * 
     * @type {string}
     * @memberof TeammemberOfPayRun
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberOfPayRun
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberReport
 */
export interface TeammemberReport {
    /**
     * 
     * @type {string}
     * @memberof TeammemberReport
     */
    'teammemberName'?: string;
    /**
     * 
     * @type {Array<WeeklyReport>}
     * @memberof TeammemberReport
     */
    'weeklyReport'?: Array<WeeklyReport>;
}
/**
 * 
 * @export
 * @interface TeammemberRepositoryModel
 */
export interface TeammemberRepositoryModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'RepositoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'RepositoryHttpsLink'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'PersonalAccessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'UserName'?: string;
    /**
     * 
     * @type {object}
     * @memberof TeammemberRepositoryModel
     */
    'ExpiryDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'RepositoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRepositoryModel
     */
    'CommitmentId'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberRoleModel
 */
export interface TeammemberRoleModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberRoleModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRoleModel
     */
    'TeammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberRoleModel
     */
    'RoleId'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberSkillModel
 */
export interface TeammemberSkillModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberSkillModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSkillModel
     */
    'SkillId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSkillModel
     */
    'Level'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSkillModel
     */
    'TotalExperienceYears'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeammemberSkillModel
     */
    'Assessment'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSkillModel
     */
    'Certificate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberSkillModel
     */
    'IsTopSkill'?: boolean;
}
/**
 * 
 * @export
 * @interface TeammemberSummaryDetailsModel
 */
export interface TeammemberSummaryDetailsModel {
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'FirstName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TeammemberSummaryDetailsModel
     */
    'PaymentMethodType'?: number;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'LastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'Mobile'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'NickName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberSummaryDetailsModel
     */
    'HasActiveCommitment'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberSummaryDetailsModel
     */
    'IsLinemanager'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'LinemanagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberSummaryDetailsModel
     */
    'UserAccountsId'?: string;
}
/**
 * 
 * @export
 * @interface TeammemberWithVmDetails
 */
export interface TeammemberWithVmDetails {
    /**
     * 
     * @type {Array<DailyTotalWork>}
     * @memberof TeammemberWithVmDetails
     */
    'ActivityWatchDetails'?: Array<DailyTotalWork>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'TimeZone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberWithVmDetails
     */
    'IsCommitmentTimezone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentAdminApproval'?: TeammemberWithVmDetailsCommitmentAdminApprovalEnum;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentCustomerApproval'?: TeammemberWithVmDetailsCommitmentCustomerApprovalEnum;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentPositionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentTeammemberApproval'?: TeammemberWithVmDetailsCommitmentTeammemberApprovalEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberWithVmDetails
     */
    'CommitmentTimesheetProcessing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberWithVmDetails
     */
    'HaveUpcomingCommitment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberWithVmDetails
     */
    'IsCommitmentExpired'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'JobRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'JobTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'Name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeammemberWithVmDetails
     */
    'NearToExpire'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'PhotoUrl'?: string;
    /**
     * 
     * @type {Array<DailyTotalWork>}
     * @memberof TeammemberWithVmDetails
     */
    'TimesheetDetails'?: Array<DailyTotalWork>;
    /**
     * 
     * @type {string}
     * @memberof TeammemberWithVmDetails
     */
    'VmId'?: string;
    /**
     * 
     * @type {Array<VmMonitorDetail>}
     * @memberof TeammemberWithVmDetails
     */
    'VmMonitorDetails'?: Array<VmMonitorDetail>;
    /**
     * 
     * @type {Array<VmUsageDetail>}
     * @memberof TeammemberWithVmDetails
     */
    'VmUsage'?: Array<VmUsageDetail>;
}

export const TeammemberWithVmDetailsCommitmentAdminApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type TeammemberWithVmDetailsCommitmentAdminApprovalEnum = typeof TeammemberWithVmDetailsCommitmentAdminApprovalEnum[keyof typeof TeammemberWithVmDetailsCommitmentAdminApprovalEnum];
export const TeammemberWithVmDetailsCommitmentCustomerApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type TeammemberWithVmDetailsCommitmentCustomerApprovalEnum = typeof TeammemberWithVmDetailsCommitmentCustomerApprovalEnum[keyof typeof TeammemberWithVmDetailsCommitmentCustomerApprovalEnum];
export const TeammemberWithVmDetailsCommitmentTeammemberApprovalEnum = {
    Pending: 'Pending',
    ApprovedExplicit: 'ApprovedExplicit',
    ApprovedInherited: 'ApprovedInherited',
    Rejected: 'Rejected'
} as const;

export type TeammemberWithVmDetailsCommitmentTeammemberApprovalEnum = typeof TeammemberWithVmDetailsCommitmentTeammemberApprovalEnum[keyof typeof TeammemberWithVmDetailsCommitmentTeammemberApprovalEnum];

/**
 * 
 * @export
 * @interface TechnologyModel
 */
export interface TechnologyModel {
    /**
     * 
     * @type {string}
     * @memberof TechnologyModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyModel
     */
    'Value'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologyModel
     */
    'ActivityIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TechnologyReport
 */
export interface TechnologyReport {
    /**
     * 
     * @type {string}
     * @memberof TechnologyReport
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyReport
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TechnologyReport
     */
    'netEffort'?: number;
}
/**
 * 
 * @export
 * @interface TextValueModel
 */
export interface TextValueModel {
    /**
     * 
     * @type {string}
     * @memberof TextValueModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueModel
     */
    'Cat'?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueModel
     */
    'Text'?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueModel
     */
    'Value'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetCommitModel
 */
export interface TimesheetCommitModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetCommitModel
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetCommitModel
     */
    'linesAdded'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetCommitModel
     */
    'linesChanged'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetCommitModel
     */
    'linesDeleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetCommitModel
     */
    'messageShort'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetCommitModel
     */
    'hash'?: string;
    /**
     * 
     * @type {object}
     * @memberof TimesheetCommitModel
     */
    'date'?: object;
}
/**
 * 
 * @export
 * @interface TimesheetCommitmentModel
 */
export interface TimesheetCommitmentModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetCommitmentModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetCommitmentModel
     */
    'Name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetCommitmentModel
     */
    'HoursPerWeekMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetCommitmentModel
     */
    'HoursPerWeekMin'?: number;
}
/**
 * 
 * @export
 * @interface TimesheetDetailResponseModel
 */
export interface TimesheetDetailResponseModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'Date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'ActivityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'Description'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetDetailResponseModel
     */
    'Effort'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'Epic'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetDetailResponseModel
     */
    'Adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetDetailResponseModel
     */
    'EffortWithAdjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'IssueNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'TechnologyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetDetailResponseModel
     */
    'IsLocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetDetailResponseModel
     */
    'Message'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetEvaluationModel
 */
export interface TimesheetEvaluationModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetEvaluationModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetEvaluationModel
     */
    'timesheetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEvaluationModel
     */
    'evaluationScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetEvaluationModel
     */
    'predictedScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetEvaluationModel
     */
    'descriptionLabel'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetModel
 */
export interface TimesheetModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'Activity'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'ActivityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {TimesheetCommitmentModel}
     * @memberof TimesheetModel
     */
    'Commitment'?: TimesheetCommitmentModel;
    /**
     * 
     * @type {object}
     * @memberof TimesheetModel
     */
    'Date'?: object;
    /**
     * 
     * @type {object}
     * @memberof TimesheetModel
     */
    'DateLink'?: object;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'Epic'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetModel
     */
    'Effort'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetModel
     */
    'Adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetModel
     */
    'EffortWithAdjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'IssueNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {TimesheetProjectModel}
     * @memberof TimesheetModel
     */
    'Project'?: TimesheetProjectModel;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetModel
     */
    'QA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'Reppsitory'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetModel
     */
    'Sort'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'Technology'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'TechnologyId'?: string;
    /**
     * 
     * @type {Array<TimesheetCommitModel>}
     * @memberof TimesheetModel
     */
    'Commits'?: Array<TimesheetCommitModel>;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetModel
     */
    'isLocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetModel
     */
    'TeammemberName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetModel
     */
    'PredictedLabel'?: number;
}
/**
 * 
 * @export
 * @interface TimesheetProjectModel
 */
export interface TimesheetProjectModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetProjectModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetProjectModel
     */
    'Name'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetReactionRequest
 */
export interface TimesheetReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof TimesheetReactionRequest
     */
    'creatorUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReactionRequest
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReactionRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReactionRequest
     */
    'timesheetId'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetReportRequestModel
 */
export interface TimesheetReportRequestModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportRequestModel
     */
    'projectLeadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportRequestModel
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface TimesheetReportResponseVM
 */
export interface TimesheetReportResponseVM {
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'Activity'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'ActivityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'CommitmentId'?: string;
    /**
     * 
     * @type {TimesheetCommitmentModel}
     * @memberof TimesheetReportResponseVM
     */
    'Commitment'?: TimesheetCommitmentModel;
    /**
     * 
     * @type {object}
     * @memberof TimesheetReportResponseVM
     */
    'Date'?: object;
    /**
     * 
     * @type {object}
     * @memberof TimesheetReportResponseVM
     */
    'DateLink'?: object;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'Epic'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetReportResponseVM
     */
    'Effort'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetReportResponseVM
     */
    'Adjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimesheetReportResponseVM
     */
    'EffortWithAdjustment'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'IssueNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'ProjectId'?: string;
    /**
     * 
     * @type {TimesheetProjectModel}
     * @memberof TimesheetReportResponseVM
     */
    'Project'?: TimesheetProjectModel;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetReportResponseVM
     */
    'QA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'Reppsitory'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetReportResponseVM
     */
    'Sort'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'TeamMemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'Technology'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'TechnologyId'?: string;
    /**
     * 
     * @type {Array<TimesheetCommitModel>}
     * @memberof TimesheetReportResponseVM
     */
    'Commits'?: Array<TimesheetCommitModel>;
    /**
     * 
     * @type {boolean}
     * @memberof TimesheetReportResponseVM
     */
    'isLocked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TimesheetReportResponseVM
     */
    'TeammemberName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TimesheetReportResponseVM
     */
    'PredictedLabel'?: number;
}
/**
 * 
 * @export
 * @interface TimesheetRequestModel
 */
export interface TimesheetRequestModel {
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'linemanagerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'teammemberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'commitmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimesheetRequestModel
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface TmRoadMapModel
 */
export interface TmRoadMapModel {
    /**
     * 
     * @type {number}
     * @memberof TmRoadMapModel
     */
    'Duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof TmRoadMapModel
     */
    'ProcessPercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TmRoadMapModel
     */
    'StartedByTM'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TmRoadMapModel
     */
    'Description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TmRoadMapModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TmRoadMapModel
     */
    'Status'?: string;
    /**
     * 
     * @type {Array<RoadMapStepModel>}
     * @memberof TmRoadMapModel
     */
    'Steps'?: Array<RoadMapStepModel>;
    /**
     * 
     * @type {Array<RoadMapTalentModel>}
     * @memberof TmRoadMapModel
     */
    'Talents'?: Array<RoadMapTalentModel>;
    /**
     * 
     * @type {string}
     * @memberof TmRoadMapModel
     */
    'Title'?: string;
}
/**
 * 
 * @export
 * @interface TrialBalanceReportItem
 */
export interface TrialBalanceReportItem {
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceReportItem
     */
    'accountId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceReportItem
     */
    'accountName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceReportItem
     */
    'accountCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceReportItem
     */
    'accountType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceReportItem
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrialBalanceReportItem
     */
    'totalDebit'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialBalanceReportItem
     */
    'totalCredit'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialBalanceReportItem
     */
    'balance'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialBalanceReportItem
     */
    'totalBalance'?: number;
}
/**
 * 
 * @export
 * @interface TrialBalanceRequest
 */
export interface TrialBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceRequest
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceRequest
     */
    'sortProperty'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialBalanceRequest
     */
    'sortOrder'?: string;
}
/**
 * 
 * @export
 * @interface UpdateAdjustmentRequestModel
 */
export interface UpdateAdjustmentRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdjustmentRequestModel
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdjustmentRequestModel
     */
    'adjustment'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCommitmentStatusRequestModel
 */
export interface UpdateCommitmentStatusRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommitmentStatusRequestModel
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommitmentStatusRequestModel
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCourseStepStateRequestModel
 */
export interface UpdateCourseStepStateRequestModel {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCourseStepStateRequestModel
     */
    'isComplete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourseStepStateRequestModel
     */
    'roadMapId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCourseStepStateRequestModel
     */
    'stepId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateRoadMapStatusRequestModel
 */
export interface UpdateRoadMapStatusRequestModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoadMapStatusRequestModel
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoadMapStatusRequestModel
     */
    'status'?: UpdateRoadMapStatusRequestModelStatusEnum;
}

export const UpdateRoadMapStatusRequestModelStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type UpdateRoadMapStatusRequestModelStatusEnum = typeof UpdateRoadMapStatusRequestModelStatusEnum[keyof typeof UpdateRoadMapStatusRequestModelStatusEnum];

/**
 * 
 * @export
 * @interface UpdateRoleAndTitleRequestModel
 */
export interface UpdateRoleAndTitleRequestModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateRoleAndTitleRequestModel
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleAndTitleRequestModel
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface UploadFileRequestModel
 */
export interface UploadFileRequestModel {
    /**
     * 
     * @type {object}
     * @memberof UploadFileRequestModel
     */
    'file'?: object;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'localId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'federatedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'photoUrl'?: string;
}
/**
 * 
 * @export
 * @interface UserDevices
 */
export interface UserDevices {
    /**
     * 
     * @type {number}
     * @memberof UserDevices
     */
    'DeviceType'?: UserDevicesDeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDevices
     */
    'FirebaseToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDevices
     */
    'Model'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDevices
     */
    'Active'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof UserDevices
     */
    'CreationDate'?: object;
}

export const UserDevicesDeviceTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type UserDevicesDeviceTypeEnum = typeof UserDevicesDeviceTypeEnum[keyof typeof UserDevicesDeviceTypeEnum];

/**
 * 
 * @export
 * @interface UserMetadata
 */
export interface UserMetadata {
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    'creationTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    'lastSignInTimestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadata
     */
    'lastRefreshTimestamp'?: string;
}
/**
 * 
 * @export
 * @interface UserModel
 */
export interface UserModel {
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserModel
     */
    'role'?: string;
    /**
     * 
     * @type {Array<UserDevices>}
     * @memberof UserModel
     */
    'Devices'?: Array<UserDevices>;
    /**
     * 
     * @type {object}
     * @memberof UserModel
     */
    'creationDate'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UserModel
     */
    'isVerified'?: boolean;
}
/**
 * 
 * @export
 * @interface UserOfNotification
 */
export interface UserOfNotification {
    /**
     * 
     * @type {string}
     * @memberof UserOfNotification
     */
    'Status'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserOfNotification
     */
    'UserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserOfNotification
     */
    'UserFullName'?: string;
}
/**
 * 
 * @export
 * @interface UserRecord
 */
export interface UserRecord {
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'uid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'photoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'providerId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserRecord
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserRecord
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {Array<IUserInfo>}
     * @memberof UserRecord
     */
    'providerData'?: Array<IUserInfo>;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'tokensValidAfterTimestamp'?: string;
    /**
     * 
     * @type {UserMetadata}
     * @memberof UserRecord
     */
    'userMetaData'?: UserMetadata;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof UserRecord
     */
    'customClaims'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'tenantId'?: string;
}
/**
 * 
 * @export
 * @interface ValidateResetPasswordRequestModel
 */
export interface ValidateResetPasswordRequestModel {
    /**
     * 
     * @type {string}
     * @memberof ValidateResetPasswordRequestModel
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface VerifyUserRequestModel
 */
export interface VerifyUserRequestModel {
    /**
     * 
     * @type {string}
     * @memberof VerifyUserRequestModel
     */
    'callbackUrl': string;
}
/**
 * 
 * @export
 * @interface VirtualDesktopSpec
 */
export interface VirtualDesktopSpec {
    /**
     * 
     * @type {boolean}
     * @memberof VirtualDesktopSpec
     */
    'AdditionalSecurityBL'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualDesktopSpec
     */
    'AdditionalSecurityNG'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VirtualDesktopSpec
     */
    'Cpu'?: number;
    /**
     * 
     * @type {number}
     * @memberof VirtualDesktopSpec
     */
    'Disk'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VirtualDesktopSpec
     */
    'Enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VirtualDesktopSpec
     */
    'Level'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualDesktopSpec
     */
    'Location'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualDesktopSpec
     */
    'OperatingSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof VirtualDesktopSpec
     */
    'Policy'?: string;
    /**
     * 
     * @type {number}
     * @memberof VirtualDesktopSpec
     */
    'Ram'?: number;
}
/**
 * 
 * @export
 * @interface VmActionLogResponseModel
 */
export interface VmActionLogResponseModel {
    /**
     * 
     * @type {string}
     * @memberof VmActionLogResponseModel
     */
    'UpdatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActionLogResponseModel
     */
    'EffectiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActionLogResponseModel
     */
    'NewStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActionLogResponseModel
     */
    'Comment'?: string;
}
/**
 * 
 * @export
 * @interface VmActivitySummary
 */
export interface VmActivitySummary {
    /**
     * 
     * @type {string}
     * @memberof VmActivitySummary
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmActivitySummary
     */
    'totalSecounds'?: number;
}
/**
 * 
 * @export
 * @interface VmActivityWatchItem
 */
export interface VmActivityWatchItem {
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'userFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmActivityWatchItem
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmActivityWatchItem
     */
    'durationExcludeAFK'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'stop'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'vmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchItem
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface VmActivityWatchModel
 */
export interface VmActivityWatchModel {
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchModel
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchModel
     */
    'vmName'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmActivityWatchModel
     */
    'totalSecounds'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmActivityWatchModel
     */
    'totalSecoundsIncludeAFK'?: number;
    /**
     * 
     * @type {Array<VmActivitySummary>}
     * @memberof VmActivityWatchModel
     */
    'applications'?: Array<VmActivitySummary>;
    /**
     * 
     * @type {Array<VmActivitySummary>}
     * @memberof VmActivityWatchModel
     */
    'windowsTitles'?: Array<VmActivitySummary>;
    /**
     * 
     * @type {Array<VmActivitySummary>}
     * @memberof VmActivityWatchModel
     */
    'browserDomains'?: Array<VmActivitySummary>;
    /**
     * 
     * @type {Array<VmActivitySummary>}
     * @memberof VmActivityWatchModel
     */
    'categories'?: Array<VmActivitySummary>;
    /**
     * 
     * @type {Array<VmActivityWatchItem>}
     * @memberof VmActivityWatchModel
     */
    'activities'?: Array<VmActivityWatchItem>;
}
/**
 * 
 * @export
 * @interface VmActivityWatchReport
 */
export interface VmActivityWatchReport {
    /**
     * 
     * @type {string}
     * @memberof VmActivityWatchReport
     */
    'timeZone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VmActivityWatchReport
     */
    'isCommitmentTimezone'?: boolean;
    /**
     * 
     * @type {Array<VmActivityWatchItem>}
     * @memberof VmActivityWatchReport
     */
    'afkActivities'?: Array<VmActivityWatchItem>;
    /**
     * 
     * @type {Array<VmActivityWatchItem>}
     * @memberof VmActivityWatchReport
     */
    'windowActivities'?: Array<VmActivityWatchItem>;
    /**
     * 
     * @type {VmActivityWatchModel}
     * @memberof VmActivityWatchReport
     */
    'summary'?: VmActivityWatchModel;
    /**
     * 
     * @type {Array<DailyTotalWork>}
     * @memberof VmActivityWatchReport
     */
    'dailyTotalWork'?: Array<DailyTotalWork>;
}
/**
 * 
 * @export
 * @interface VmLastPushedDataResponse
 */
export interface VmLastPushedDataResponse {
    /**
     * 
     * @type {number}
     * @memberof VmLastPushedDataResponse
     */
    'lastAFKId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmLastPushedDataResponse
     */
    'lastWindowId'?: number;
}
/**
 * 
 * @export
 * @interface VmLoginResponse
 */
export interface VmLoginResponse {
    /**
     * 
     * @type {string}
     * @memberof VmLoginResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmLoginResponse
     */
    'publicIP'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmLoginResponse
     */
    'remotePortRdp'?: number;
}
/**
 * 
 * @export
 * @interface VmModel
 */
export interface VmModel {
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'ActivitiyAgentRequired'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'Activitywatch'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'AdditionalSecurity'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'AdminAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'CodeClanAgent'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VmModel
     */
    'CPU'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'CustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Decomissioned'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'GuestAgentRquired'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Location'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Note'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'OperatingSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'OsName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'OwnerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'TempPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'PanelName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'PrivateIP'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'ProvisionedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'PublicIP'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmModel
     */
    'RAM'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmModel
     */
    'RemotePortRdp'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'SecurityAgentRequired'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'SecurityLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'SecurityPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Status'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmModel
     */
    'Storage'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'Username'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'VmCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VmModel
     */
    'WazuhAgent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'WazuhAgentId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VmModel
     */
    'WazuhLevel'?: Array<string>;
    /**
     * 
     * @type {Array<CommitmentModel>}
     * @memberof VmModel
     */
    'ReleatedCommitments'?: Array<CommitmentModel>;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'MostRecentCommitmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'ReleatedCommitmentsFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmModel
     */
    'WazuhPolicyId'?: string;
}
/**
 * 
 * @export
 * @interface VmMonitorDetail
 */
export interface VmMonitorDetail {
    /**
     * 
     * @type {string}
     * @memberof VmMonitorDetail
     */
    'Date'?: string;
    /**
     * 
     * @type {Array<VmMonitorTimeDetail>}
     * @memberof VmMonitorDetail
     */
    'TimeDetail'?: Array<VmMonitorTimeDetail>;
}
/**
 * 
 * @export
 * @interface VmMonitorTimeDetail
 */
export interface VmMonitorTimeDetail {
    /**
     * 
     * @type {string}
     * @memberof VmMonitorTimeDetail
     */
    'Time'?: string;
    /**
     * 
     * @type {number}
     * @memberof VmMonitorTimeDetail
     */
    'Latency'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VmMonitorTimeDetail
     */
    'Status'?: boolean;
}
/**
 * 
 * @export
 * @interface VmPushActivityWatchEvent
 */
export interface VmPushActivityWatchEvent {
    /**
     * 
     * @type {number}
     * @memberof VmPushActivityWatchEvent
     */
    'eventId'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmPushActivityWatchEvent
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmPushActivityWatchEvent
     */
    'durationExcludeAFK'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEvent
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEvent
     */
    'stop'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEvent
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEvent
     */
    'type'?: string;
    /**
     * 
     * @type {VmPushActivityWatchEventData}
     * @memberof VmPushActivityWatchEvent
     */
    'data'?: VmPushActivityWatchEventData;
}
/**
 * 
 * @export
 * @interface VmPushActivityWatchEventData
 */
export interface VmPushActivityWatchEventData {
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEventData
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEventData
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchEventData
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface VmPushActivityWatchRequestModel
 */
export interface VmPushActivityWatchRequestModel {
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchRequestModel
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchRequestModel
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmPushActivityWatchRequestModel
     */
    'version'?: string;
    /**
     * 
     * @type {VmResourceUtilizationRequestModel}
     * @memberof VmPushActivityWatchRequestModel
     */
    'vmResourceUtilizationRequestModel'?: VmResourceUtilizationRequestModel;
    /**
     * 
     * @type {Array<VmPushActivityWatchEvent>}
     * @memberof VmPushActivityWatchRequestModel
     */
    'events'?: Array<VmPushActivityWatchEvent>;
}
/**
 * 
 * @export
 * @interface VmResourceUtilizationRequestModel
 */
export interface VmResourceUtilizationRequestModel {
    /**
     * 
     * @type {string}
     * @memberof VmResourceUtilizationRequestModel
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmResourceUtilizationRequestModel
     */
    'cpu'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmResourceUtilizationRequestModel
     */
    'memory'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmResourceUtilizationRequestModel
     */
    'disk'?: string;
}
/**
 * 
 * @export
 * @interface VmSecurityPolicyResponse
 */
export interface VmSecurityPolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPolicyResponse
     */
    'wazuhAgentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPolicyResponse
     */
    'wazuhPolicyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmSecurityPolicyResponse
     */
    'publicIP'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VmSecurityPolicyResponse
     */
    'wazuhLevel'?: Array<string>;
}
/**
 * 
 * @export
 * @interface VmSonarQubeResultRequest
 */
export interface VmSonarQubeResultRequest {
    /**
     * 
     * @type {string}
     * @memberof VmSonarQubeResultRequest
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {SonarQubeResultModel}
     * @memberof VmSonarQubeResultRequest
     */
    'solarCubeResultModel'?: SonarQubeResultModel;
}
/**
 * 
 * @export
 * @interface VmStatusRequestModel
 */
export interface VmStatusRequestModel {
    /**
     * 
     * @type {string}
     * @memberof VmStatusRequestModel
     */
    'EffectiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmStatusRequestModel
     */
    'VmId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmStatusRequestModel
     */
    'Status'?: string;
}
/**
 * 
 * @export
 * @interface VmUsageDetail
 */
export interface VmUsageDetail {
    /**
     * 
     * @type {string}
     * @memberof VmUsageDetail
     */
    'Date'?: string;
    /**
     * 
     * @type {Array<VmUsageTimeDetail>}
     * @memberof VmUsageDetail
     */
    'TimeDetail'?: Array<VmUsageTimeDetail>;
}
/**
 * 
 * @export
 * @interface VmUsageTimeDetail
 */
export interface VmUsageTimeDetail {
    /**
     * 
     * @type {number}
     * @memberof VmUsageTimeDetail
     */
    'Cpu'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmUsageTimeDetail
     */
    'Disk'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmUsageTimeDetail
     */
    'Memory'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmUsageTimeDetail
     */
    'Time'?: string;
}
/**
 * 
 * @export
 * @interface VmWazuhModel
 */
export interface VmWazuhModel {
    /**
     * 
     * @type {number}
     * @memberof VmWazuhModel
     */
    'passed'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmWazuhModel
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmWazuhModel
     */
    'notApplicable'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmWazuhModel
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof VmWazuhModel
     */
    'checks'?: number;
    /**
     * 
     * @type {string}
     * @memberof VmWazuhModel
     */
    'endScan'?: string;
    /**
     * 
     * @type {Array<WazuhRequestModel>}
     * @memberof VmWazuhModel
     */
    'items'?: Array<WazuhRequestModel>;
}
/**
 * 
 * @export
 * @interface VmWazuhRequestModel
 */
export interface VmWazuhRequestModel {
    /**
     * 
     * @type {string}
     * @memberof VmWazuhRequestModel
     */
    'wazuhId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmWazuhRequestModel
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmWazuhRequestModel
     */
    'wazuhAgentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VmWazuhRequestModel
     */
    'publicIp'?: string;
}
/**
 * 
 * @export
 * @interface WazuhComplianceModel
 */
export interface WazuhComplianceModel {
    /**
     * 
     * @type {string}
     * @memberof WazuhComplianceModel
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhComplianceModel
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface WazuhRequestModel
 */
export interface WazuhRequestModel {
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'wazuhId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'command'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'rationale'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'policyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'remediation'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRequestModel
     */
    'createdAt'?: string;
    /**
     * 
     * @type {Array<WazuhComplianceModel>}
     * @memberof WazuhRequestModel
     */
    'compliance'?: Array<WazuhComplianceModel>;
    /**
     * 
     * @type {Array<WazuhRuleModel>}
     * @memberof WazuhRequestModel
     */
    'rules'?: Array<WazuhRuleModel>;
}
/**
 * 
 * @export
 * @interface WazuhRuleModel
 */
export interface WazuhRuleModel {
    /**
     * 
     * @type {string}
     * @memberof WazuhRuleModel
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof WazuhRuleModel
     */
    'rule'?: string;
}
/**
 * 
 * @export
 * @interface WeekOfPayRunItem
 */
export interface WeekOfPayRunItem {
    /**
     * 
     * @type {string}
     * @memberof WeekOfPayRunItem
     */
    'FromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeekOfPayRunItem
     */
    'ToDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof WeekOfPayRunItem
     */
    'Hours'?: number;
}
/**
 * 
 * @export
 * @interface WeeklyReport
 */
export interface WeeklyReport {
    /**
     * 
     * @type {string}
     * @memberof WeeklyReport
     */
    'week'?: string;
    /**
     * 
     * @type {Array<TimesheetModel>}
     * @memberof WeeklyReport
     */
    'timesheets'?: Array<TimesheetModel>;
}
/**
 * 
 * @export
 * @interface WeeklyTimesheetAuditModel
 */
export interface WeeklyTimesheetAuditModel {
    /**
     * 
     * @type {string}
     * @memberof WeeklyTimesheetAuditModel
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyTimesheetAuditModel
     */
    'CommitmentID'?: string;
    /**
     * 
     * @type {object}
     * @memberof WeeklyTimesheetAuditModel
     */
    'WeekStartDate'?: object;
    /**
     * 
     * @type {string}
     * @memberof WeeklyTimesheetAuditModel
     */
    'ApprovedBy'?: string;
    /**
     * 
     * @type {object}
     * @memberof WeeklyTimesheetAuditModel
     */
    'ApprovedOn'?: object;
    /**
     * 
     * @type {number}
     * @memberof WeeklyTimesheetAuditModel
     */
    'SumOfHours'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyTimesheetAuditModel
     */
    'Revoked'?: boolean;
}
/**
 * 
 * @export
 * @interface WiseAccountModel
 */
export interface WiseAccountModel {
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'FullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'Email'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'BankName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'AccountNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'SwiftCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'Country'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'City'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'RecipientAddress'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WiseAccountModel
     */
    'IsDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'PostCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof WiseAccountModel
     */
    'CreatedAt'?: string;
}

/**
 * AccessApi - axios parameter creator
 * @export
 */
export const AccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccessModel} body Don\&#39;t fill id to Create new Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccess: async (body: AccessModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createAccess', 'body', body)
            const localVarPath = `/V1/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Access List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListByCustomerId: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getListByCustomerId', 'customerId', customerId)
            const localVarPath = `/V1/access/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body grant access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess: async (body: GrantRevokeAccessModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('grantAccess', 'body', body)
            const localVarPath = `/V1/access/grant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body revoke access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess: async (body: GrantRevokeAccessModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('revokeAccess', 'body', body)
            const localVarPath = `/V1/access/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessApi - functional programming interface
 * @export
 */
export const AccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AccessModel} body Don\&#39;t fill id to Create new Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccess(body: AccessModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccess(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.createAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.getList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Access List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListByCustomerId(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListByCustomerId(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.getListByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body grant access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAccess(body: GrantRevokeAccessModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAccess(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.grantAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body revoke access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAccess(body: GrantRevokeAccessModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAccess(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.revokeAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessApi - factory interface
 * @export
 */
export const AccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessApiFp(configuration)
    return {
        /**
         * 
         * @param {AccessModel} body Don\&#39;t fill id to Create new Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccess(body: AccessModel, options?: any): AxiosPromise<string> {
            return localVarFp.createAccess(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getList(options?: any): AxiosPromise<string> {
            return localVarFp.getList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Access List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListByCustomerId(customerId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getListByCustomerId(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body grant access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccess(body: GrantRevokeAccessModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.grantAccess(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GrantRevokeAccessModel} body revoke access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAccess(body: GrantRevokeAccessModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.revokeAccess(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccessApi - object-oriented interface
 * @export
 * @class AccessApi
 * @extends {BaseAPI}
 */
export class AccessApi extends BaseAPI {
    /**
     * 
     * @param {AccessModel} body Don\&#39;t fill id to Create new Access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public createAccess(body: AccessModel, options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).createAccess(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public getList(options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).getList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId Send CustomerId to Customer Access List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public getListByCustomerId(customerId: string, options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).getListByCustomerId(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GrantRevokeAccessModel} body grant access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public grantAccess(body: GrantRevokeAccessModel, options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).grantAccess(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GrantRevokeAccessModel} body revoke access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public revokeAccess(body: GrantRevokeAccessModel, options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).revokeAccess(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActivityApi - axios parameter creator
 * @export
 */
export const ActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ActivityModel} body Will Create a new Activity(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addActivity: async (body: ActivityModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addActivity', 'body', body)
            const localVarPath = `/V1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActivityModel} body Will Update an existing Activity(id Required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity: async (body: ActivityModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateActivity', 'body', body)
            const localVarPath = `/V1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityApi - functional programming interface
 * @export
 */
export const ActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ActivityModel} body Will Create a new Activity(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addActivity(body: ActivityModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addActivity(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityApi.addActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityApi.getActivityList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActivityModel} body Will Update an existing Activity(id Required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivity(body: ActivityModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivity(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityApi.updateActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityApi - factory interface
 * @export
 */
export const ActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {ActivityModel} body Will Create a new Activity(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addActivity(body: ActivityModel, options?: any): AxiosPromise<ActivityModel> {
            return localVarFp.addActivity(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityList(options?: any): AxiosPromise<Array<ActivityModel>> {
            return localVarFp.getActivityList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ActivityModel} body Will Update an existing Activity(id Required)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(body: ActivityModel, options?: any): AxiosPromise<ActivityModel> {
            return localVarFp.updateActivity(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityApi - object-oriented interface
 * @export
 * @class ActivityApi
 * @extends {BaseAPI}
 */
export class ActivityApi extends BaseAPI {
    /**
     * 
     * @param {ActivityModel} body Will Create a new Activity(don\&#39;t need id here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityApi
     */
    public addActivity(body: ActivityModel, options?: RawAxiosRequestConfig) {
        return ActivityApiFp(this.configuration).addActivity(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityApi
     */
    public getActivityList(options?: RawAxiosRequestConfig) {
        return ActivityApiFp(this.configuration).getActivityList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ActivityModel} body Will Update an existing Activity(id Required)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityApi
     */
    public updateActivity(body: ActivityModel, options?: RawAxiosRequestConfig) {
        return ActivityApiFp(this.configuration).updateActivity(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentApi - axios parameter creator
 * @export
 */
export const AssessmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssessmentModel} body To Create a new Assessment don\&#39;t set the id in request model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment: async (body: AssessmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addAssessment', 'body', body)
            const localVarPath = `/V1/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentByTeammemberId: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssessmentByTeammemberId', 'id', id)
            const localVarPath = `/V1/assessments/teammembers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Assessment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssessment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeAssessment', 'id', id)
            const localVarPath = `/V1/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentApi - functional programming interface
 * @export
 */
export const AssessmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssessmentModel} body To Create a new Assessment don\&#39;t set the id in request model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAssessment(body: AssessmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAssessment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.addAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentByTeammemberId(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentByTeammemberId(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.getAssessmentByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.getAssessmentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Assessment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAssessment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAssessment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentApi.removeAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentApi - factory interface
 * @export
 */
export const AssessmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentApiFp(configuration)
    return {
        /**
         * 
         * @param {AssessmentModel} body To Create a new Assessment don\&#39;t set the id in request model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssessment(body: AssessmentModel, options?: any): AxiosPromise<ActivityModel> {
            return localVarFp.addAssessment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentByTeammemberId(id: string, options?: any): AxiosPromise<Array<AssessmentModel>> {
            return localVarFp.getAssessmentByTeammemberId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentList(options?: any): AxiosPromise<Array<AssessmentModel>> {
            return localVarFp.getAssessmentList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Assessment Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssessment(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeAssessment(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentApi - object-oriented interface
 * @export
 * @class AssessmentApi
 * @extends {BaseAPI}
 */
export class AssessmentApi extends BaseAPI {
    /**
     * 
     * @param {AssessmentModel} body To Create a new Assessment don\&#39;t set the id in request model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public addAssessment(body: AssessmentModel, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).addAssessment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public getAssessmentByTeammemberId(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).getAssessmentByTeammemberId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public getAssessmentList(options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).getAssessmentList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Assessment Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public removeAssessment(id: string, options?: RawAxiosRequestConfig) {
        return AssessmentApiFp(this.configuration).removeAssessment(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditTrailApi - axios parameter creator
 * @export
 */
export const AuditTrailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailList: async (recordTypeId: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordTypeId' is not null or undefined
            assertParamExists('getAuditTrailList', 'recordTypeId', recordTypeId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAuditTrailList', 'type', type)
            const localVarPath = `/V1/audittrail/getListByDateRange`
                .replace(`{${"recordTypeId"}}`, encodeURIComponent(String(recordTypeId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListByType: async (recordTypeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordTypeId' is not null or undefined
            assertParamExists('getAuditTrailListByType', 'recordTypeId', recordTypeId)
            const localVarPath = `/V1/audittrail/payrun/{recordTypeId}`
                .replace(`{${"recordTypeId"}}`, encodeURIComponent(String(recordTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} teammemberId Send Team member Id to get the PayRun\&#39;s AuditTrail list. Default is -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListByTypeAdmin: async (recordTypeId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordTypeId' is not null or undefined
            assertParamExists('getAuditTrailListByTypeAdmin', 'recordTypeId', recordTypeId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getAuditTrailListByTypeAdmin', 'teammemberId', teammemberId)
            const localVarPath = `/V1/audittrail/payrun/admin/{recordTypeId}/{teammemberId}`
                .replace(`{${"recordTypeId"}}`, encodeURIComponent(String(recordTypeId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListForAdmin: async (recordTypeId: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordTypeId' is not null or undefined
            assertParamExists('getAuditTrailListForAdmin', 'recordTypeId', recordTypeId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAuditTrailListForAdmin', 'type', type)
            const localVarPath = `/V1/audittrail/getList`
                .replace(`{${"recordTypeId"}}`, encodeURIComponent(String(recordTypeId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAuditTrail: async (body: AuditTrailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveAuditTrail', 'body', body)
            const localVarPath = `/V1/audittrail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAuditTrailForAdmin: async (body: AuditTrailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveAuditTrailForAdmin', 'body', body)
            const localVarPath = `/V1/audittrail/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditTrailApi - functional programming interface
 * @export
 */
export const AuditTrailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditTrailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrailList(recordTypeId: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrailList(recordTypeId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAuditTrailList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrailListByType(recordTypeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrailListByType(recordTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAuditTrailListByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} teammemberId Send Team member Id to get the PayRun\&#39;s AuditTrail list. Default is -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrailListByTypeAdmin(recordTypeId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrailListByTypeAdmin(recordTypeId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAuditTrailListByTypeAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrailListForAdmin(recordTypeId: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrailModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrailListForAdmin(recordTypeId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.getAuditTrailListForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAuditTrail(body: AuditTrailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAuditTrail(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.saveAuditTrail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAuditTrailForAdmin(body: AuditTrailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAuditTrailForAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditTrailApi.saveAuditTrailForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditTrailApi - factory interface
 * @export
 */
export const AuditTrailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditTrailApiFp(configuration)
    return {
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailList(recordTypeId: string, type: string, options?: any): AxiosPromise<Array<AuditTrailModel>> {
            return localVarFp.getAuditTrailList(recordTypeId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListByType(recordTypeId: string, options?: any): AxiosPromise<Array<AuditTrailModel>> {
            return localVarFp.getAuditTrailListByType(recordTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} teammemberId Send Team member Id to get the PayRun\&#39;s AuditTrail list. Default is -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListByTypeAdmin(recordTypeId: string, teammemberId: string, options?: any): AxiosPromise<Array<AuditTrailModel>> {
            return localVarFp.getAuditTrailListByTypeAdmin(recordTypeId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
         * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrailListForAdmin(recordTypeId: string, type: string, options?: any): AxiosPromise<Array<AuditTrailModel>> {
            return localVarFp.getAuditTrailListForAdmin(recordTypeId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAuditTrail(body: AuditTrailModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.saveAuditTrail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuditTrailModel} body Audit Trail Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAuditTrailForAdmin(body: AuditTrailModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.saveAuditTrailForAdmin(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditTrailApi - object-oriented interface
 * @export
 * @class AuditTrailApi
 * @extends {BaseAPI}
 */
export class AuditTrailApi extends BaseAPI {
    /**
     * 
     * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
     * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public getAuditTrailList(recordTypeId: string, type: string, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAuditTrailList(recordTypeId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public getAuditTrailListByType(recordTypeId: string, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAuditTrailListByType(recordTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
     * @param {string} teammemberId Send Team member Id to get the PayRun\&#39;s AuditTrail list. Default is -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public getAuditTrailListByTypeAdmin(recordTypeId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAuditTrailListByTypeAdmin(recordTypeId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} recordTypeId Send PayRun Id to get the PayRun\&#39;s AuditTrail list
     * @param {string} type Send type to get the that record type\&#39;s AuditTrail list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public getAuditTrailListForAdmin(recordTypeId: string, type: string, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).getAuditTrailListForAdmin(recordTypeId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditTrailModel} body Audit Trail Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public saveAuditTrail(body: AuditTrailModel, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).saveAuditTrail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuditTrailModel} body Audit Trail Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditTrailApi
     */
    public saveAuditTrailForAdmin(body: AuditTrailModel, options?: RawAxiosRequestConfig) {
        return AuditTrailApiFp(this.configuration).saveAuditTrailForAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthorApi - axios parameter creator
 * @export
 */
export const AuthorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorList: async (linemanagerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('getAuthorList', 'linemanagerId', linemanagerId)
            const localVarPath = `/V1/authors/{linemanagerId}`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorListAdmin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/authors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} linemanagerId Send id to ignore ahthor to show for it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreAuthor: async (linemanagerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('ignoreAuthor', 'linemanagerId', linemanagerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ignoreAuthor', 'id', id)
            const localVarPath = `/V1/authors/{id}/{linemanagerId}/ignore`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {AuthorModel} body Fill Author to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthor: async (linemanagerId: string, body: AuthorModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('updateAuthor', 'linemanagerId', linemanagerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateAuthor', 'body', body)
            const localVarPath = `/V1/authors/{linemanagerId}`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorApi - functional programming interface
 * @export
 */
export const AuthorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorList(linemanagerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthorModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorList(linemanagerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorApi.getAuthorList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorListAdmin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthorModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorListAdmin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorApi.getAuthorListAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} linemanagerId Send id to ignore ahthor to show for it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreAuthor(linemanagerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreAuthor(linemanagerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorApi.ignoreAuthor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {AuthorModel} body Fill Author to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuthor(linemanagerId: string, body: AuthorModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuthor(linemanagerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorApi.updateAuthor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorApi - factory interface
 * @export
 */
export const AuthorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorApiFp(configuration)
    return {
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorList(linemanagerId: string, options?: any): AxiosPromise<Array<AuthorModel>> {
            return localVarFp.getAuthorList(linemanagerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorListAdmin(options?: any): AxiosPromise<Array<AuthorModel>> {
            return localVarFp.getAuthorListAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} linemanagerId Send id to ignore ahthor to show for it
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreAuthor(linemanagerId: string, id: string, options?: any): AxiosPromise<string> {
            return localVarFp.ignoreAuthor(linemanagerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} linemanagerId Send id to get specific Line Manager
         * @param {AuthorModel} body Fill Author to Update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuthor(linemanagerId: string, body: AuthorModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateAuthor(linemanagerId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorApi - object-oriented interface
 * @export
 * @class AuthorApi
 * @extends {BaseAPI}
 */
export class AuthorApi extends BaseAPI {
    /**
     * 
     * @param {string} linemanagerId Send id to get specific Line Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorApi
     */
    public getAuthorList(linemanagerId: string, options?: RawAxiosRequestConfig) {
        return AuthorApiFp(this.configuration).getAuthorList(linemanagerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorApi
     */
    public getAuthorListAdmin(options?: RawAxiosRequestConfig) {
        return AuthorApiFp(this.configuration).getAuthorListAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} linemanagerId Send id to ignore ahthor to show for it
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorApi
     */
    public ignoreAuthor(linemanagerId: string, id: string, options?: RawAxiosRequestConfig) {
        return AuthorApiFp(this.configuration).ignoreAuthor(linemanagerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} linemanagerId Send id to get specific Line Manager
     * @param {AuthorModel} body Fill Author to Update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorApi
     */
    public updateAuthor(linemanagerId: string, body: AuthorModel, options?: RawAxiosRequestConfig) {
        return AuthorApiFp(this.configuration).updateAuthor(linemanagerId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AzureAISearchApi - axios parameter creator
 * @export
 */
export const AzureAISearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeammemberByAdmin: async (body: AzureAISearchTeammemberRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('searchTeammemberByAdmin', 'body', body)
            const localVarPath = `/V1/admin-search/teammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeammemberByClient: async (body: AzureAISearchTeammemberRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('searchTeammemberByClient', 'body', body)
            const localVarPath = `/V1/search/teammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AzureAISearchApi - functional programming interface
 * @export
 */
export const AzureAISearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AzureAISearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTeammemberByAdmin(body: AzureAISearchTeammemberRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AzureAISearchTeammemberByClientResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTeammemberByAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzureAISearchApi.searchTeammemberByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTeammemberByClient(body: AzureAISearchTeammemberRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientSearchTeammemberResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTeammemberByClient(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AzureAISearchApi.searchTeammemberByClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AzureAISearchApi - factory interface
 * @export
 */
export const AzureAISearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AzureAISearchApiFp(configuration)
    return {
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeammemberByAdmin(body: AzureAISearchTeammemberRequestModel, options?: any): AxiosPromise<Array<AzureAISearchTeammemberByClientResponseModel>> {
            return localVarFp.searchTeammemberByAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AzureAISearchTeammemberRequestModel} body text query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeammemberByClient(body: AzureAISearchTeammemberRequestModel, options?: any): AxiosPromise<Array<ClientSearchTeammemberResponseModel>> {
            return localVarFp.searchTeammemberByClient(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AzureAISearchApi - object-oriented interface
 * @export
 * @class AzureAISearchApi
 * @extends {BaseAPI}
 */
export class AzureAISearchApi extends BaseAPI {
    /**
     * 
     * @param {AzureAISearchTeammemberRequestModel} body text query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzureAISearchApi
     */
    public searchTeammemberByAdmin(body: AzureAISearchTeammemberRequestModel, options?: RawAxiosRequestConfig) {
        return AzureAISearchApiFp(this.configuration).searchTeammemberByAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AzureAISearchTeammemberRequestModel} body text query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AzureAISearchApi
     */
    public searchTeammemberByClient(body: AzureAISearchTeammemberRequestModel, options?: RawAxiosRequestConfig) {
        return AzureAISearchApiFp(this.configuration).searchTeammemberByClient(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BatchApi - axios parameter creator
 * @export
 */
export const BatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BatchModel} body Don\&#39;t fill id to Create new Batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBatch: async (body: BatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createBatch', 'body', body)
            const localVarPath = `/V1/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchApi - functional programming interface
 * @export
 */
export const BatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BatchModel} body Don\&#39;t fill id to Create new Batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBatch(body: BatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBatch(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BatchApi.createBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BatchApi - factory interface
 * @export
 */
export const BatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchApiFp(configuration)
    return {
        /**
         * 
         * @param {BatchModel} body Don\&#39;t fill id to Create new Batch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBatch(body: BatchModel, options?: any): AxiosPromise<string> {
            return localVarFp.createBatch(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchApi - object-oriented interface
 * @export
 * @class BatchApi
 * @extends {BaseAPI}
 */
export class BatchApi extends BaseAPI {
    /**
     * 
     * @param {BatchModel} body Don\&#39;t fill id to Create new Batch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    public createBatch(body: BatchModel, options?: RawAxiosRequestConfig) {
        return BatchApiFp(this.configuration).createBatch(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BatchesApi - axios parameter creator
 * @export
 */
export const BatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatches: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BatchesApi - functional programming interface
 * @export
 */
export const BatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatches(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BatchModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatches(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BatchesApi.getBatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BatchesApi - factory interface
 * @export
 */
export const BatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BatchesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatches(options?: any): AxiosPromise<Array<BatchModel>> {
            return localVarFp.getBatches(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BatchesApi - object-oriented interface
 * @export
 * @class BatchesApi
 * @extends {BaseAPI}
 */
export class BatchesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchesApi
     */
    public getBatches(options?: RawAxiosRequestConfig) {
        return BatchesApiFp(this.configuration).getBatches(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillableItemApi - axios parameter creator
 * @export
 */
export const BillableItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BillableItemModel} body Fill id to Update or it will create a new Billable Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillableItem: async (body: BillableItemModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createBillableItem', 'body', body)
            const localVarPath = `/V1/billableItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillableItems: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/billableItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillableItemApi - functional programming interface
 * @export
 */
export const BillableItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillableItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BillableItemModel} body Fill id to Update or it will create a new Billable Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillableItem(body: BillableItemModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillableItemModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillableItem(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillableItemApi.createBillableItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBillableItems(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillableItemModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBillableItems(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillableItemApi.getBillableItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillableItemApi - factory interface
 * @export
 */
export const BillableItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillableItemApiFp(configuration)
    return {
        /**
         * 
         * @param {BillableItemModel} body Fill id to Update or it will create a new Billable Item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillableItem(body: BillableItemModel, options?: any): AxiosPromise<BillableItemModel> {
            return localVarFp.createBillableItem(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillableItems(options?: any): AxiosPromise<Array<BillableItemModel>> {
            return localVarFp.getBillableItems(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BillableItemApi - object-oriented interface
 * @export
 * @class BillableItemApi
 * @extends {BaseAPI}
 */
export class BillableItemApi extends BaseAPI {
    /**
     * 
     * @param {BillableItemModel} body Fill id to Update or it will create a new Billable Item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillableItemApi
     */
    public createBillableItem(body: BillableItemModel, options?: RawAxiosRequestConfig) {
        return BillableItemApiFp(this.configuration).createBillableItem(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillableItemApi
     */
    public getBillableItems(options?: RawAxiosRequestConfig) {
        return BillableItemApiFp(this.configuration).getBillableItems(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BulkImportExportApi - axios parameter creator
 * @export
 */
export const BulkImportExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} body Run export process with given teammember Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkExportByAdmin: async (body: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkExportByAdmin', 'body', body)
            const localVarPath = `/V1/bulk/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} body Run import process with given list of files\&#39; name in storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkImportByAdmin: async (body: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkImportByAdmin', 'body', body)
            const localVarPath = `/V1/bulk/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<UploadFileRequestModel>} body Upload list of teammemmbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadByAdmin: async (body: Array<UploadFileRequestModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkUploadByAdmin', 'body', body)
            const localVarPath = `/V1/bulk/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} body Delete files in TeammembersInfoBulkImportExport container
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilesByAdmin: async (body: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteFilesByAdmin', 'body', body)
            const localVarPath = `/V1/bulk/delete/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAvailableFilesByAdmin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/bulk/tobeimported/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BulkImportExportApi - functional programming interface
 * @export
 */
export const BulkImportExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BulkImportExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} body Run export process with given teammember Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkExportByAdmin(body: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkExportByAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BulkImportExportApi.bulkExportByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} body Run import process with given list of files\&#39; name in storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkImportByAdmin(body: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkImportByAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BulkImportExportApi.bulkImportByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<UploadFileRequestModel>} body Upload list of teammemmbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadByAdmin(body: Array<UploadFileRequestModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadByAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BulkImportExportApi.bulkUploadByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} body Delete files in TeammembersInfoBulkImportExport container
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFilesByAdmin(body: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFilesByAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BulkImportExportApi.deleteFilesByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAvailableFilesByAdmin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAvailableFilesByAdmin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BulkImportExportApi.retrieveAvailableFilesByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BulkImportExportApi - factory interface
 * @export
 */
export const BulkImportExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BulkImportExportApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} body Run export process with given teammember Ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkExportByAdmin(body: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.bulkExportByAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} body Run import process with given list of files\&#39; name in storage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkImportByAdmin(body: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.bulkImportByAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<UploadFileRequestModel>} body Upload list of teammemmbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadByAdmin(body: Array<UploadFileRequestModel>, options?: any): AxiosPromise<string> {
            return localVarFp.bulkUploadByAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} body Delete files in TeammembersInfoBulkImportExport container
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilesByAdmin(body: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.deleteFilesByAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAvailableFilesByAdmin(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.retrieveAvailableFilesByAdmin(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BulkImportExportApi - object-oriented interface
 * @export
 * @class BulkImportExportApi
 * @extends {BaseAPI}
 */
export class BulkImportExportApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} body Run export process with given teammember Ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkImportExportApi
     */
    public bulkExportByAdmin(body: Array<string>, options?: RawAxiosRequestConfig) {
        return BulkImportExportApiFp(this.configuration).bulkExportByAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} body Run import process with given list of files\&#39; name in storage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkImportExportApi
     */
    public bulkImportByAdmin(body: Array<string>, options?: RawAxiosRequestConfig) {
        return BulkImportExportApiFp(this.configuration).bulkImportByAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<UploadFileRequestModel>} body Upload list of teammemmbers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkImportExportApi
     */
    public bulkUploadByAdmin(body: Array<UploadFileRequestModel>, options?: RawAxiosRequestConfig) {
        return BulkImportExportApiFp(this.configuration).bulkUploadByAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} body Delete files in TeammembersInfoBulkImportExport container
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkImportExportApi
     */
    public deleteFilesByAdmin(body: Array<string>, options?: RawAxiosRequestConfig) {
        return BulkImportExportApiFp(this.configuration).deleteFilesByAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkImportExportApi
     */
    public retrieveAvailableFilesByAdmin(options?: RawAxiosRequestConfig) {
        return BulkImportExportApiFp(this.configuration).retrieveAvailableFilesByAdmin(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createClient', 'body', body)
            const localVarPath = `/V1/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClient(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.createClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClients(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerCustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClients(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.getClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createClient(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClients(options?: any): AxiosPromise<Array<ManagerCustomerModel>> {
            return localVarFp.getClients(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createClient(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).createClient(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClients(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getClients(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAssessmentApi - axios parameter creator
 * @export
 */
export const ClientAssessmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClientAssessmentModel} body Fill id to Update or it will create a new Assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssessment: async (body: ClientAssessmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createAssessment', 'body', body)
            const localVarPath = `/V1/assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssessment: async (body: FindAssessmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('findAssessment', 'body', body)
            const localVarPath = `/V1/assessment/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssessmentById', 'id', id)
            const localVarPath = `/V1/assessment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAssessmentApi - functional programming interface
 * @export
 */
export const ClientAssessmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAssessmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClientAssessmentModel} body Fill id to Update or it will create a new Assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssessment(body: ClientAssessmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultClientAssessmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssessment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAssessmentApi.createAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAssessment(body: FindAssessmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAssessment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAssessmentApi.findAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultClientAssessmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAssessmentApi.getAssessmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAssessmentApi - factory interface
 * @export
 */
export const ClientAssessmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAssessmentApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientAssessmentModel} body Fill id to Update or it will create a new Assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssessment(body: ClientAssessmentModel, options?: any): AxiosPromise<ResultClientAssessmentModel> {
            return localVarFp.createAssessment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAssessment(body: FindAssessmentRequestModel, options?: any): AxiosPromise<ResultList1> {
            return localVarFp.findAssessment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentById(id: string, options?: any): AxiosPromise<ResultClientAssessmentModel> {
            return localVarFp.getAssessmentById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAssessmentApi - object-oriented interface
 * @export
 * @class ClientAssessmentApi
 * @extends {BaseAPI}
 */
export class ClientAssessmentApi extends BaseAPI {
    /**
     * 
     * @param {ClientAssessmentModel} body Fill id to Update or it will create a new Assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAssessmentApi
     */
    public createAssessment(body: ClientAssessmentModel, options?: RawAxiosRequestConfig) {
        return ClientAssessmentApiFp(this.configuration).createAssessment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FindAssessmentRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAssessmentApi
     */
    public findAssessment(body: FindAssessmentRequestModel, options?: RawAxiosRequestConfig) {
        return ClientAssessmentApiFp(this.configuration).findAssessment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Assessment Id to get related Assessment details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAssessmentApi
     */
    public getAssessmentById(id: string, options?: RawAxiosRequestConfig) {
        return ClientAssessmentApiFp(this.configuration).getAssessmentById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientAuthApi - axios parameter creator
 * @export
 */
export const ClientAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailLoginForClient: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createEmailLoginForClient', 'email', email)
            const localVarPath = `/V1/authentication/CreateEmailLoginForClient/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Email that should be sent to admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendClientLoginIssueReport: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendClientLoginIssueReport', 'email', email)
            const localVarPath = `/V1/authentication/SendClientLoginIssueReport/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTokenAndReturnClientInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/authentication/ValidateTokenAndReturnClientInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientAuthApi - functional programming interface
 * @export
 */
export const ClientAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEmailLoginForClient(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEmailLoginForClient(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuthApi.createEmailLoginForClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Email that should be sent to admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendClientLoginIssueReport(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendClientLoginIssueReport(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuthApi.sendClientLoginIssueReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTokenAndReturnClientInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultManagerModelLoginVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTokenAndReturnClientInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientAuthApi.validateTokenAndReturnClientInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientAuthApi - factory interface
 * @export
 */
export const ClientAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmailLoginForClient(email: string, options?: any): AxiosPromise<Result> {
            return localVarFp.createEmailLoginForClient(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Email that should be sent to admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendClientLoginIssueReport(email: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendClientLoginIssueReport(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTokenAndReturnClientInformation(options?: any): AxiosPromise<ResultManagerModelLoginVM> {
            return localVarFp.validateTokenAndReturnClientInformation(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientAuthApi - object-oriented interface
 * @export
 * @class ClientAuthApi
 * @extends {BaseAPI}
 */
export class ClientAuthApi extends BaseAPI {
    /**
     * 
     * @param {string} email Send Email to get the User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuthApi
     */
    public createEmailLoginForClient(email: string, options?: RawAxiosRequestConfig) {
        return ClientAuthApiFp(this.configuration).createEmailLoginForClient(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Email that should be sent to admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuthApi
     */
    public sendClientLoginIssueReport(email: string, options?: RawAxiosRequestConfig) {
        return ClientAuthApiFp(this.configuration).sendClientLoginIssueReport(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientAuthApi
     */
    public validateTokenAndReturnClientInformation(options?: RawAxiosRequestConfig) {
        return ClientAuthApiFp(this.configuration).validateTokenAndReturnClientInformation(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientCommitmentApi - axios parameter creator
 * @export
 */
export const ClientCommitmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommitmentActionModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientApplyActionToCommitment: async (body: CommitmentActionModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientApplyActionToCommitment', 'body', body)
            const localVarPath = `/V1/client/commitment/applyAction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateCommitment: async (body: CommitmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientCreateCommitment', 'body', body)
            const localVarPath = `/V1/client/commitment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCommitment: async (commitmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('clientGetCommitment', 'commitmentId', commitmentId)
            const localVarPath = `/V1/client/commitment/{commitmentId}`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientCommitmentApi - functional programming interface
 * @export
 */
export const ClientCommitmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientCommitmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommitmentActionModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientApplyActionToCommitment(body: CommitmentActionModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientApplyActionToCommitment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCommitmentApi.clientApplyActionToCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberWithVmDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCreateCommitment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCommitmentApi.clientCreateCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetCommitment(commitmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientGetCommitmentByIdResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetCommitment(commitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCommitmentApi.clientGetCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientCommitmentApi - factory interface
 * @export
 */
export const ClientCommitmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientCommitmentApiFp(configuration)
    return {
        /**
         * 
         * @param {CommitmentActionModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientApplyActionToCommitment(body: CommitmentActionModel, options?: any): AxiosPromise<string> {
            return localVarFp.clientApplyActionToCommitment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateCommitment(body: CommitmentModel, options?: any): AxiosPromise<TeammemberWithVmDetails> {
            return localVarFp.clientCreateCommitment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCommitment(commitmentId: string, options?: any): AxiosPromise<ClientGetCommitmentByIdResponseModel> {
            return localVarFp.clientGetCommitment(commitmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientCommitmentApi - object-oriented interface
 * @export
 * @class ClientCommitmentApi
 * @extends {BaseAPI}
 */
export class ClientCommitmentApi extends BaseAPI {
    /**
     * 
     * @param {CommitmentActionModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCommitmentApi
     */
    public clientApplyActionToCommitment(body: CommitmentActionModel, options?: RawAxiosRequestConfig) {
        return ClientCommitmentApiFp(this.configuration).clientApplyActionToCommitment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCommitmentApi
     */
    public clientCreateCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig) {
        return ClientCommitmentApiFp(this.configuration).clientCreateCommitment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} commitmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCommitmentApi
     */
    public clientGetCommitment(commitmentId: string, options?: RawAxiosRequestConfig) {
        return ClientCommitmentApiFp(this.configuration).clientGetCommitment(commitmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientCourseApi - axios parameter creator
 * @export
 */
export const ClientCourseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CourseModel} body Fill id to Update or it will create a new Course
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourse: async (body: CourseModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createCourse', 'body', body)
            const localVarPath = `/V1/course`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCourse: async (body: FindCoursesRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('findCourse', 'body', body)
            const localVarPath = `/V1/course/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCourseById', 'id', id)
            const localVarPath = `/V1/course/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoursesName: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/course/get/coursesName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMGetCourseById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tMGetCourseById', 'id', id)
            const localVarPath = `/V1/tmCourse/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientCourseApi - functional programming interface
 * @export
 */
export const ClientCourseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientCourseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CourseModel} body Fill id to Update or it will create a new Course
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCourse(body: CourseModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultCourseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCourse(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCourseApi.createCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCourse(body: FindCoursesRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCourse(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCourseApi.findCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCourseById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultCourseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCourseById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCourseApi.getCourseById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoursesName(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoursesName(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCourseApi.getCoursesName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tMGetCourseById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultCourseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tMGetCourseById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCourseApi.tMGetCourseById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientCourseApi - factory interface
 * @export
 */
export const ClientCourseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientCourseApiFp(configuration)
    return {
        /**
         * 
         * @param {CourseModel} body Fill id to Update or it will create a new Course
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourse(body: CourseModel, options?: any): AxiosPromise<ResultCourseModel> {
            return localVarFp.createCourse(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCourse(body: FindCoursesRequestModel, options?: any): AxiosPromise<ResultList1> {
            return localVarFp.findCourse(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCourseById(id: string, options?: any): AxiosPromise<ResultCourseModel> {
            return localVarFp.getCourseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoursesName(options?: any): AxiosPromise<ResultList1> {
            return localVarFp.getCoursesName(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send course Id to get related course details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMGetCourseById(id: string, options?: any): AxiosPromise<ResultCourseModel> {
            return localVarFp.tMGetCourseById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientCourseApi - object-oriented interface
 * @export
 * @class ClientCourseApi
 * @extends {BaseAPI}
 */
export class ClientCourseApi extends BaseAPI {
    /**
     * 
     * @param {CourseModel} body Fill id to Update or it will create a new Course
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCourseApi
     */
    public createCourse(body: CourseModel, options?: RawAxiosRequestConfig) {
        return ClientCourseApiFp(this.configuration).createCourse(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FindCoursesRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCourseApi
     */
    public findCourse(body: FindCoursesRequestModel, options?: RawAxiosRequestConfig) {
        return ClientCourseApiFp(this.configuration).findCourse(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send course Id to get related course details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCourseApi
     */
    public getCourseById(id: string, options?: RawAxiosRequestConfig) {
        return ClientCourseApiFp(this.configuration).getCourseById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCourseApi
     */
    public getCoursesName(options?: RawAxiosRequestConfig) {
        return ClientCourseApiFp(this.configuration).getCoursesName(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send course Id to get related course details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCourseApi
     */
    public tMGetCourseById(id: string, options?: RawAxiosRequestConfig) {
        return ClientCourseApiFp(this.configuration).tMGetCourseById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientCustomerApi - axios parameter creator
 * @export
 */
export const ClientCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAddOfficeLocation: async (authorization: string, body: OfficeLocationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('clientAddOfficeLocation', 'authorization', authorization)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientAddOfficeLocation', 'body', body)
            const localVarPath = `/V1/client/customer/officeLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetOfficeLocation: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('clientGetOfficeLocation', 'authorization', authorization)
            const localVarPath = `/V1/client/customer/officeLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientCustomerApi - functional programming interface
 * @export
 */
export const ClientCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientAddOfficeLocation(authorization: string, body: OfficeLocationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientAddOfficeLocation(authorization, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCustomerApi.clientAddOfficeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetOfficeLocation(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfficeLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetOfficeLocation(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientCustomerApi.clientGetOfficeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientCustomerApi - factory interface
 * @export
 */
export const ClientCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientCustomerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientAddOfficeLocation(authorization: string, body: OfficeLocationModel, options?: any): AxiosPromise<string> {
            return localVarFp.clientAddOfficeLocation(authorization, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetOfficeLocation(authorization: string, options?: any): AxiosPromise<Array<OfficeLocationModel>> {
            return localVarFp.clientGetOfficeLocation(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientCustomerApi - object-oriented interface
 * @export
 * @class ClientCustomerApi
 * @extends {BaseAPI}
 */
export class ClientCustomerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {OfficeLocationModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCustomerApi
     */
    public clientAddOfficeLocation(authorization: string, body: OfficeLocationModel, options?: RawAxiosRequestConfig) {
        return ClientCustomerApiFp(this.configuration).clientAddOfficeLocation(authorization, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientCustomerApi
     */
    public clientGetOfficeLocation(authorization: string, options?: RawAxiosRequestConfig) {
        return ClientCustomerApiFp(this.configuration).clientGetOfficeLocation(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientDashboardApi - axios parameter creator
 * @export
 */
export const ClientDashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DashboardRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDashboard: async (body: DashboardRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientDashboard', 'body', body)
            const localVarPath = `/V1/client/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesClient: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/dashboard/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientDashboardApi - functional programming interface
 * @export
 */
export const ClientDashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientDashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DashboardRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientDashboard(body: DashboardRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultManagerModelLoginVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientDashboard(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientDashboardApi.clientDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitiesClient(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitiesClient(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientDashboardApi.getActivitiesClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientDashboardApi - factory interface
 * @export
 */
export const ClientDashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientDashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientDashboard(body: DashboardRequestModel, options?: any): AxiosPromise<ResultManagerModelLoginVM> {
            return localVarFp.clientDashboard(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitiesClient(options?: any): AxiosPromise<Array<ActivityModel>> {
            return localVarFp.getActivitiesClient(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientDashboardApi - object-oriented interface
 * @export
 * @class ClientDashboardApi
 * @extends {BaseAPI}
 */
export class ClientDashboardApi extends BaseAPI {
    /**
     * 
     * @param {DashboardRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDashboardApi
     */
    public clientDashboard(body: DashboardRequestModel, options?: RawAxiosRequestConfig) {
        return ClientDashboardApiFp(this.configuration).clientDashboard(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientDashboardApi
     */
    public getActivitiesClient(options?: RawAxiosRequestConfig) {
        return ClientDashboardApiFp(this.configuration).getActivitiesClient(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientEpicApi - axios parameter creator
 * @export
 */
export const ClientEpicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSaveEpic: async (body: EpicRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientSaveEpic', 'body', body)
            const localVarPath = `/V1/client/epic/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientEpicApi - functional programming interface
 * @export
 */
export const ClientEpicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientEpicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSaveEpic(body: EpicRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpicModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSaveEpic(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientEpicApi.clientSaveEpic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientEpicApi - factory interface
 * @export
 */
export const ClientEpicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientEpicApiFp(configuration)
    return {
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSaveEpic(body: EpicRequestModel, options?: any): AxiosPromise<EpicModel> {
            return localVarFp.clientSaveEpic(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientEpicApi - object-oriented interface
 * @export
 * @class ClientEpicApi
 * @extends {BaseAPI}
 */
export class ClientEpicApi extends BaseAPI {
    /**
     * 
     * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientEpicApi
     */
    public clientSaveEpic(body: EpicRequestModel, options?: RawAxiosRequestConfig) {
        return ClientEpicApiFp(this.configuration).clientSaveEpic(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientLineManagersApi - axios parameter creator
 * @export
 */
export const ClientLineManagersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetLineManagerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/lineManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientLineManagersApi - functional programming interface
 * @export
 */
export const ClientLineManagersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientLineManagersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetLineManagerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LineManagerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetLineManagerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientLineManagersApi.clientGetLineManagerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientLineManagersApi - factory interface
 * @export
 */
export const ClientLineManagersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientLineManagersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetLineManagerList(options?: any): AxiosPromise<Array<LineManagerModel>> {
            return localVarFp.clientGetLineManagerList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientLineManagersApi - object-oriented interface
 * @export
 * @class ClientLineManagersApi
 * @extends {BaseAPI}
 */
export class ClientLineManagersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientLineManagersApi
     */
    public clientGetLineManagerList(options?: RawAxiosRequestConfig) {
        return ClientLineManagersApiFp(this.configuration).clientGetLineManagerList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientOfficeSpaceApi - axios parameter creator
 * @export
 */
export const ClientOfficeSpaceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetOfficeSpace: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/officeSpace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientOfficeSpaceApi - functional programming interface
 * @export
 */
export const ClientOfficeSpaceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientOfficeSpaceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetOfficeSpace(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfficeSpaceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetOfficeSpace(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientOfficeSpaceApi.clientGetOfficeSpace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientOfficeSpaceApi - factory interface
 * @export
 */
export const ClientOfficeSpaceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientOfficeSpaceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetOfficeSpace(options?: any): AxiosPromise<Array<OfficeSpaceModel>> {
            return localVarFp.clientGetOfficeSpace(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientOfficeSpaceApi - object-oriented interface
 * @export
 * @class ClientOfficeSpaceApi
 * @extends {BaseAPI}
 */
export class ClientOfficeSpaceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientOfficeSpaceApi
     */
    public clientGetOfficeSpace(options?: RawAxiosRequestConfig) {
        return ClientOfficeSpaceApiFp(this.configuration).clientGetOfficeSpace(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientPortfolioManagersApi - axios parameter creator
 * @export
 */
export const ClientPortfolioManagersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPortfolioManagerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/portfolioManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPortfolioManagersApi - functional programming interface
 * @export
 */
export const ClientPortfolioManagersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientPortfolioManagersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetPortfolioManagerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerCustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetPortfolioManagerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPortfolioManagersApi.clientGetPortfolioManagerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientPortfolioManagersApi - factory interface
 * @export
 */
export const ClientPortfolioManagersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientPortfolioManagersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPortfolioManagerList(options?: any): AxiosPromise<Array<ManagerCustomerModel>> {
            return localVarFp.clientGetPortfolioManagerList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPortfolioManagersApi - object-oriented interface
 * @export
 * @class ClientPortfolioManagersApi
 * @extends {BaseAPI}
 */
export class ClientPortfolioManagersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPortfolioManagersApi
     */
    public clientGetPortfolioManagerList(options?: RawAxiosRequestConfig) {
        return ClientPortfolioManagersApiFp(this.configuration).clientGetPortfolioManagerList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientPositionApi - axios parameter creator
 * @export
 */
export const ClientPositionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPositionById: async (positionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('clientGetPositionById', 'positionId', positionId)
            const localVarPath = `/V1/client/position/{positionId}`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PositionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSavePosition: async (body: PositionRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientSavePosition', 'body', body)
            const localVarPath = `/V1/client/position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} positionId 
         * @param {PositionJDAndDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSavePositionDetails: async (positionId: string, body: PositionJDAndDetailsRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionId' is not null or undefined
            assertParamExists('clientSavePositionDetails', 'positionId', positionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientSavePositionDetails', 'body', body)
            const localVarPath = `/V1/client/position/{positionId}/details`
                .replace(`{${"positionId"}}`, encodeURIComponent(String(positionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPositionApi - functional programming interface
 * @export
 */
export const ClientPositionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientPositionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetPositionById(positionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetPositionById(positionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPositionApi.clientGetPositionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PositionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSavePosition(body: PositionRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSavePosition(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPositionApi.clientSavePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} positionId 
         * @param {PositionJDAndDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSavePositionDetails(positionId: string, body: PositionJDAndDetailsRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSavePositionDetails(positionId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPositionApi.clientSavePositionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientPositionApi - factory interface
 * @export
 */
export const ClientPositionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientPositionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} positionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPositionById(positionId: string, options?: any): AxiosPromise<PositionDetailResponseModel> {
            return localVarFp.clientGetPositionById(positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PositionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSavePosition(body: PositionRequestModel, options?: any): AxiosPromise<PositionDetailResponseModel> {
            return localVarFp.clientSavePosition(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} positionId 
         * @param {PositionJDAndDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSavePositionDetails(positionId: string, body: PositionJDAndDetailsRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.clientSavePositionDetails(positionId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPositionApi - object-oriented interface
 * @export
 * @class ClientPositionApi
 * @extends {BaseAPI}
 */
export class ClientPositionApi extends BaseAPI {
    /**
     * 
     * @param {string} positionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPositionApi
     */
    public clientGetPositionById(positionId: string, options?: RawAxiosRequestConfig) {
        return ClientPositionApiFp(this.configuration).clientGetPositionById(positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PositionRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPositionApi
     */
    public clientSavePosition(body: PositionRequestModel, options?: RawAxiosRequestConfig) {
        return ClientPositionApiFp(this.configuration).clientSavePosition(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} positionId 
     * @param {PositionJDAndDetailsRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPositionApi
     */
    public clientSavePositionDetails(positionId: string, body: PositionJDAndDetailsRequestModel, options?: RawAxiosRequestConfig) {
        return ClientPositionApiFp(this.configuration).clientSavePositionDetails(positionId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientProjectApi - axios parameter creator
 * @export
 */
export const ClientProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateProject: async (body: ProjectModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientCreateProject', 'body', body)
            const localVarPath = `/V1/client/project/CreateProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetProjectWithDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjectsWithDetails: async (body: GetProjectWithDetailsRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientGetProjectsWithDetails', 'body', body)
            const localVarPath = `/V1/client/project/withDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientProjectApi - functional programming interface
 * @export
 */
export const ClientProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateProject(body: ProjectModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCreateProject(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProjectApi.clientCreateProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProjectApi.clientGetProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetProjectWithDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetProjectsWithDetails(body: GetProjectWithDetailsRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientProjectWithDetailsResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetProjectsWithDetails(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProjectApi.clientGetProjectsWithDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientProjectApi - factory interface
 * @export
 */
export const ClientProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientProjectApiFp(configuration)
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateProject(body: ProjectModel, options?: any): AxiosPromise<ProjectModel> {
            return localVarFp.clientCreateProject(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjects(options?: any): AxiosPromise<Array<ProjectModel>> {
            return localVarFp.clientGetProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetProjectWithDetailsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjectsWithDetails(body: GetProjectWithDetailsRequestModel, options?: any): AxiosPromise<Array<ClientProjectWithDetailsResponseModel>> {
            return localVarFp.clientGetProjectsWithDetails(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientProjectApi - object-oriented interface
 * @export
 * @class ClientProjectApi
 * @extends {BaseAPI}
 */
export class ClientProjectApi extends BaseAPI {
    /**
     * 
     * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProjectApi
     */
    public clientCreateProject(body: ProjectModel, options?: RawAxiosRequestConfig) {
        return ClientProjectApiFp(this.configuration).clientCreateProject(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProjectApi
     */
    public clientGetProjects(options?: RawAxiosRequestConfig) {
        return ClientProjectApiFp(this.configuration).clientGetProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetProjectWithDetailsRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProjectApi
     */
    public clientGetProjectsWithDetails(body: GetProjectWithDetailsRequestModel, options?: RawAxiosRequestConfig) {
        return ClientProjectApiFp(this.configuration).clientGetProjectsWithDetails(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientProjectLeadsApi - axios parameter creator
 * @export
 */
export const ClientProjectLeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjectLeadList: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('clientGetProjectLeadList', 'authorization', authorization)
            const localVarPath = `/V1/client/projectLeads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientProjectLeadsApi - functional programming interface
 * @export
 */
export const ClientProjectLeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientProjectLeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetProjectLeadList(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerCustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetProjectLeadList(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientProjectLeadsApi.clientGetProjectLeadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientProjectLeadsApi - factory interface
 * @export
 */
export const ClientProjectLeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientProjectLeadsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetProjectLeadList(authorization: string, options?: any): AxiosPromise<Array<ManagerCustomerModel>> {
            return localVarFp.clientGetProjectLeadList(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientProjectLeadsApi - object-oriented interface
 * @export
 * @class ClientProjectLeadsApi
 * @extends {BaseAPI}
 */
export class ClientProjectLeadsApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientProjectLeadsApi
     */
    public clientGetProjectLeadList(authorization: string, options?: RawAxiosRequestConfig) {
        return ClientProjectLeadsApiFp(this.configuration).clientGetProjectLeadList(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientPublicHolidaysApi - axios parameter creator
 * @export
 */
export const ClientPublicHolidaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPublicHolidayList: async (authorization: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('clientGetPublicHolidayList', 'authorization', authorization)
            const localVarPath = `/V1/client/publicholidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPublicHolidaysApi - functional programming interface
 * @export
 */
export const ClientPublicHolidaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientPublicHolidaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetPublicHolidayList(authorization: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetPublicHolidayList(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientPublicHolidaysApi.clientGetPublicHolidayList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientPublicHolidaysApi - factory interface
 * @export
 */
export const ClientPublicHolidaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientPublicHolidaysApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetPublicHolidayList(authorization: string, options?: any): AxiosPromise<Array<PublicHolidayModel>> {
            return localVarFp.clientGetPublicHolidayList(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPublicHolidaysApi - object-oriented interface
 * @export
 * @class ClientPublicHolidaysApi
 * @extends {BaseAPI}
 */
export class ClientPublicHolidaysApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicHolidaysApi
     */
    public clientGetPublicHolidayList(authorization: string, options?: RawAxiosRequestConfig) {
        return ClientPublicHolidaysApiFp(this.configuration).clientGetPublicHolidayList(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientRoadMapApi - axios parameter creator
 * @export
 */
export const ClientRoadMapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send RoadMap Id to add talents
         * @param {Array<string>} body Send the Talent Ids list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTalentToRoadMap: async (id: string, body: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTalentToRoadMap', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addTalentToRoadMap', 'body', body)
            const localVarPath = `/V1/roadMap/{id}/addTalents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RoadMapModel} body Fill id to Update or it will create a new RoadMap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoadMap: async (body: RoadMapModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createRoadMap', 'body', body)
            const localVarPath = `/V1/roadMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FindRoadMapsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoadMap: async (body: FindRoadMapsRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('findRoadMap', 'body', body)
            const localVarPath = `/V1/roadMap/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to get related RoadMap details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoadMapById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRoadMapById', 'id', id)
            const localVarPath = `/V1/roadMap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to remove it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoadMap: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeRoadMap', 'id', id)
            const localVarPath = `/V1/roadMap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateRoadMapStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadMapStatus: async (body: UpdateRoadMapStatusRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateRoadMapStatus', 'body', body)
            const localVarPath = `/V1/roadMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientRoadMapApi - functional programming interface
 * @export
 */
export const ClientRoadMapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientRoadMapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send RoadMap Id to add talents
         * @param {Array<string>} body Send the Talent Ids list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTalentToRoadMap(id: string, body: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoadMapModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTalentToRoadMap(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.addTalentToRoadMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RoadMapModel} body Fill id to Update or it will create a new RoadMap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoadMap(body: RoadMapModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoadMapModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoadMap(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.createRoadMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FindRoadMapsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRoadMap(body: FindRoadMapsRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRoadMap(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.findRoadMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to get related RoadMap details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoadMapById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoadMapModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoadMapById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.getRoadMapById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to remove it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoadMap(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultIActionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoadMap(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.removeRoadMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateRoadMapStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoadMapStatus(body: UpdateRoadMapStatusRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultRoadMapModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoadMapStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientRoadMapApi.updateRoadMapStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientRoadMapApi - factory interface
 * @export
 */
export const ClientRoadMapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientRoadMapApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send RoadMap Id to add talents
         * @param {Array<string>} body Send the Talent Ids list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTalentToRoadMap(id: string, body: Array<string>, options?: any): AxiosPromise<ResultRoadMapModel> {
            return localVarFp.addTalentToRoadMap(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RoadMapModel} body Fill id to Update or it will create a new RoadMap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoadMap(body: RoadMapModel, options?: any): AxiosPromise<ResultRoadMapModel> {
            return localVarFp.createRoadMap(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FindRoadMapsRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRoadMap(body: FindRoadMapsRequestModel, options?: any): AxiosPromise<ResultList1> {
            return localVarFp.findRoadMap(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to get related RoadMap details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoadMapById(id: string, options?: any): AxiosPromise<ResultRoadMapModel> {
            return localVarFp.getRoadMapById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send RoadMap Id to remove it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoadMap(id: string, options?: any): AxiosPromise<ResultIActionResult> {
            return localVarFp.removeRoadMap(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateRoadMapStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoadMapStatus(body: UpdateRoadMapStatusRequestModel, options?: any): AxiosPromise<ResultRoadMapModel> {
            return localVarFp.updateRoadMapStatus(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientRoadMapApi - object-oriented interface
 * @export
 * @class ClientRoadMapApi
 * @extends {BaseAPI}
 */
export class ClientRoadMapApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send RoadMap Id to add talents
     * @param {Array<string>} body Send the Talent Ids list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public addTalentToRoadMap(id: string, body: Array<string>, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).addTalentToRoadMap(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RoadMapModel} body Fill id to Update or it will create a new RoadMap
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public createRoadMap(body: RoadMapModel, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).createRoadMap(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FindRoadMapsRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public findRoadMap(body: FindRoadMapsRequestModel, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).findRoadMap(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send RoadMap Id to get related RoadMap details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public getRoadMapById(id: string, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).getRoadMapById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send RoadMap Id to remove it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public removeRoadMap(id: string, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).removeRoadMap(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateRoadMapStatusRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientRoadMapApi
     */
    public updateRoadMapStatus(body: UpdateRoadMapStatusRequestModel, options?: RawAxiosRequestConfig) {
        return ClientRoadMapApiFp(this.configuration).updateRoadMapStatus(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientTeammemberApi - axios parameter creator
 * @export
 */
export const ClientTeammemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teammemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetTeammember: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('clientGetTeammember', 'teammemberId', teammemberId)
            const localVarPath = `/V1/client/teammembers/get/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientInviteTeammemberRequest} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientInviteTeammember: async (body: ClientInviteTeammemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientInviteTeammember', 'body', body)
            const localVarPath = `/V1/client/teammembers/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchTeammemberRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSearchTeammember: async (body: SearchTeammemberRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientSearchTeammember', 'body', body)
            const localVarPath = `/V1/client/teammembers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientValidateTeammember: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('clientValidateTeammember', 'email', email)
            const localVarPath = `/V1/client/teammembers/validate/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geActivetTeammeberListByProjectLeadId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/teammembers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientTeammemberListSummaryDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/teammembers/SummaryDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientTeammemberApi - functional programming interface
 * @export
 */
export const ClientTeammemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientTeammemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teammemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetTeammember(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientGetTeammemberResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetTeammember(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.clientGetTeammember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClientInviteTeammemberRequest} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientInviteTeammember(body: ClientInviteTeammemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSearchTeammemberResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientInviteTeammember(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.clientInviteTeammember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchTeammemberRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSearchTeammember(body: SearchTeammemberRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientSearchTeammemberResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSearchTeammember(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.clientSearchTeammember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientValidateTeammember(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientValidateTeammemberResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientValidateTeammember(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.clientValidateTeammember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geActivetTeammeberListByProjectLeadId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultManagerModelLoginVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geActivetTeammeberListByProjectLeadId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.geActivetTeammeberListByProjectLeadId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientTeammemberListSummaryDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSummaryDetailsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientTeammemberListSummaryDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientTeammemberApi.getClientTeammemberListSummaryDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientTeammemberApi - factory interface
 * @export
 */
export const ClientTeammemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientTeammemberApiFp(configuration)
    return {
        /**
         * 
         * @param {string} teammemberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetTeammember(teammemberId: string, options?: any): AxiosPromise<ClientGetTeammemberResponseModel> {
            return localVarFp.clientGetTeammember(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientInviteTeammemberRequest} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientInviteTeammember(body: ClientInviteTeammemberRequest, options?: any): AxiosPromise<ClientSearchTeammemberResponseModel> {
            return localVarFp.clientInviteTeammember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchTeammemberRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSearchTeammember(body: SearchTeammemberRequestModel, options?: any): AxiosPromise<Array<ClientSearchTeammemberResponseModel>> {
            return localVarFp.clientSearchTeammember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientValidateTeammember(email: string, options?: any): AxiosPromise<ClientValidateTeammemberResponseModel> {
            return localVarFp.clientValidateTeammember(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geActivetTeammeberListByProjectLeadId(options?: any): AxiosPromise<ResultManagerModelLoginVM> {
            return localVarFp.geActivetTeammeberListByProjectLeadId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientTeammemberListSummaryDetails(options?: any): AxiosPromise<Array<TeammemberSummaryDetailsModel>> {
            return localVarFp.getClientTeammemberListSummaryDetails(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientTeammemberApi - object-oriented interface
 * @export
 * @class ClientTeammemberApi
 * @extends {BaseAPI}
 */
export class ClientTeammemberApi extends BaseAPI {
    /**
     * 
     * @param {string} teammemberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public clientGetTeammember(teammemberId: string, options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).clientGetTeammember(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientInviteTeammemberRequest} body Create new User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public clientInviteTeammember(body: ClientInviteTeammemberRequest, options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).clientInviteTeammember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchTeammemberRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public clientSearchTeammember(body: SearchTeammemberRequestModel, options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).clientSearchTeammember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public clientValidateTeammember(email: string, options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).clientValidateTeammember(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public geActivetTeammeberListByProjectLeadId(options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).geActivetTeammeberListByProjectLeadId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTeammemberApi
     */
    public getClientTeammemberListSummaryDetails(options?: RawAxiosRequestConfig) {
        return ClientTeammemberApiFp(this.configuration).getClientTeammemberListSummaryDetails(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientVMApi - axios parameter creator
 * @export
 */
export const ClientVMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClientCreateVMRequest} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateVM: async (body: ClientCreateVMRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientCreateVM', 'body', body)
            const localVarPath = `/V1/client/vm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetActivityWatchForVM: async (body: ActivityWatchRequestVM, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientGetActivityWatchForVM', 'body', body)
            const localVarPath = `/V1/client/vm/GetActivityWatchForVM`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} vmId 
         * @param {ClientVmSupportRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientVmSupport: async (vmId: string, body: ClientVmSupportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('clientVmSupport', 'vmId', vmId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientVmSupport', 'body', body)
            const localVarPath = `/V1/client/vm/{vmId}/vmSupport`
                .replace(`{${"vmId"}}`, encodeURIComponent(String(vmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientVMApi - functional programming interface
 * @export
 */
export const ClientVMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientVMApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClientCreateVMRequest} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateVM(body: ClientCreateVMRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientCreateVM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientVMApi.clientCreateVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetActivityWatchForVM(body: ActivityWatchRequestVM, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmActivityWatchReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetActivityWatchForVM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientVMApi.clientGetActivityWatchForVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} vmId 
         * @param {ClientVmSupportRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientVmSupport(vmId: string, body: ClientVmSupportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientVmSupport(vmId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientVMApi.clientVmSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientVMApi - factory interface
 * @export
 */
export const ClientVMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientVMApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientCreateVMRequest} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateVM(body: ClientCreateVMRequest, options?: any): AxiosPromise<string> {
            return localVarFp.clientCreateVM(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetActivityWatchForVM(body: ActivityWatchRequestVM, options?: any): AxiosPromise<VmActivityWatchReport> {
            return localVarFp.clientGetActivityWatchForVM(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} vmId 
         * @param {ClientVmSupportRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientVmSupport(vmId: string, body: ClientVmSupportRequest, options?: any): AxiosPromise<string> {
            return localVarFp.clientVmSupport(vmId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientVMApi - object-oriented interface
 * @export
 * @class ClientVMApi
 * @extends {BaseAPI}
 */
export class ClientVMApi extends BaseAPI {
    /**
     * 
     * @param {ClientCreateVMRequest} body string content to save as vms in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVMApi
     */
    public clientCreateVM(body: ClientCreateVMRequest, options?: RawAxiosRequestConfig) {
        return ClientVMApiFp(this.configuration).clientCreateVM(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ActivityWatchRequestVM} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVMApi
     */
    public clientGetActivityWatchForVM(body: ActivityWatchRequestVM, options?: RawAxiosRequestConfig) {
        return ClientVMApiFp(this.configuration).clientGetActivityWatchForVM(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} vmId 
     * @param {ClientVmSupportRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientVMApi
     */
    public clientVmSupport(vmId: string, body: ClientVmSupportRequest, options?: RawAxiosRequestConfig) {
        return ClientVMApiFp(this.configuration).clientVmSupport(vmId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientsApi - axios parameter creator
 * @export
 */
export const ClientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send id to get specific Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClientById', 'id', id)
            const localVarPath = `/V1/client/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateClient', 'body', body)
            const localVarPath = `/V1/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientsApi - functional programming interface
 * @export
 */
export const ClientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.getClientById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClient(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientsApi.updateClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientsApi - factory interface
 * @export
 */
export const ClientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getClientById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateClient(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientsApi - object-oriented interface
 * @export
 * @class ClientsApi
 * @extends {BaseAPI}
 */
export class ClientsApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send id to get specific Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public getClientById(id: string, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).getClientById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerCustomerModel} body Fill id to Update existing Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientsApi
     */
    public updateClient(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return ClientsApiFp(this.configuration).updateClient(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CodeClanApi - axios parameter creator
 * @export
 */
export const CodeClanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ContactUsRequestModel} body information to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContent: async (body: ContactUsRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendContent', 'body', body)
            const localVarPath = `/V1/codeclan/contactus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeClanApi - functional programming interface
 * @export
 */
export const CodeClanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodeClanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ContactUsRequestModel} body information to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendContent(body: ContactUsRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendContent(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodeClanApi.sendContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CodeClanApi - factory interface
 * @export
 */
export const CodeClanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodeClanApiFp(configuration)
    return {
        /**
         * 
         * @param {ContactUsRequestModel} body information to send email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContent(body: ContactUsRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendContent(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeClanApi - object-oriented interface
 * @export
 * @class CodeClanApi
 * @extends {BaseAPI}
 */
export class CodeClanApi extends BaseAPI {
    /**
     * 
     * @param {ContactUsRequestModel} body information to send email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeClanApi
     */
    public sendContent(body: ContactUsRequestModel, options?: RawAxiosRequestConfig) {
        return CodeClanApiFp(this.configuration).sendContent(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommitmentApi - axios parameter creator
 * @export
 */
export const CommitmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} commitmentId 
         * @param {SendCommitmentNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendCommitmentNotification: async (commitmentId: string, body: SendCommitmentNotificationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('adminSendCommitmentNotification', 'commitmentId', commitmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminSendCommitmentNotification', 'body', body)
            const localVarPath = `/V1/commitment/{commitmentId}/sendNotification`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCommitmentStatus: async (commitmentId: string, body: UpdateCommitmentStatusRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('adminUpdateCommitmentStatus', 'commitmentId', commitmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminUpdateCommitmentStatus', 'body', body)
            const localVarPath = `/V1/commitment/{commitmentId}/updateStatus`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommitment: async (body: CommitmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createCommitment', 'body', body)
            const localVarPath = `/V1/commitment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommitmentV2: async (body: CommitmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createCommitmentV2', 'body', body)
            const localVarPath = `/V1/commitmentV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId Send customerId to get all related commitment to this customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByCustomerId: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCommitmentByCustomerId', 'customerId', customerId)
            const localVarPath = `/V1/commitment/GetCommitmentByCustomerId/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommitmentById', 'id', id)
            const localVarPath = `/V1/commitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment to this linemanager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByLinemanagerId: async (linemanagerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('getCommitmentByLinemanagerId', 'linemanagerId', linemanagerId)
            const localVarPath = `/V1/commitment/GetCommitmentByLinemanagerId/{linemanagerId}`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByName: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getCommitmentByName', 'name', name)
            const localVarPath = `/V1/commitment/GetByName/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related commitment to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByTeammemberIdForAdmin: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getCommitmentByTeammemberIdForAdmin', 'teammemberId', teammemberId)
            const localVarPath = `/V1/commitment/GetCommitmentByTeammemberId/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/commitment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsAndRelationsByDateRange: async (body: DateRangeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getCommitmentsAndRelationsByDateRange', 'body', body)
            const localVarPath = `/V1/commitment/getCommitmentsRelations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment and relations to this linemanager
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsAndRelationsByLinemanagerId: async (linemanagerId: string, body: DateRangeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('getCommitmentsAndRelationsByLinemanagerId', 'linemanagerId', linemanagerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getCommitmentsAndRelationsByLinemanagerId', 'body', body)
            const localVarPath = `/V1/commitment/getCommitmentsRelations/admin`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModelV2} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsV2: async (body: PaginationRequestModelV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getCommitmentsV2', 'body', body)
            const localVarPath = `/V2/commitment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewCommitment: async (commitmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('getReviewCommitment', 'commitmentId', commitmentId)
            const localVarPath = `/V1/commitment/{commitmentId}/getReview`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to remove the Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommitment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCommitment', 'id', id)
            const localVarPath = `/V1/commitment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberUpdateCommitmentStatus: async (commitmentId: string, body: UpdateCommitmentStatusRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('teammemberUpdateCommitmentStatus', 'commitmentId', commitmentId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('teammemberUpdateCommitmentStatus', 'body', body)
            const localVarPath = `/V1/teammember/commitment/{commitmentId}/updateStatus`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommitmentModel} body Fill id to Update existing Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommitment: async (body: CommitmentModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCommitment', 'body', body)
            const localVarPath = `/V1/commitment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommitmentApi - functional programming interface
 * @export
 */
export const CommitmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommitmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} commitmentId 
         * @param {SendCommitmentNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSendCommitmentNotification(commitmentId: string, body: SendCommitmentNotificationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSendCommitmentNotification(commitmentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.adminSendCommitmentNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateCommitmentStatus(commitmentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.adminUpdateCommitmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommitment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.createCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommitmentV2(body: CommitmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommitmentV2(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.createCommitmentV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId Send customerId to get all related commitment to this customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentByCustomerId(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentByCustomerId(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment to this linemanager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentByLinemanagerId(linemanagerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentByLinemanagerId(linemanagerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentByLinemanagerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentByName(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related commitment to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentByTeammemberIdForAdmin(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentByTeammemberIdForAdmin(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentByTeammemberIdForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentsAndRelationsByDateRange(body: DateRangeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentWithRelationsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentsAndRelationsByDateRange(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentsAndRelationsByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment and relations to this linemanager
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentsAndRelationsByLinemanagerId(linemanagerId: string, body: DateRangeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentWithRelationsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentsAndRelationsByLinemanagerId(linemanagerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentsAndRelationsByLinemanagerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModelV2} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentsV2(body: PaginationRequestModelV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelCommitmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentsV2(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getCommitmentsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewCommitment(commitmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReviewCommitmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewCommitment(commitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.getReviewCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to remove the Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCommitment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCommitment(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.removeCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teammemberUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teammemberUpdateCommitmentStatus(commitmentId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.teammemberUpdateCommitmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommitmentModel} body Fill id to Update existing Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommitment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommitmentApi.updateCommitment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommitmentApi - factory interface
 * @export
 */
export const CommitmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommitmentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} commitmentId 
         * @param {SendCommitmentNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendCommitmentNotification(commitmentId: string, body: SendCommitmentNotificationRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.adminSendCommitmentNotification(commitmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.adminUpdateCommitmentStatus(commitmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommitment(body: CommitmentModel, options?: any): AxiosPromise<string> {
            return localVarFp.createCommitment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommitmentV2(body: CommitmentModel, options?: any): AxiosPromise<string> {
            return localVarFp.createCommitmentV2(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId Send customerId to get all related commitment to this customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByCustomerId(customerId: string, options?: any): AxiosPromise<Array<CommitmentModel>> {
            return localVarFp.getCommitmentByCustomerId(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentById(id: string, options?: any): AxiosPromise<CommitmentModel> {
            return localVarFp.getCommitmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment to this linemanager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByLinemanagerId(linemanagerId: string, options?: any): AxiosPromise<Array<CommitmentModel>> {
            return localVarFp.getCommitmentByLinemanagerId(linemanagerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name Send id to get specific Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByName(name: string, options?: any): AxiosPromise<string> {
            return localVarFp.getCommitmentByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related commitment to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByTeammemberIdForAdmin(teammemberId: string, options?: any): AxiosPromise<Array<CommitmentModel>> {
            return localVarFp.getCommitmentByTeammemberIdForAdmin(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitments(options?: any): AxiosPromise<Array<CommitmentModel>> {
            return localVarFp.getCommitments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsAndRelationsByDateRange(body: DateRangeRequestModel, options?: any): AxiosPromise<Array<CommitmentWithRelationsModel>> {
            return localVarFp.getCommitmentsAndRelationsByDateRange(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get all related commitment and relations to this linemanager
         * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsAndRelationsByLinemanagerId(linemanagerId: string, body: DateRangeRequestModel, options?: any): AxiosPromise<Array<CommitmentWithRelationsModel>> {
            return localVarFp.getCommitmentsAndRelationsByLinemanagerId(linemanagerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModelV2} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentsV2(body: PaginationRequestModelV2, options?: any): AxiosPromise<PaginationResponseModelCommitmentModel> {
            return localVarFp.getCommitmentsV2(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewCommitment(commitmentId: string, options?: any): AxiosPromise<GetReviewCommitmentModel> {
            return localVarFp.getReviewCommitment(commitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to remove the Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCommitment(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeCommitment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commitmentId 
         * @param {UpdateCommitmentStatusRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.teammemberUpdateCommitmentStatus(commitmentId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommitmentModel} body Fill id to Update existing Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommitment(body: CommitmentModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateCommitment(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommitmentApi - object-oriented interface
 * @export
 * @class CommitmentApi
 * @extends {BaseAPI}
 */
export class CommitmentApi extends BaseAPI {
    /**
     * 
     * @param {string} commitmentId 
     * @param {SendCommitmentNotificationRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public adminSendCommitmentNotification(commitmentId: string, body: SendCommitmentNotificationRequestModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).adminSendCommitmentNotification(commitmentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} commitmentId 
     * @param {UpdateCommitmentStatusRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public adminUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).adminUpdateCommitmentStatus(commitmentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public createCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).createCommitment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommitmentModel} body Don\&#39;t fill id to Create new Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public createCommitmentV2(body: CommitmentModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).createCommitmentV2(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId Send customerId to get all related commitment to this customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentByCustomerId(customerId: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentByCustomerId(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to get specific Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentById(id: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} linemanagerId Send linemanagerId to get all related commitment to this linemanager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentByLinemanagerId(linemanagerId: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentByLinemanagerId(linemanagerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name Send id to get specific Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentByName(name: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send TeammemberId to get all related commitment to this Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentByTeammemberIdForAdmin(teammemberId: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentByTeammemberIdForAdmin(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitments(options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentsAndRelationsByDateRange(body: DateRangeRequestModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentsAndRelationsByDateRange(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} linemanagerId Send linemanagerId to get all related commitment and relations to this linemanager
     * @param {DateRangeRequestModel} body Fill Date properties to get a Commitments and relations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentsAndRelationsByLinemanagerId(linemanagerId: string, body: DateRangeRequestModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentsAndRelationsByLinemanagerId(linemanagerId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModelV2} body Fill filter and pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getCommitmentsV2(body: PaginationRequestModelV2, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getCommitmentsV2(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} commitmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public getReviewCommitment(commitmentId: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).getReviewCommitment(commitmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to remove the Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public removeCommitment(id: string, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).removeCommitment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} commitmentId 
     * @param {UpdateCommitmentStatusRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public teammemberUpdateCommitmentStatus(commitmentId: string, body: UpdateCommitmentStatusRequestModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).teammemberUpdateCommitmentStatus(commitmentId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommitmentModel} body Fill id to Update existing Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommitmentApi
     */
    public updateCommitment(body: CommitmentModel, options?: RawAxiosRequestConfig) {
        return CommitmentApiFp(this.configuration).updateCommitment(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CoreSkillApi - axios parameter creator
 * @export
 */
export const CoreSkillApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send SkillId for approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveRequestedSkillByAdmin: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveRequestedSkillByAdmin', 'id', id)
            const localVarPath = `/V1/coreskill/approve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCoreSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/coreskill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoreSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/coreskill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoreSkillsWithDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/coreskill/fulldetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberGetCoreSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/coreskill/teammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CoreSkillApi - functional programming interface
 * @export
 */
export const CoreSkillApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CoreSkillApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send SkillId for approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveRequestedSkillByAdmin(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveRequestedSkillByAdmin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreSkillApi.approveRequestedSkillByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetCoreSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoreSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetCoreSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreSkillApi.clientGetCoreSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoreSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoreSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoreSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreSkillApi.getCoreSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoreSkillsWithDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoreSkillFullModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoreSkillsWithDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreSkillApi.getCoreSkillsWithDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teammemberGetCoreSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CoreSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teammemberGetCoreSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CoreSkillApi.teammemberGetCoreSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CoreSkillApi - factory interface
 * @export
 */
export const CoreSkillApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CoreSkillApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send SkillId for approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveRequestedSkillByAdmin(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.approveRequestedSkillByAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCoreSkills(options?: any): AxiosPromise<Array<CoreSkillModel>> {
            return localVarFp.clientGetCoreSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoreSkills(options?: any): AxiosPromise<Array<CoreSkillModel>> {
            return localVarFp.getCoreSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoreSkillsWithDetails(options?: any): AxiosPromise<Array<CoreSkillFullModel>> {
            return localVarFp.getCoreSkillsWithDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberGetCoreSkills(options?: any): AxiosPromise<Array<CoreSkillModel>> {
            return localVarFp.teammemberGetCoreSkills(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CoreSkillApi - object-oriented interface
 * @export
 * @class CoreSkillApi
 * @extends {BaseAPI}
 */
export class CoreSkillApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send SkillId for approval
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreSkillApi
     */
    public approveRequestedSkillByAdmin(id: string, options?: RawAxiosRequestConfig) {
        return CoreSkillApiFp(this.configuration).approveRequestedSkillByAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreSkillApi
     */
    public clientGetCoreSkills(options?: RawAxiosRequestConfig) {
        return CoreSkillApiFp(this.configuration).clientGetCoreSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreSkillApi
     */
    public getCoreSkills(options?: RawAxiosRequestConfig) {
        return CoreSkillApiFp(this.configuration).getCoreSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreSkillApi
     */
    public getCoreSkillsWithDetails(options?: RawAxiosRequestConfig) {
        return CoreSkillApiFp(this.configuration).getCoreSkillsWithDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreSkillApi
     */
    public teammemberGetCoreSkills(options?: RawAxiosRequestConfig) {
        return CoreSkillApiFp(this.configuration).teammemberGetCoreSkills(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CountryApi - axios parameter creator
 * @export
 */
export const CountryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/country`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} countryId Send countryId to Get City List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCities: async (countryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryId' is not null or undefined
            assertParamExists('getCities', 'countryId', countryId)
            const localVarPath = `/V1/country/getCities/{countryId}`
                .replace(`{${"countryId"}}`, encodeURIComponent(String(countryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/country`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CountryApi - functional programming interface
 * @export
 */
export const CountryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CountryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryApi.clientGetCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} countryId Send countryId to Get City List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCities(countryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CityModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCities(countryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryApi.getCities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CountryApi.getCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CountryApi - factory interface
 * @export
 */
export const CountryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CountryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetCountries(options?: any): AxiosPromise<Array<CountryModel>> {
            return localVarFp.clientGetCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} countryId Send countryId to Get City List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCities(countryId: string, options?: any): AxiosPromise<Array<CityModel>> {
            return localVarFp.getCities(countryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(options?: any): AxiosPromise<Array<CountryModel>> {
            return localVarFp.getCountries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CountryApi - object-oriented interface
 * @export
 * @class CountryApi
 * @extends {BaseAPI}
 */
export class CountryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryApi
     */
    public clientGetCountries(options?: RawAxiosRequestConfig) {
        return CountryApiFp(this.configuration).clientGetCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} countryId Send countryId to Get City List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryApi
     */
    public getCities(countryId: string, options?: RawAxiosRequestConfig) {
        return CountryApiFp(this.configuration).getCities(countryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryApi
     */
    public getCountries(options?: RawAxiosRequestConfig) {
        return CountryApiFp(this.configuration).getCountries(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfficeLocation: async (authorization: string, customerId: string, body: OfficeLocationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addOfficeLocation', 'authorization', authorization)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('addOfficeLocation', 'customerId', customerId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addOfficeLocation', 'body', body)
            const localVarPath = `/V1/customer/{customerId}/officeLocation`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (body: ManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createCustomer', 'body', body)
            const localVarPath = `/V1/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeLocation: async (authorization: string, customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOfficeLocation', 'authorization', authorization)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getOfficeLocation', 'customerId', customerId)
            const localVarPath = `/V1/customer/{customerId}/officeLocation`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOfficeLocation(authorization: string, customerId: string, body: OfficeLocationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOfficeLocation(authorization, customerId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.addOfficeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(body: ManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfficeLocation(authorization: string, customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfficeLocationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfficeLocation(authorization, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getOfficeLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {OfficeLocationModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOfficeLocation(authorization: string, customerId: string, body: OfficeLocationModel, options?: any): AxiosPromise<string> {
            return localVarFp.addOfficeLocation(authorization, customerId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(body: ManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createCustomer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(options?: any): AxiosPromise<Array<CustomerModel>> {
            return localVarFp.getCustomers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorization Send Token to check authorization
         * @param {string} customerId Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeLocation(authorization: string, customerId: string, options?: any): AxiosPromise<Array<OfficeLocationModel>> {
            return localVarFp.getOfficeLocation(authorization, customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {string} customerId Send id to get specific Customer
     * @param {OfficeLocationModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public addOfficeLocation(authorization: string, customerId: string, body: OfficeLocationModel, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addOfficeLocation(authorization, customerId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerModel} body Don\&#39;t fill id to Create new Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createCustomer(body: ManagerModel, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createCustomer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getCustomers(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorization Send Token to check authorization
     * @param {string} customerId Send id to get specific Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getOfficeLocation(authorization: string, customerId: string, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getOfficeLocation(authorization, customerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerInvoiceApi - axios parameter creator
 * @export
 */
export const CustomerInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomerInvoiceVM} body Don\&#39;t fill id to Create new customer invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerInvoice: async (body: CustomerInvoiceVM, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createCustomerInvoice', 'body', body)
            const localVarPath = `/V1/customerInvoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<CustomerInvoicePaymentVM>} body Fill id to set customer invoice payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerInvoiceSetPayments: async (id: string, body: Array<CustomerInvoicePaymentVM>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('customerInvoiceSetPayments', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('customerInvoiceSetPayments', 'body', body)
            const localVarPath = `/V1/customerInvoice/setPayments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId Send Customer Id to get the Customer Invoice
         * @param {string} fromDate Send From Date to get the Customer Invoice
         * @param {string} toDate Send To Date to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomerInvoice: async (customerId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('generateCustomerInvoice', 'customerId', customerId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('generateCustomerInvoice', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('generateCustomerInvoice', 'toDate', toDate)
            const localVarPath = `/V1/customerInvoice/generate/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerInvoice', 'id', id)
            const localVarPath = `/V1/customerInvoice/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerInvoiceApi - functional programming interface
 * @export
 */
export const CustomerInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CustomerInvoiceVM} body Don\&#39;t fill id to Create new customer invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerInvoice(body: CustomerInvoiceVM, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerInvoice(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerInvoiceApi.createCustomerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<CustomerInvoicePaymentVM>} body Fill id to set customer invoice payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerInvoiceSetPayments(id: string, body: Array<CustomerInvoicePaymentVM>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerInvoiceSetPayments(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerInvoiceApi.customerInvoiceSetPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId Send Customer Id to get the Customer Invoice
         * @param {string} fromDate Send From Date to get the Customer Invoice
         * @param {string} toDate Send To Date to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCustomerInvoice(customerId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInvoiceVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCustomerInvoice(customerId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerInvoiceApi.generateCustomerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerInvoice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerInvoiceVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerInvoice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerInvoiceApi.getCustomerInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerInvoiceApi - factory interface
 * @export
 */
export const CustomerInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomerInvoiceVM} body Don\&#39;t fill id to Create new customer invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerInvoice(body: CustomerInvoiceVM, options?: any): AxiosPromise<string> {
            return localVarFp.createCustomerInvoice(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<CustomerInvoicePaymentVM>} body Fill id to set customer invoice payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerInvoiceSetPayments(id: string, body: Array<CustomerInvoicePaymentVM>, options?: any): AxiosPromise<Result> {
            return localVarFp.customerInvoiceSetPayments(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId Send Customer Id to get the Customer Invoice
         * @param {string} fromDate Send From Date to get the Customer Invoice
         * @param {string} toDate Send To Date to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCustomerInvoice(customerId: string, fromDate: string, toDate: string, options?: any): AxiosPromise<CustomerInvoiceVM> {
            return localVarFp.generateCustomerInvoice(customerId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to get the Customer Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerInvoice(id: string, options?: any): AxiosPromise<CustomerInvoiceVM> {
            return localVarFp.getCustomerInvoice(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerInvoiceApi - object-oriented interface
 * @export
 * @class CustomerInvoiceApi
 * @extends {BaseAPI}
 */
export class CustomerInvoiceApi extends BaseAPI {
    /**
     * 
     * @param {CustomerInvoiceVM} body Don\&#39;t fill id to Create new customer invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApi
     */
    public createCustomerInvoice(body: CustomerInvoiceVM, options?: RawAxiosRequestConfig) {
        return CustomerInvoiceApiFp(this.configuration).createCustomerInvoice(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<CustomerInvoicePaymentVM>} body Fill id to set customer invoice payment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApi
     */
    public customerInvoiceSetPayments(id: string, body: Array<CustomerInvoicePaymentVM>, options?: RawAxiosRequestConfig) {
        return CustomerInvoiceApiFp(this.configuration).customerInvoiceSetPayments(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId Send Customer Id to get the Customer Invoice
     * @param {string} fromDate Send From Date to get the Customer Invoice
     * @param {string} toDate Send To Date to get the Customer Invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApi
     */
    public generateCustomerInvoice(customerId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return CustomerInvoiceApiFp(this.configuration).generateCustomerInvoice(customerId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to get the Customer Invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerInvoiceApi
     */
    public getCustomerInvoice(id: string, options?: RawAxiosRequestConfig) {
        return CustomerInvoiceApiFp(this.configuration).getCustomerInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerById', 'id', id)
            const localVarPath = `/V1/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: async (body: ManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCustomer', 'body', body)
            const localVarPath = `/V1/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.getCustomerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomer(body: ManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomer(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.updateCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getCustomerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer(body: ManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateCustomer(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send id to get specific Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomerById(id: string, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).getCustomerById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerModel} body Fill id to Update existing Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public updateCustomer(body: ManagerModel, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).updateCustomer(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} refreshToken Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshToken' is not null or undefined
            assertParamExists('refreshToken', 'refreshToken', refreshToken)
            const localVarPath = `/V1/authentication/refreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (refreshToken != null) {
                localVarHeaderParameter['RefreshToken'] = String(refreshToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} refreshToken Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiObjectResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {string} refreshToken Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshToken: string, options?: any): AxiosPromise<ApiObjectResult> {
            return localVarFp.refreshToken(refreshToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {string} refreshToken Refresh Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshToken(refreshToken: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshToken(refreshToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DetailsApi - axios parameter creator
 * @export
 */
export const DetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberGetDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/details/teammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetailsApi - functional programming interface
 * @export
 */
export const DetailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DetailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DetailsApi.clientGetDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DetailsApi.getDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teammemberGetDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teammemberGetDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DetailsApi.teammemberGetDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DetailsApi - factory interface
 * @export
 */
export const DetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DetailsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetDetails(options?: any): AxiosPromise<Array<DetailsModel>> {
            return localVarFp.clientGetDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(options?: any): AxiosPromise<Array<DetailsModel>> {
            return localVarFp.getDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberGetDetails(options?: any): AxiosPromise<Array<DetailsModel>> {
            return localVarFp.teammemberGetDetails(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DetailsApi - object-oriented interface
 * @export
 * @class DetailsApi
 * @extends {BaseAPI}
 */
export class DetailsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public clientGetDetails(options?: RawAxiosRequestConfig) {
        return DetailsApiFp(this.configuration).clientGetDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public getDetails(options?: RawAxiosRequestConfig) {
        return DetailsApiFp(this.configuration).getDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public teammemberGetDetails(options?: RawAxiosRequestConfig) {
        return DetailsApiFp(this.configuration).teammemberGetDetails(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EditorApi - axios parameter creator
 * @export
 */
export const EditorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetEditors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/client/editor/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEditors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/editor/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EditorApi - functional programming interface
 * @export
 */
export const EditorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EditorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetEditors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EditorModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetEditors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditorApi.clientGetEditors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEditors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EditorModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEditors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditorApi.getEditors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EditorApi - factory interface
 * @export
 */
export const EditorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EditorApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetEditors(options?: any): AxiosPromise<Array<EditorModel>> {
            return localVarFp.clientGetEditors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEditors(options?: any): AxiosPromise<Array<EditorModel>> {
            return localVarFp.getEditors(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EditorApi - object-oriented interface
 * @export
 * @class EditorApi
 * @extends {BaseAPI}
 */
export class EditorApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EditorApi
     */
    public clientGetEditors(options?: RawAxiosRequestConfig) {
        return EditorApiFp(this.configuration).clientGetEditors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EditorApi
     */
    public getEditors(options?: RawAxiosRequestConfig) {
        return EditorApiFp(this.configuration).getEditors(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EpicApi - axios parameter creator
 * @export
 */
export const EpicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} projectId Send projectId to get Epics of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEpicOfProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getEpicOfProject', 'projectId', projectId)
            const localVarPath = `/V1/epic/getEpicOfProject/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEpic: async (body: EpicRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveEpic', 'body', body)
            const localVarPath = `/V1/epic/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEpicClient: async (body: EpicRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveEpicClient', 'body', body)
            const localVarPath = `/V1/client/dashboard/epic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EpicModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEpic: async (body: EpicModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateEpic', 'body', body)
            const localVarPath = `/V1/epic/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EpicApi - functional programming interface
 * @export
 */
export const EpicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EpicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} projectId Send projectId to get Epics of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEpicOfProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpicModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEpicOfProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EpicApi.getEpicOfProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEpic(body: EpicRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpicModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEpic(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EpicApi.saveEpic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEpicClient(body: EpicRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpicModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEpicClient(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EpicApi.saveEpicClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EpicModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEpic(body: EpicModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EpicModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEpic(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EpicApi.updateEpic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EpicApi - factory interface
 * @export
 */
export const EpicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EpicApiFp(configuration)
    return {
        /**
         * 
         * @param {string} projectId Send projectId to get Epics of the project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEpicOfProject(projectId: string, options?: any): AxiosPromise<EpicModel> {
            return localVarFp.getEpicOfProject(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEpic(body: EpicRequestModel, options?: any): AxiosPromise<EpicModel> {
            return localVarFp.saveEpic(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEpicClient(body: EpicRequestModel, options?: any): AxiosPromise<EpicModel> {
            return localVarFp.saveEpicClient(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EpicModel} body Will add EpicTitle for the filled ProjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEpic(body: EpicModel, options?: any): AxiosPromise<EpicModel> {
            return localVarFp.updateEpic(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EpicApi - object-oriented interface
 * @export
 * @class EpicApi
 * @extends {BaseAPI}
 */
export class EpicApi extends BaseAPI {
    /**
     * 
     * @param {string} projectId Send projectId to get Epics of the project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpicApi
     */
    public getEpicOfProject(projectId: string, options?: RawAxiosRequestConfig) {
        return EpicApiFp(this.configuration).getEpicOfProject(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpicApi
     */
    public saveEpic(body: EpicRequestModel, options?: RawAxiosRequestConfig) {
        return EpicApiFp(this.configuration).saveEpic(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EpicRequestModel} body Will add EpicTitle for the filled ProjectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpicApi
     */
    public saveEpicClient(body: EpicRequestModel, options?: RawAxiosRequestConfig) {
        return EpicApiFp(this.configuration).saveEpicClient(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EpicModel} body Will add EpicTitle for the filled ProjectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EpicApi
     */
    public updateEpic(body: EpicModel, options?: RawAxiosRequestConfig) {
        return EpicApiFp(this.configuration).updateEpic(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeaveApi - axios parameter creator
 * @export
 */
export const LeaveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLeaveDateRangeList: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAdminLeaveDateRangeList', 'body', body)
            const localVarPath = `/V1/leave/admin/GetDateRangeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to Get the leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLeaveById', 'id', id)
            const localVarPath = `/V1/leave/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to Get the Leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveByIdForAdmin: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLeaveByIdForAdmin', 'id', id)
            const localVarPath = `/V1/leave/admin/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveDateRangeList: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getLeaveDateRangeList', 'body', body)
            const localVarPath = `/V1/leave/GetDateRangeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdminLeave: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeAdminLeave', 'id', id)
            const localVarPath = `/V1/leave/admin/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLeave: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeLeave', 'id', id)
            const localVarPath = `/V1/leave/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdminLeave: async (body: LeaveModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveAdminLeave', 'body', body)
            const localVarPath = `/V1/leave/admin/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLeave: async (body: LeaveModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveLeave', 'body', body)
            const localVarPath = `/V1/leave/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaveApi - functional programming interface
 * @export
 */
export const LeaveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeaveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminLeaveDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeaveModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminLeaveDateRangeList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.getAdminLeaveDateRangeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to Get the leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaveById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaveById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.getLeaveById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to Get the Leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaveByIdForAdmin(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaveByIdForAdmin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.getLeaveByIdForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaveDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeaveModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaveDateRangeList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.getLeaveDateRangeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAdminLeave(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAdminLeave(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.removeAdminLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLeave(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLeave(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.removeLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAdminLeave(body: LeaveModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAdminLeave(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.saveAdminLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLeave(body: LeaveModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLeave(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaveApi.saveLeave']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeaveApi - factory interface
 * @export
 */
export const LeaveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeaveApiFp(configuration)
    return {
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLeaveDateRangeList(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<LeaveModel>> {
            return localVarFp.getAdminLeaveDateRangeList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to Get the leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveById(id: string, options?: any): AxiosPromise<LeaveDetailResponseModel> {
            return localVarFp.getLeaveById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to Get the Leave by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveByIdForAdmin(id: string, options?: any): AxiosPromise<LeaveDetailResponseModel> {
            return localVarFp.getLeaveByIdForAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaveDateRangeList(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<LeaveModel>> {
            return localVarFp.getLeaveDateRangeList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdminLeave(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeAdminLeave(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to remove the Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLeave(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeLeave(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAdminLeave(body: LeaveModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveAdminLeave(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLeave(body: LeaveModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveLeave(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeaveApi - object-oriented interface
 * @export
 * @class LeaveApi
 * @extends {BaseAPI}
 */
export class LeaveApi extends BaseAPI {
    /**
     * 
     * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public getAdminLeaveDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).getAdminLeaveDateRangeList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to Get the leave by Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public getLeaveById(id: string, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).getLeaveById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to Get the Leave by Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public getLeaveByIdForAdmin(id: string, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).getLeaveByIdForAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember leaves between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public getLeaveDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).getLeaveDateRangeList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to remove the Leave
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public removeAdminLeave(id: string, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).removeAdminLeave(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to remove the Leave
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public removeLeave(id: string, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).removeLeave(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public saveAdminLeave(body: LeaveModel, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).saveAdminLeave(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LeaveModel} body Fill Id to update specific Leave otherwise it will add new Leave
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeaveApi
     */
    public saveLeave(body: LeaveModel, options?: RawAxiosRequestConfig) {
        return LeaveApiFp(this.configuration).saveLeave(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LineManagersApi - axios parameter creator
 * @export
 */
export const LineManagersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LineManagerModel} body Don\&#39;t fill id to Create new Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLineManager: async (body: LineManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createLineManager', 'body', body)
            const localVarPath = `/V1/lineManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineManagerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLineManagerById', 'id', id)
            const localVarPath = `/V1/lineManagers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineManagerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/lineManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LineManagerModel} body Fill id to Update existing Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineManager: async (body: LineManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateLineManager', 'body', body)
            const localVarPath = `/V1/lineManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LineManagersApi - functional programming interface
 * @export
 */
export const LineManagersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LineManagersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LineManagerModel} body Don\&#39;t fill id to Create new Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLineManager(body: LineManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLineManager(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LineManagersApi.createLineManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineManagerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineManagerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LineManagersApi.getLineManagerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineManagerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LineManagerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineManagerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LineManagersApi.getLineManagerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LineManagerModel} body Fill id to Update existing Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLineManager(body: LineManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLineManager(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LineManagersApi.updateLineManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LineManagersApi - factory interface
 * @export
 */
export const LineManagersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LineManagersApiFp(configuration)
    return {
        /**
         * 
         * @param {LineManagerModel} body Don\&#39;t fill id to Create new Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLineManager(body: LineManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createLineManager(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to get specific Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineManagerById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getLineManagerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineManagerList(options?: any): AxiosPromise<Array<LineManagerModel>> {
            return localVarFp.getLineManagerList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LineManagerModel} body Fill id to Update existing Line Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLineManager(body: LineManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateLineManager(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LineManagersApi - object-oriented interface
 * @export
 * @class LineManagersApi
 * @extends {BaseAPI}
 */
export class LineManagersApi extends BaseAPI {
    /**
     * 
     * @param {LineManagerModel} body Don\&#39;t fill id to Create new Line Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineManagersApi
     */
    public createLineManager(body: LineManagerModel, options?: RawAxiosRequestConfig) {
        return LineManagersApiFp(this.configuration).createLineManager(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to get specific Line Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineManagersApi
     */
    public getLineManagerById(id: string, options?: RawAxiosRequestConfig) {
        return LineManagersApiFp(this.configuration).getLineManagerById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineManagersApi
     */
    public getLineManagerList(options?: RawAxiosRequestConfig) {
        return LineManagersApiFp(this.configuration).getLineManagerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LineManagerModel} body Fill id to Update existing Line Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LineManagersApi
     */
    public updateLineManager(body: LineManagerModel, options?: RawAxiosRequestConfig) {
        return LineManagersApiFp(this.configuration).updateLineManager(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApi - axios parameter creator
 * @export
 */
export const LoanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoan: async (body: LoanModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addLoan', 'body', body)
            const localVarPath = `/V1/loan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoanAdmin: async (body: LoanModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addLoanAdmin', 'body', body)
            const localVarPath = `/V1/loan/addByAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoan: async (id: string, body: LoanModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLoan', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteLoan', 'body', body)
            const localVarPath = `/V1/loan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoanByAdmin: async (id: string, body: LoanModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLoanByAdmin', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteLoanByAdmin', 'body', body)
            const localVarPath = `/V1/loan/deleteByAdmin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoanRequestModel} body Get All Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLoans: async (body: LoanRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAllLoans', 'body', body)
            const localVarPath = `/V1/loan/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body Get Last Unpaid Item Of Loan By TeamMember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUnpaidItemOfLoanByTeamMemberId: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getLastUnpaidItemOfLoanByTeamMemberId', 'body', body)
            const localVarPath = `/V1/loan/getLastUnpaidItemOfLoanByTeamMemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} body Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanByTeamMemberId: async (body: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getLoanByTeamMemberId', 'body', body)
            const localVarPath = `/V1/loan/getByTeammemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanApproval: async (body: LoanApprovalModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loanApproval', 'body', body)
            const localVarPath = `/V1/loan/approval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} payRunId 
         * @param {Array<LoanItemModel>} body Loan Installment Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanInstallmentPayment: async (payRunId: string, body: Array<LoanItemModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'payRunId' is not null or undefined
            assertParamExists('loanInstallmentPayment', 'payRunId', payRunId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loanInstallmentPayment', 'body', body)
            const localVarPath = `/V1/loan/installmentPayment/{payRunId}`
                .replace(`{${"payRunId"}}`, encodeURIComponent(String(payRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanPayment: async (body: LoanApprovalModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loanPayment', 'body', body)
            const localVarPath = `/V1/loan/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoanModel} body update Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoan: async (body: LoanModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateLoan', 'body', body)
            const localVarPath = `/V1/loan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApi - functional programming interface
 * @export
 */
export const LoanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLoan(body: LoanModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLoan(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.addLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLoanAdmin(body: LoanModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLoanAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.addLoanAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLoan(id: string, body: LoanModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLoan(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.deleteLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLoanByAdmin(id: string, body: LoanModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLoanByAdmin(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.deleteLoanByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoanRequestModel} body Get All Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLoans(body: LoanRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLoans(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.getAllLoans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} body Get Last Unpaid Item Of Loan By TeamMember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastUnpaidItemOfLoanByTeamMemberId(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoanModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastUnpaidItemOfLoanByTeamMemberId(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.getLastUnpaidItemOfLoanByTeamMemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} body Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanByTeamMemberId(body: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanByTeamMemberId(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.getLoanByTeamMemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loanApproval(body: LoanApprovalModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loanApproval(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.loanApproval']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} payRunId 
         * @param {Array<LoanItemModel>} body Loan Installment Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loanInstallmentPayment(payRunId: string, body: Array<LoanItemModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loanInstallmentPayment(payRunId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.loanInstallmentPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loanPayment(body: LoanApprovalModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loanPayment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.loanPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoanModel} body update Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoan(body: LoanModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoan(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApi.updateLoan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApi - factory interface
 * @export
 */
export const LoanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApiFp(configuration)
    return {
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoan(body: LoanModel, options?: any): AxiosPromise<string> {
            return localVarFp.addLoan(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoanModel} body Add new Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLoanAdmin(body: LoanModel, options?: any): AxiosPromise<string> {
            return localVarFp.addLoanAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoan(id: string, body: LoanModel, options?: any): AxiosPromise<string> {
            return localVarFp.deleteLoan(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {LoanModel} body delete Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoanByAdmin(id: string, body: LoanModel, options?: any): AxiosPromise<string> {
            return localVarFp.deleteLoanByAdmin(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoanRequestModel} body Get All Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLoans(body: LoanRequestModel, options?: any): AxiosPromise<LoanListResult> {
            return localVarFp.getAllLoans(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body Get Last Unpaid Item Of Loan By TeamMember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUnpaidItemOfLoanByTeamMemberId(body: string, options?: any): AxiosPromise<Array<LoanModel>> {
            return localVarFp.getLastUnpaidItemOfLoanByTeamMemberId(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} body Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanByTeamMemberId(body: PaginationRequestModel, options?: any): AxiosPromise<LoanListResult> {
            return localVarFp.getLoanByTeamMemberId(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanApproval(body: LoanApprovalModel, options?: any): AxiosPromise<string> {
            return localVarFp.loanApproval(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} payRunId 
         * @param {Array<LoanItemModel>} body Loan Installment Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanInstallmentPayment(payRunId: string, body: Array<LoanItemModel>, options?: any): AxiosPromise<string> {
            return localVarFp.loanInstallmentPayment(payRunId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoanApprovalModel} body Loan Payment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loanPayment(body: LoanApprovalModel, options?: any): AxiosPromise<string> {
            return localVarFp.loanPayment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoanModel} body update Loan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoan(body: LoanModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateLoan(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanApi - object-oriented interface
 * @export
 * @class LoanApi
 * @extends {BaseAPI}
 */
export class LoanApi extends BaseAPI {
    /**
     * 
     * @param {LoanModel} body Add new Loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public addLoan(body: LoanModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).addLoan(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoanModel} body Add new Loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public addLoanAdmin(body: LoanModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).addLoanAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {LoanModel} body delete Loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public deleteLoan(id: string, body: LoanModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).deleteLoan(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {LoanModel} body delete Loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public deleteLoanByAdmin(id: string, body: LoanModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).deleteLoanByAdmin(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoanRequestModel} body Get All Loans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getAllLoans(body: LoanRequestModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).getAllLoans(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body Get Last Unpaid Item Of Loan By TeamMember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getLastUnpaidItemOfLoanByTeamMemberId(body: string, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).getLastUnpaidItemOfLoanByTeamMemberId(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} body Fill TeamMember Id to get TeamMember\&#39;s Loans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public getLoanByTeamMemberId(body: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).getLoanByTeamMemberId(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoanApprovalModel} body Loan Approval
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public loanApproval(body: LoanApprovalModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).loanApproval(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} payRunId 
     * @param {Array<LoanItemModel>} body Loan Installment Payment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public loanInstallmentPayment(payRunId: string, body: Array<LoanItemModel>, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).loanInstallmentPayment(payRunId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoanApprovalModel} body Loan Payment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public loanPayment(body: LoanApprovalModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).loanPayment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoanModel} body update Loan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    public updateLoan(body: LoanModel, options?: RawAxiosRequestConfig) {
        return LoanApiFp(this.configuration).updateLoan(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} commitmentId The ID of commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCommitmentNotifications: async (commitmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitmentId' is not null or undefined
            assertParamExists('adminGetCommitmentNotifications', 'commitmentId', commitmentId)
            const localVarPath = `/V1/notification/getByCommitmentId/{commitmentId}`
                .replace(`{${"commitmentId"}}`, encodeURIComponent(String(commitmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeClientNotificationStatus: async (body: NotificationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('changeClientNotificationStatus', 'body', body)
            const localVarPath = `/V1/notification/client/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNotificationStatus: async (body: NotificationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('changeNotificationStatus', 'body', body)
            const localVarPath = `/V1/notification/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creatSupportNotifications: async (body?: AdminSupportNotificationItemModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/notification/createSupport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationModel} body Don\&#39;t fill id to Create new Notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (body: NotificationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createNotification', 'body', body)
            const localVarPath = `/V1/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNoneSeenNotificationItemsByUserEmail: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getClientNoneSeenNotificationItemsByUserEmail', 'teammemberId', teammemberId)
            const localVarPath = `/V1/notification/client/getNoneSeenNotificationItemsByUserEmail`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNotificationItemsByUserEmail: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getClientNotificationItemsByUserEmail', 'teammemberId', teammemberId)
            const localVarPath = `/V1/notification/client/getItemsByUserEmail`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationId Send id to get Notification items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsByNotificationId: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getItemsByNotificationId', 'notificationId', notificationId)
            const localVarPath = `/V1/notification/items/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoneSeenNotificationItemsByUserEmail: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getNoneSeenNotificationItemsByUserEmail', 'teammemberId', teammemberId)
            const localVarPath = `/V1/notification/getNoneSeenNotificationItemsByUserEmail`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationItemsByUserEmail: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getNotificationItemsByUserEmail', 'teammemberId', teammemberId)
            const localVarPath = `/V1/notification/getItemsByUserEmail`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} positionTaskId The ID of positiontask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionTaskNotifications: async (positionTaskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionTaskId' is not null or undefined
            assertParamExists('getPositionTaskNotifications', 'positionTaskId', positionTaskId)
            const localVarPath = `/V1/notification/tasks/{positionTaskId}`
                .replace(`{${"positionTaskId"}}`, encodeURIComponent(String(positionTaskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} supportItemId The ID of the support notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotificationById: async (supportItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportItemId' is not null or undefined
            assertParamExists('getSupportNotificationById', 'supportItemId', supportItemId)
            const localVarPath = `/V1/notification/getSupport/{supportItemId}`
                .replace(`{${"supportItemId"}}`, encodeURIComponent(String(supportItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotifications: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/notification/getSupportList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeClientSeenReply: async (notificationItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationItemId' is not null or undefined
            assertParamExists('makeClientSeenReply', 'notificationItemId', notificationItemId)
            const localVarPath = `/V1/notification/client/{notificationItemId}/reply/seen`
                .replace(`{${"notificationItemId"}}`, encodeURIComponent(String(notificationItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeSeenReply: async (notificationItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationItemId' is not null or undefined
            assertParamExists('makeSeenReply', 'notificationItemId', notificationItemId)
            const localVarPath = `/V1/notification/{notificationItemId}/reply/seen`
                .replace(`{${"notificationItemId"}}`, encodeURIComponent(String(notificationItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyClientNotificationItem: async (body: NotificationItemReplyRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('replyClientNotificationItem', 'body', body)
            const localVarPath = `/V1/notification/client/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyNotificationItem: async (body: NotificationItemReplyRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('replyNotificationItem', 'body', body)
            const localVarPath = `/V1/notification/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replySupportNotification: async (body: AdminSupportNotificationItemModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('replySupportNotification', 'body', body)
            const localVarPath = `/V1/notification/replySupport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item to be withdrawn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawClientNotificationId: async (notificationItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationItemId' is not null or undefined
            assertParamExists('withdrawClientNotificationId', 'notificationItemId', notificationItemId)
            const localVarPath = `/V1/notification/client/{notificationItemId}/withdraw`
                .replace(`{${"notificationItemId"}}`, encodeURIComponent(String(notificationItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawNotificationId: async (notificationItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationItemId' is not null or undefined
            assertParamExists('withdrawNotificationId', 'notificationItemId', notificationItemId)
            const localVarPath = `/V1/notification/{notificationItemId}/withdraw`
                .replace(`{${"notificationItemId"}}`, encodeURIComponent(String(notificationItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} commitmentId The ID of commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetCommitmentNotifications(commitmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetCommitmentNotifications(commitmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.adminGetCommitmentNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeClientNotificationStatus(body: NotificationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeClientNotificationStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.changeClientNotificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeNotificationStatus(body: NotificationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeNotificationStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.changeNotificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creatSupportNotifications(body?: AdminSupportNotificationItemModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creatSupportNotifications(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.creatSupportNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationModel} body Don\&#39;t fill id to Create new Notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(body: NotificationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientNoneSeenNotificationItemsByUserEmail(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getClientNoneSeenNotificationItemsByUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultNotificationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientNotificationItemsByUserEmail(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getClientNotificationItemsByUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationId Send id to get Notification items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemsByNotificationId(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemsByNotificationId(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getItemsByNotificationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoneSeenNotificationItemsByUserEmail(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNoneSeenNotificationItemsByUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultNotificationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationItemsByUserEmail(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotificationItemsByUserEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NotificationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} positionTaskId The ID of positiontask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionTaskNotifications(positionTaskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListResultNotificationItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionTaskNotifications(positionTaskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getPositionTaskNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} supportItemId The ID of the support notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportNotificationById(supportItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSupportNotificationItemModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportNotificationById(supportItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getSupportNotificationById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportNotifications(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelAdminSupportNotificationItemModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportNotifications(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getSupportNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeClientSeenReply(notificationItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeClientSeenReply(notificationItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.makeClientSeenReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeSeenReply(notificationItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeSeenReply(notificationItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.makeSeenReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replyClientNotificationItem(body: NotificationItemReplyRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultNotificationItemReply>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replyClientNotificationItem(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.replyClientNotificationItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replyNotificationItem(body: NotificationItemReplyRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultNotificationItemReply>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replyNotificationItem(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.replyNotificationItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replySupportNotification(body: AdminSupportNotificationItemModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replySupportNotification(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.replySupportNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item to be withdrawn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawClientNotificationId(notificationItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawClientNotificationId(notificationItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.withdrawClientNotificationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawNotificationId(notificationItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawNotificationId(notificationItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.withdrawNotificationId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} commitmentId The ID of commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCommitmentNotifications(commitmentId: string, options?: any): AxiosPromise<Array<NotificationItem>> {
            return localVarFp.adminGetCommitmentNotifications(commitmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeClientNotificationStatus(body: NotificationRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.changeClientNotificationStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationRequestModel} body fill id to Update Notification Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeNotificationStatus(body: NotificationRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.changeNotificationStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creatSupportNotifications(body?: AdminSupportNotificationItemModel, options?: any): AxiosPromise<string> {
            return localVarFp.creatSupportNotifications(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationModel} body Don\&#39;t fill id to Create new Notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(body: NotificationModel, options?: any): AxiosPromise<string> {
            return localVarFp.createNotification(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: any): AxiosPromise<number> {
            return localVarFp.getClientNoneSeenNotificationItemsByUserEmail(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientNotificationItemsByUserEmail(teammemberId: string, options?: any): AxiosPromise<ListResultNotificationItem> {
            return localVarFp.getClientNotificationItemsByUserEmail(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationId Send id to get Notification items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsByNotificationId(notificationId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getItemsByNotificationId(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: any): AxiosPromise<number> {
            return localVarFp.getNoneSeenNotificationItemsByUserEmail(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationItemsByUserEmail(teammemberId: string, options?: any): AxiosPromise<ListResultNotificationItem> {
            return localVarFp.getNotificationItemsByUserEmail(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(options?: any): AxiosPromise<Array<NotificationModel>> {
            return localVarFp.getNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} positionTaskId The ID of positiontask
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionTaskNotifications(positionTaskId: string, options?: any): AxiosPromise<ListResultNotificationItem> {
            return localVarFp.getPositionTaskNotifications(positionTaskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} supportItemId The ID of the support notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotificationById(supportItemId: string, options?: any): AxiosPromise<AdminSupportNotificationItemModel> {
            return localVarFp.getSupportNotificationById(supportItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportNotifications(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelAdminSupportNotificationItemModel> {
            return localVarFp.getSupportNotifications(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeClientSeenReply(notificationItemId: string, options?: any): AxiosPromise<ResultString> {
            return localVarFp.makeClientSeenReply(notificationItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeSeenReply(notificationItemId: string, options?: any): AxiosPromise<ResultString> {
            return localVarFp.makeSeenReply(notificationItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyClientNotificationItem(body: NotificationItemReplyRequestModel, options?: any): AxiosPromise<ResultNotificationItemReply> {
            return localVarFp.replyClientNotificationItem(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationItemReplyRequestModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replyNotificationItem(body: NotificationItemReplyRequestModel, options?: any): AxiosPromise<ResultNotificationItemReply> {
            return localVarFp.replyNotificationItem(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminSupportNotificationItemModel} body Reply Notification Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replySupportNotification(body: AdminSupportNotificationItemModel, options?: any): AxiosPromise<string> {
            return localVarFp.replySupportNotification(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item to be withdrawn
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawClientNotificationId(notificationItemId: string, options?: any): AxiosPromise<ResultString> {
            return localVarFp.withdrawClientNotificationId(notificationItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationItemId The ID of the notification item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawNotificationId(notificationItemId: string, options?: any): AxiosPromise<ResultString> {
            return localVarFp.withdrawNotificationId(notificationItemId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @param {string} commitmentId The ID of commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public adminGetCommitmentNotifications(commitmentId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).adminGetCommitmentNotifications(commitmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationRequestModel} body fill id to Update Notification Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public changeClientNotificationStatus(body: NotificationRequestModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).changeClientNotificationStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationRequestModel} body fill id to Update Notification Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public changeNotificationStatus(body: NotificationRequestModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).changeNotificationStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminSupportNotificationItemModel} [body] Pagination items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public creatSupportNotifications(body?: AdminSupportNotificationItemModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).creatSupportNotifications(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationModel} body Don\&#39;t fill id to Create new Notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public createNotification(body: NotificationModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createNotification(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getClientNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getClientNoneSeenNotificationItemsByUserEmail(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getClientNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getClientNotificationItemsByUserEmail(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationId Send id to get Notification items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getItemsByNotificationId(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getItemsByNotificationId(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNoneSeenNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNoneSeenNotificationItemsByUserEmail(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send id to get Teammember\&#39;s Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotificationItemsByUserEmail(teammemberId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotificationItemsByUserEmail(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotifications(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} positionTaskId The ID of positiontask
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getPositionTaskNotifications(positionTaskId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getPositionTaskNotifications(positionTaskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} supportItemId The ID of the support notification item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getSupportNotificationById(supportItemId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getSupportNotificationById(supportItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Pagination items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getSupportNotifications(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getSupportNotifications(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationItemId The ID of the notification item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public makeClientSeenReply(notificationItemId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).makeClientSeenReply(notificationItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationItemId The ID of the notification item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public makeSeenReply(notificationItemId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).makeSeenReply(notificationItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationItemReplyRequestModel} body Reply Notification Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public replyClientNotificationItem(body: NotificationItemReplyRequestModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).replyClientNotificationItem(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationItemReplyRequestModel} body Reply Notification Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public replyNotificationItem(body: NotificationItemReplyRequestModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).replyNotificationItem(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminSupportNotificationItemModel} body Reply Notification Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public replySupportNotification(body: AdminSupportNotificationItemModel, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).replySupportNotification(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationItemId The ID of the notification item to be withdrawn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public withdrawClientNotificationId(notificationItemId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).withdrawClientNotificationId(notificationItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationItemId The ID of the notification item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public withdrawNotificationId(notificationItemId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).withdrawNotificationId(notificationItemId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OfficeSpaceApi - axios parameter creator
 * @export
 */
export const OfficeSpaceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeSpace: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/officeSpace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OfficeSpaceApi - functional programming interface
 * @export
 */
export const OfficeSpaceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OfficeSpaceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfficeSpace(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OfficeSpaceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfficeSpace(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OfficeSpaceApi.getOfficeSpace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OfficeSpaceApi - factory interface
 * @export
 */
export const OfficeSpaceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OfficeSpaceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfficeSpace(options?: any): AxiosPromise<Array<OfficeSpaceModel>> {
            return localVarFp.getOfficeSpace(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OfficeSpaceApi - object-oriented interface
 * @export
 * @class OfficeSpaceApi
 * @extends {BaseAPI}
 */
export class OfficeSpaceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeSpaceApi
     */
    public getOfficeSpace(options?: RawAxiosRequestConfig) {
        return OfficeSpaceApiFp(this.configuration).getOfficeSpace(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OpenAIApi - axios parameter creator
 * @export
 */
export const OpenAIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentCompletionBasedOnWrittenText: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('contentCompletionBasedOnWrittenText', 'body', body)
            const localVarPath = `/V1/openai/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body comma separated words
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContentBasedOnKeyWords: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('generateContentBasedOnKeyWords', 'body', body)
            const localVarPath = `/V1/openai/generatecontent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestModificationOnWrittenText: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('suggestModificationOnWrittenText', 'body', body)
            const localVarPath = `/V1/openai/improve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeammemberInfoRAGRequestModel} body Teammember Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberInfoRAG: async (body: TeammemberInfoRAGRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('teammemberInfoRAG', 'body', body)
            const localVarPath = `/V1/openai/teammemberInfoRAG`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenAIApi - functional programming interface
 * @export
 */
export const OpenAIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenAIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentCompletionBasedOnWrittenText(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentCompletionBasedOnWrittenText(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpenAIApi.contentCompletionBasedOnWrittenText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} body comma separated words
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateContentBasedOnKeyWords(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateContentBasedOnKeyWords(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpenAIApi.generateContentBasedOnKeyWords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestModificationOnWrittenText(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestModificationOnWrittenText(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpenAIApi.suggestModificationOnWrittenText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TeammemberInfoRAGRequestModel} body Teammember Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teammemberInfoRAG(body: TeammemberInfoRAGRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teammemberInfoRAG(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpenAIApi.teammemberInfoRAG']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OpenAIApi - factory interface
 * @export
 */
export const OpenAIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenAIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentCompletionBasedOnWrittenText(body: string, options?: any): AxiosPromise<string> {
            return localVarFp.contentCompletionBasedOnWrittenText(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body comma separated words
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateContentBasedOnKeyWords(body: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateContentBasedOnKeyWords(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body Previous Sentence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestModificationOnWrittenText(body: string, options?: any): AxiosPromise<string> {
            return localVarFp.suggestModificationOnWrittenText(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeammemberInfoRAGRequestModel} body Teammember Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberInfoRAG(body: TeammemberInfoRAGRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.teammemberInfoRAG(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OpenAIApi - object-oriented interface
 * @export
 * @class OpenAIApi
 * @extends {BaseAPI}
 */
export class OpenAIApi extends BaseAPI {
    /**
     * 
     * @param {string} body Previous Sentence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public contentCompletionBasedOnWrittenText(body: string, options?: RawAxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).contentCompletionBasedOnWrittenText(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body comma separated words
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public generateContentBasedOnKeyWords(body: string, options?: RawAxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).generateContentBasedOnKeyWords(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body Previous Sentence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public suggestModificationOnWrittenText(body: string, options?: RawAxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).suggestModificationOnWrittenText(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeammemberInfoRAGRequestModel} body Teammember Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenAIApi
     */
    public teammemberInfoRAG(body: TeammemberInfoRAGRequestModel, options?: RawAxiosRequestConfig) {
        return OpenAIApiFp(this.configuration).teammemberInfoRAG(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PayRunApi - axios parameter creator
 * @export
 */
export const PayRunApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePayRunByAdmin: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approvePayRunByAdmin', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('approvePayRunByAdmin', 'body', body)
            const localVarPath = `/V1/payrun/approveByAdmin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePayRunByTM: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approvePayRunByTM', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('approvePayRunByTM', 'body', body)
            const localVarPath = `/V1/payrun/approveByTM/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PayRunModel} body Don\&#39;t fill id to Create new PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayRunForAdmin: async (body: PayRunModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createPayRunForAdmin', 'body', body)
            const localVarPath = `/V1/payrun/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePayruns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/payrun/getActivePayruns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualExpenseAnalysis: async (body: ExpenseAnalysisRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getActualExpenseAnalysis', 'body', body)
            const localVarPath = `/V1/payrun/actualExpenseAnalysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Teammember Id to get the Teammember\&#39;s PayRun list
         * @param {PaginationRequestModel} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPayRunList: async (teammemberId: string, body: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getAdminPayRunList', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAdminPayRunList', 'body', body)
            const localVarPath = `/V1/payrun/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTeammemberPayRunList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/payrun`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastExpenseAnalysis: async (body: ExpenseAnalysisRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getForecastExpenseAnalysis', 'body', body)
            const localVarPath = `/V1/payrun/forecastExpenseAnalysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to get the PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayRun: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPayRun', 'id', id)
            const localVarPath = `/V1/payrun/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPayableCharges: async (teammemberId: string, fromDate: string, toDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getTeammemberPayableCharges', 'teammemberId', teammemberId)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getTeammemberPayableCharges', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getTeammemberPayableCharges', 'toDate', toDate)
            const localVarPath = `/V1/payrun/getTeammemberPayableCharges/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<PayrunPayment>} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payRunSetPayments: async (id: string, body: Array<PayrunPayment>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('payRunSetPayments', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('payRunSetPayments', 'body', body)
            const localVarPath = `/V1/payrun/setPayments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PayRunApi - functional programming interface
 * @export
 */
export const PayRunApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PayRunApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePayRunByAdmin(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePayRunByAdmin(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.approvePayRunByAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approvePayRunByTM(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approvePayRunByTM(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.approvePayRunByTM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PayRunModel} body Don\&#39;t fill id to Create new PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPayRunForAdmin(body: PayRunModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPayRunForAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.createPayRunForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivePayruns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayRunModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivePayruns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getActivePayruns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActualExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseAnalysisVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActualExpenseAnalysis(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getActualExpenseAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Teammember Id to get the Teammember\&#39;s PayRun list
         * @param {PaginationRequestModel} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPayRunList(teammemberId: string, body: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelPayRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPayRunList(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getAdminPayRunList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentTeammemberPayRunList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayRunModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentTeammemberPayRunList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getCurrentTeammemberPayRunList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseAnalysisVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastExpenseAnalysis(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getForecastExpenseAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to get the PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayRun(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayRunModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayRun(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getPayRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberPayableCharges(teammemberId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayrunBillableItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberPayableCharges(teammemberId, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.getTeammemberPayableCharges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<PayrunPayment>} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payRunSetPayments(id: string, body: Array<PayrunPayment>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payRunSetPayments(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PayRunApi.payRunSetPayments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PayRunApi - factory interface
 * @export
 */
export const PayRunApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PayRunApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePayRunByAdmin(id: string, body: string, options?: any): AxiosPromise<string> {
            return localVarFp.approvePayRunByAdmin(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approvePayRunByTM(id: string, body: string, options?: any): AxiosPromise<string> {
            return localVarFp.approvePayRunByTM(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PayRunModel} body Don\&#39;t fill id to Create new PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPayRunForAdmin(body: PayRunModel, options?: any): AxiosPromise<string> {
            return localVarFp.createPayRunForAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivePayruns(options?: any): AxiosPromise<Array<PayRunModel>> {
            return localVarFp.getActivePayruns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActualExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: any): AxiosPromise<ExpenseAnalysisVM> {
            return localVarFp.getActualExpenseAnalysis(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Teammember Id to get the Teammember\&#39;s PayRun list
         * @param {PaginationRequestModel} body Fill filter and pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPayRunList(teammemberId: string, body: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelPayRunModel> {
            return localVarFp.getAdminPayRunList(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTeammemberPayRunList(options?: any): AxiosPromise<Array<PayRunModel>> {
            return localVarFp.getCurrentTeammemberPayRunList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: any): AxiosPromise<ExpenseAnalysisVM> {
            return localVarFp.getForecastExpenseAnalysis(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to get the PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayRun(id: string, options?: any): AxiosPromise<PayRunModel> {
            return localVarFp.getPayRun(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {string} fromDate 
         * @param {string} toDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPayableCharges(teammemberId: string, fromDate: string, toDate: string, options?: any): AxiosPromise<Array<PayrunBillableItem>> {
            return localVarFp.getTeammemberPayableCharges(teammemberId, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<PayrunPayment>} body Fill id to Approve PayRun
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payRunSetPayments(id: string, body: Array<PayrunPayment>, options?: any): AxiosPromise<Result> {
            return localVarFp.payRunSetPayments(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PayRunApi - object-oriented interface
 * @export
 * @class PayRunApi
 * @extends {BaseAPI}
 */
export class PayRunApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} body Fill id to Approve PayRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public approvePayRunByAdmin(id: string, body: string, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).approvePayRunByAdmin(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} body Fill id to Approve PayRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public approvePayRunByTM(id: string, body: string, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).approvePayRunByTM(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PayRunModel} body Don\&#39;t fill id to Create new PayRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public createPayRunForAdmin(body: PayRunModel, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).createPayRunForAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getActivePayruns(options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getActivePayruns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getActualExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getActualExpenseAnalysis(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Teammember Id to get the Teammember\&#39;s PayRun list
     * @param {PaginationRequestModel} body Fill filter and pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getAdminPayRunList(teammemberId: string, body: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getAdminPayRunList(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getCurrentTeammemberPayRunList(options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getCurrentTeammemberPayRunList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExpenseAnalysisRequestModel} body Fill Dates to get Payruns between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getForecastExpenseAnalysis(body: ExpenseAnalysisRequestModel, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getForecastExpenseAnalysis(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to get the PayRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getPayRun(id: string, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getPayRun(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId 
     * @param {string} fromDate 
     * @param {string} toDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public getTeammemberPayableCharges(teammemberId: string, fromDate: string, toDate: string, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).getTeammemberPayableCharges(teammemberId, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<PayrunPayment>} body Fill id to Approve PayRun
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayRunApi
     */
    public payRunSetPayments(id: string, body: Array<PayrunPayment>, options?: RawAxiosRequestConfig) {
        return PayRunApiFp(this.configuration).payRunSetPayments(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentMethodsApi - axios parameter creator
 * @export
 */
export const PaymentMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberBankAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/paymentMethod/bankAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberCryptoCurrency: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/paymentMethod/cryptoCurrency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultBankAccountByTeammemberId: async (tmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tmId' is not null or undefined
            assertParamExists('getTeammemberDefaultBankAccountByTeammemberId', 'tmId', tmId)
            const localVarPath = `/V1/admin/paymentMethod/bankAccount/{tmId}`
                .replace(`{${"tmId"}}`, encodeURIComponent(String(tmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultCryptoCurrencyByTeammemberId: async (tmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tmId' is not null or undefined
            assertParamExists('getTeammemberDefaultCryptoCurrencyByTeammemberId', 'tmId', tmId)
            const localVarPath = `/V1/admin/paymentMethod/cryptoCurrency/{tmId}`
                .replace(`{${"tmId"}}`, encodeURIComponent(String(tmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultPaypalByTeammemberId: async (tmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tmId' is not null or undefined
            assertParamExists('getTeammemberDefaultPaypalByTeammemberId', 'tmId', tmId)
            const localVarPath = `/V1/admin/paymentMethod/paypal/{tmId}`
                .replace(`{${"tmId"}}`, encodeURIComponent(String(tmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultWiseAccountByTeammemberId: async (tmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tmId' is not null or undefined
            assertParamExists('getTeammemberDefaultWiseAccountByTeammemberId', 'tmId', tmId)
            const localVarPath = `/V1/admin/paymentMethod/wiseAccount/{tmId}`
                .replace(`{${"tmId"}}`, encodeURIComponent(String(tmId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPaypal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/paymentMethod/paypal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberWiseAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/paymentMethod/wiseAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BankAccountModel} body Bank account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberBankAccount: async (body: BankAccountModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTeammemberBankAccount', 'body', body)
            const localVarPath = `/V1/paymentMethod/bankAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CryptoCurrencyModel} body Crypto model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberCryptoCurrency: async (body: CryptoCurrencyModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTeammemberCryptoCurrency', 'body', body)
            const localVarPath = `/V1/paymentMethod/cryptoCurrency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaypalModel} body Paypal model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberPaypal: async (body: PaypalModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTeammemberPaypal', 'body', body)
            const localVarPath = `/V1/paymentMethod/paypal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WiseAccountModel} body Wise account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberWiseAccount: async (body: WiseAccountModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTeammemberWiseAccount', 'body', body)
            const localVarPath = `/V1/paymentMethod/wiseAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodsApi - functional programming interface
 * @export
 */
export const PaymentMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberBankAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberBankAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberCryptoCurrency(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CryptoCurrencyModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberCryptoCurrency(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberCryptoCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberDefaultBankAccountByTeammemberId(tmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberDefaultBankAccountByTeammemberId(tmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberDefaultBankAccountByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CryptoCurrencyModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberDefaultCryptoCurrencyByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberDefaultPaypalByTeammemberId(tmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaypalModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberDefaultPaypalByTeammemberId(tmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberDefaultPaypalByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberDefaultWiseAccountByTeammemberId(tmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WiseAccountModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberDefaultWiseAccountByTeammemberId(tmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberDefaultWiseAccountByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberPaypal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaypalModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberPaypal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberPaypal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberWiseAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WiseAccountModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberWiseAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getTeammemberWiseAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BankAccountModel} body Bank account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTeammemberBankAccount(body: BankAccountModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTeammemberBankAccount(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.saveTeammemberBankAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CryptoCurrencyModel} body Crypto model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTeammemberCryptoCurrency(body: CryptoCurrencyModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CryptoCurrencyModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTeammemberCryptoCurrency(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.saveTeammemberCryptoCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaypalModel} body Paypal model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTeammemberPaypal(body: PaypalModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaypalModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTeammemberPaypal(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.saveTeammemberPaypal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WiseAccountModel} body Wise account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTeammemberWiseAccount(body: WiseAccountModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WiseAccountModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTeammemberWiseAccount(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.saveTeammemberWiseAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentMethodsApi - factory interface
 * @export
 */
export const PaymentMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentMethodsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberBankAccount(options?: any): AxiosPromise<Array<BankAccountModel>> {
            return localVarFp.getTeammemberBankAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberCryptoCurrency(options?: any): AxiosPromise<Array<CryptoCurrencyModel>> {
            return localVarFp.getTeammemberCryptoCurrency(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultBankAccountByTeammemberId(tmId: string, options?: any): AxiosPromise<BankAccountModel> {
            return localVarFp.getTeammemberDefaultBankAccountByTeammemberId(tmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId: string, options?: any): AxiosPromise<CryptoCurrencyModel> {
            return localVarFp.getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultPaypalByTeammemberId(tmId: string, options?: any): AxiosPromise<PaypalModel> {
            return localVarFp.getTeammemberDefaultPaypalByTeammemberId(tmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tmId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberDefaultWiseAccountByTeammemberId(tmId: string, options?: any): AxiosPromise<WiseAccountModel> {
            return localVarFp.getTeammemberDefaultWiseAccountByTeammemberId(tmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPaypal(options?: any): AxiosPromise<Array<PaypalModel>> {
            return localVarFp.getTeammemberPaypal(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberWiseAccount(options?: any): AxiosPromise<Array<WiseAccountModel>> {
            return localVarFp.getTeammemberWiseAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BankAccountModel} body Bank account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberBankAccount(body: BankAccountModel, options?: any): AxiosPromise<Array<BankAccountModel>> {
            return localVarFp.saveTeammemberBankAccount(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CryptoCurrencyModel} body Crypto model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberCryptoCurrency(body: CryptoCurrencyModel, options?: any): AxiosPromise<Array<CryptoCurrencyModel>> {
            return localVarFp.saveTeammemberCryptoCurrency(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaypalModel} body Paypal model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberPaypal(body: PaypalModel, options?: any): AxiosPromise<Array<PaypalModel>> {
            return localVarFp.saveTeammemberPaypal(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WiseAccountModel} body Wise account model to be added in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTeammemberWiseAccount(body: WiseAccountModel, options?: any): AxiosPromise<Array<WiseAccountModel>> {
            return localVarFp.saveTeammemberWiseAccount(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentMethodsApi - object-oriented interface
 * @export
 * @class PaymentMethodsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberBankAccount(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberBankAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberCryptoCurrency(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberCryptoCurrency(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tmId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberDefaultBankAccountByTeammemberId(tmId: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberDefaultBankAccountByTeammemberId(tmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tmId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberDefaultCryptoCurrencyByTeammemberId(tmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tmId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberDefaultPaypalByTeammemberId(tmId: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberDefaultPaypalByTeammemberId(tmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tmId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberDefaultWiseAccountByTeammemberId(tmId: string, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberDefaultWiseAccountByTeammemberId(tmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberPaypal(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberPaypal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getTeammemberWiseAccount(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getTeammemberWiseAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BankAccountModel} body Bank account model to be added in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public saveTeammemberBankAccount(body: BankAccountModel, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).saveTeammemberBankAccount(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CryptoCurrencyModel} body Crypto model to be added in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public saveTeammemberCryptoCurrency(body: CryptoCurrencyModel, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).saveTeammemberCryptoCurrency(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaypalModel} body Paypal model to be added in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public saveTeammemberPaypal(body: PaypalModel, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).saveTeammemberPaypal(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WiseAccountModel} body Wise account model to be added in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public saveTeammemberWiseAccount(body: WiseAccountModel, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).saveTeammemberWiseAccount(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortfolioManagersApi - axios parameter creator
 * @export
 */
export const PortfolioManagersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolioManager: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createPortfolioManager', 'body', body)
            const localVarPath = `/V1/portfolioManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to get specific Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPortfolioManagerById', 'id', id)
            const localVarPath = `/V1/portfolioManagers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/portfolioManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortfolioManager: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePortfolioManager', 'body', body)
            const localVarPath = `/V1/portfolioManagers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioManagersApi - functional programming interface
 * @export
 */
export const PortfolioManagersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioManagersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortfolioManager(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortfolioManager(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioManagersApi.createPortfolioManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to get specific Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioManagerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioManagerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioManagersApi.getPortfolioManagerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioManagerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerCustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioManagerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioManagersApi.getPortfolioManagerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePortfolioManager(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePortfolioManager(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioManagersApi.updatePortfolioManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortfolioManagersApi - factory interface
 * @export
 */
export const PortfolioManagersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioManagersApiFp(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortfolioManager(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createPortfolioManager(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to get specific Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPortfolioManagerById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerList(options?: any): AxiosPromise<Array<ManagerCustomerModel>> {
            return localVarFp.getPortfolioManagerList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Portfolio Manager
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortfolioManager(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updatePortfolioManager(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioManagersApi - object-oriented interface
 * @export
 * @class PortfolioManagersApi
 * @extends {BaseAPI}
 */
export class PortfolioManagersApi extends BaseAPI {
    /**
     * 
     * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Portfolio Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioManagersApi
     */
    public createPortfolioManager(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return PortfolioManagersApiFp(this.configuration).createPortfolioManager(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to get specific Portfolio Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioManagersApi
     */
    public getPortfolioManagerById(id: string, options?: RawAxiosRequestConfig) {
        return PortfolioManagersApiFp(this.configuration).getPortfolioManagerById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioManagersApi
     */
    public getPortfolioManagerList(options?: RawAxiosRequestConfig) {
        return PortfolioManagersApiFp(this.configuration).getPortfolioManagerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerCustomerModel} body Fill id to Update existing Portfolio Manager
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioManagersApi
     */
    public updatePortfolioManager(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return PortfolioManagersApiFp(this.configuration).updatePortfolioManager(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PositionApi - axios parameter creator
 * @export
 */
export const PositionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionStatus: async (id: string, status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changePositionStatus', 'id', id)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changePositionStatus', 'status', status)
            const localVarPath = `/V1/position/{id}/{status}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionTaskStatus: async (id: string, status: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changePositionTaskStatus', 'id', id)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changePositionTaskStatus', 'status', status)
            const localVarPath = `/V1/position/tasks/{id}/{status}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionTask: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePositionTask', 'id', id)
            const localVarPath = `/V1/position/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should returned from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gePositionTaskDetail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('gePositionTaskDetail', 'id', id)
            const localVarPath = `/V1/position/tasks/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gePositionTaskList: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/position/getTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id position Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionDetial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionDetial', 'id', id)
            const localVarPath = `/V1/position/detail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionList: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/position/getList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionSummaryList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/position/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PositionModel} body Job openning model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePosition: async (body: PositionModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePosition', 'body', body)
            const localVarPath = `/V1/position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PositionTaskModel} body PositionTask model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePositionTask: async (body: PositionTaskModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePositionTask', 'body', body)
            const localVarPath = `/V1/position/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Id of a positionTask
         * @param {SendNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPositionTaskNotification: async (id: string, body: SendNotificationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendPositionTaskNotification', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendPositionTaskNotification', 'body', body)
            const localVarPath = `/V1/position/tasks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionApi - functional programming interface
 * @export
 */
export const PositionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePositionStatus(id: string, status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePositionStatus(id, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.changePositionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePositionTaskStatus(id: string, status: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePositionTaskStatus(id, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.changePositionTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePositionTask(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePositionTask(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.deletePositionTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should returned from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gePositionTaskDetail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionTaskDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gePositionTaskDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.gePositionTaskDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gePositionTaskList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelPositionTaskResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gePositionTaskList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.gePositionTaskList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id position Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionDetial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionDetial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.getPositionDetial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelPositionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.getPositionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionSummaryList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySummaryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionSummaryList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.getPositionSummaryList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PositionModel} body Job openning model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePosition(body: PositionModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePosition(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.savePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PositionTaskModel} body PositionTask model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePositionTask(body: PositionTaskModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionTaskResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePositionTask(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.savePositionTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Id of a positionTask
         * @param {SendNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPositionTaskNotification(id: string, body: SendNotificationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPositionTaskNotification(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionApi.sendPositionTaskNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PositionApi - factory interface
 * @export
 */
export const PositionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionStatus(id: string, status: string, options?: any): AxiosPromise<PositionModel> {
            return localVarFp.changePositionStatus(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id position Id
         * @param {string} status Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionTaskStatus(id: string, status: string, options?: any): AxiosPromise<PositionModel> {
            return localVarFp.changePositionTaskStatus(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should be deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePositionTask(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deletePositionTask(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Id of a positionTask that should returned from database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gePositionTaskDetail(id: string, options?: any): AxiosPromise<PositionTaskDetailResponseModel> {
            return localVarFp.gePositionTaskDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gePositionTaskList(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelPositionTaskResponseModel> {
            return localVarFp.gePositionTaskList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id position Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionDetial(id: string, options?: any): AxiosPromise<PositionDetailResponseModel> {
            return localVarFp.getPositionDetial(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionList(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelPositionResponseModel> {
            return localVarFp.getPositionList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionSummaryList(options?: any): AxiosPromise<Array<EntitySummaryModel>> {
            return localVarFp.getPositionSummaryList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PositionModel} body Job openning model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePosition(body: PositionModel, options?: any): AxiosPromise<PositionResponseModel> {
            return localVarFp.savePosition(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PositionTaskModel} body PositionTask model to be saved in db
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePositionTask(body: PositionTaskModel, options?: any): AxiosPromise<PositionTaskResponseModel> {
            return localVarFp.savePositionTask(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Id of a positionTask
         * @param {SendNotificationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPositionTaskNotification(id: string, body: SendNotificationRequestModel, options?: any): AxiosPromise<NotificationModel> {
            return localVarFp.sendPositionTaskNotification(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PositionApi - object-oriented interface
 * @export
 * @class PositionApi
 * @extends {BaseAPI}
 */
export class PositionApi extends BaseAPI {
    /**
     * 
     * @param {string} id position Id
     * @param {string} status Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public changePositionStatus(id: string, status: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).changePositionStatus(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id position Id
     * @param {string} status Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public changePositionTaskStatus(id: string, status: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).changePositionTaskStatus(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Id of a positionTask that should be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public deletePositionTask(id: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).deletePositionTask(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Id of a positionTask that should returned from database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public gePositionTaskDetail(id: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).gePositionTaskDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Pagination items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public gePositionTaskList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).gePositionTaskList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id position Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public getPositionDetial(id: string, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).getPositionDetial(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Pagination items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public getPositionList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).getPositionList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public getPositionSummaryList(options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).getPositionSummaryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PositionModel} body Job openning model to be saved in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public savePosition(body: PositionModel, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).savePosition(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PositionTaskModel} body PositionTask model to be saved in db
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public savePositionTask(body: PositionTaskModel, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).savePositionTask(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Id of a positionTask
     * @param {SendNotificationRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public sendPositionTaskNotification(id: string, body: SendNotificationRequestModel, options?: RawAxiosRequestConfig) {
        return PositionApiFp(this.configuration).sendPositionTaskNotification(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApi - axios parameter creator
 * @export
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (body: ProjectModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createProject', 'body', body)
            const localVarPath = `/V1/project/CreateProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId: async (customerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getByCustomerId', 'customerId', customerId)
            const localVarPath = `/V1/project/GetListByCustomerId/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTeammemberId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/project/GetByTeammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to Get Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTeammemberIdForAdmin: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getByTeammemberIdForAdmin', 'teammemberId', teammemberId)
            const localVarPath = `/V1/project/admin/GetByTeammember/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/project/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 * @export
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(body: ProjectModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.createProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerId(customerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerId(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByTeammemberId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByTeammemberId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to Get Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByTeammemberIdForAdmin(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByTeammemberIdForAdmin(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getByTeammemberIdForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnlyProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnlyProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getOnlyProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.getProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApi - factory interface
 * @export
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApiFp(configuration)
    return {
        /**
         * 
         * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(body: ProjectModel, options?: any): AxiosPromise<ProjectModel> {
            return localVarFp.createProject(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId Send CustomerId to Customer Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerId(customerId: string, options?: any): AxiosPromise<Array<ProjectModel>> {
            return localVarFp.getByCustomerId(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTeammemberId(options?: any): AxiosPromise<string> {
            return localVarFp.getByTeammemberId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to Get Project List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTeammemberIdForAdmin(teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getByTeammemberIdForAdmin(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnlyProjects(options?: any): AxiosPromise<Array<ProjectModel>> {
            return localVarFp.getOnlyProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjects(options?: any): AxiosPromise<Array<ProjectModel>> {
            return localVarFp.getProjects(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
export class ProjectApi extends BaseAPI {
    /**
     * 
     * @param {ProjectModel} body Don\&#39;t fill id to Create new Project
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public createProject(body: ProjectModel, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).createProject(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customerId Send CustomerId to Customer Project List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getByCustomerId(customerId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getByCustomerId(customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getByTeammemberId(options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getByTeammemberId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send TeammemberId to Get Project List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getByTeammemberIdForAdmin(teammemberId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getByTeammemberIdForAdmin(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getOnlyProjects(options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getOnlyProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public getProjects(options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).getProjects(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectLeadsApi - axios parameter creator
 * @export
 */
export const ProjectLeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectLead: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createProjectLead', 'body', body)
            const localVarPath = `/V1/projectLeads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to get specific Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProjectLeadById', 'id', id)
            const localVarPath = `/V1/projectLeads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/projectLeads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectLead: async (body: ManagerCustomerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateProjectLead', 'body', body)
            const localVarPath = `/V1/projectLeads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectLeadsApi - functional programming interface
 * @export
 */
export const ProjectLeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectLeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProjectLead(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProjectLead(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectLeadsApi.createProjectLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to get specific Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectLeadById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectLeadById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectLeadsApi.getProjectLeadById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectLeadList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerCustomerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectLeadList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectLeadsApi.getProjectLeadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectLead(body: ManagerCustomerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectLead(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectLeadsApi.updateProjectLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectLeadsApi - factory interface
 * @export
 */
export const ProjectLeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectLeadsApiFp(configuration)
    return {
        /**
         * 
         * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectLead(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createProjectLead(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to get specific Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getProjectLeadById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadList(options?: any): AxiosPromise<Array<ManagerCustomerModel>> {
            return localVarFp.getProjectLeadList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerCustomerModel} body Fill id to Update existing Project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectLead(body: ManagerCustomerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateProjectLead(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectLeadsApi - object-oriented interface
 * @export
 * @class ProjectLeadsApi
 * @extends {BaseAPI}
 */
export class ProjectLeadsApi extends BaseAPI {
    /**
     * 
     * @param {ManagerCustomerModel} body Don\&#39;t fill id to Create new Project Lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectLeadsApi
     */
    public createProjectLead(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return ProjectLeadsApiFp(this.configuration).createProjectLead(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to get specific Project Lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectLeadsApi
     */
    public getProjectLeadById(id: string, options?: RawAxiosRequestConfig) {
        return ProjectLeadsApiFp(this.configuration).getProjectLeadById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectLeadsApi
     */
    public getProjectLeadList(options?: RawAxiosRequestConfig) {
        return ProjectLeadsApiFp(this.configuration).getProjectLeadList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerCustomerModel} body Fill id to Update existing Project Lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectLeadsApi
     */
    public updateProjectLead(body: ManagerCustomerModel, options?: RawAxiosRequestConfig) {
        return ProjectLeadsApiFp(this.configuration).updateProjectLead(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicHolidaysApi - axios parameter creator
 * @export
 */
export const PublicHolidaysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PublicHolidayModel} body Don\&#39;t fill id to Create new Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHoliday: async (body: PublicHolidayModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createPublicHoliday', 'body', body)
            const localVarPath = `/V1/publicholidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHolidayList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/publicholidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicHolidayId Send PublicHolidayId to Remove Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePublicHoliday: async (publicHolidayId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicHolidayId' is not null or undefined
            assertParamExists('removePublicHoliday', 'publicHolidayId', publicHolidayId)
            const localVarPath = `/V1/publicholidays/{publicHolidayId}`
                .replace(`{${"publicHolidayId"}}`, encodeURIComponent(String(publicHolidayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicHolidaysApi - functional programming interface
 * @export
 */
export const PublicHolidaysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicHolidaysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PublicHolidayModel} body Don\&#39;t fill id to Create new Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPublicHoliday(body: PublicHolidayModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicHolidayModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPublicHoliday(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicHolidaysApi.createPublicHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicHolidayList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicHolidayList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicHolidaysApi.getPublicHolidayList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicHolidayId Send PublicHolidayId to Remove Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePublicHoliday(publicHolidayId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicHolidayModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePublicHoliday(publicHolidayId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicHolidaysApi.removePublicHoliday']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicHolidaysApi - factory interface
 * @export
 */
export const PublicHolidaysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicHolidaysApiFp(configuration)
    return {
        /**
         * 
         * @param {PublicHolidayModel} body Don\&#39;t fill id to Create new Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublicHoliday(body: PublicHolidayModel, options?: any): AxiosPromise<PublicHolidayModel> {
            return localVarFp.createPublicHoliday(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicHolidayList(options?: any): AxiosPromise<Array<PublicHolidayModel>> {
            return localVarFp.getPublicHolidayList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicHolidayId Send PublicHolidayId to Remove Public Holiday
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePublicHoliday(publicHolidayId: string, options?: any): AxiosPromise<Array<PublicHolidayModel>> {
            return localVarFp.removePublicHoliday(publicHolidayId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicHolidaysApi - object-oriented interface
 * @export
 * @class PublicHolidaysApi
 * @extends {BaseAPI}
 */
export class PublicHolidaysApi extends BaseAPI {
    /**
     * 
     * @param {PublicHolidayModel} body Don\&#39;t fill id to Create new Public Holiday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public createPublicHoliday(body: PublicHolidayModel, options?: RawAxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).createPublicHoliday(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public getPublicHolidayList(options?: RawAxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).getPublicHolidayList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicHolidayId Send PublicHolidayId to Remove Public Holiday
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicHolidaysApi
     */
    public removePublicHoliday(publicHolidayId: string, options?: RawAxiosRequestConfig) {
        return PublicHolidaysApiFp(this.configuration).removePublicHoliday(publicHolidayId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} accountId The account ID for which to generate the ledger.
         * @param {AccountLedgerRequest} [body] The request body containing ledger filters and pagination options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLedger: async (accountId: string, body?: AccountLedgerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountLedger', 'accountId', accountId)
            const localVarPath = `/V1/reports/accountledger/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributionReport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/reports/contributionReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostAnalysisReport: async (body: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getCostAnalysisReport', 'body', body)
            const localVarPath = `/V1/reports/costAnalysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and teammemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollReport: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getPayrollReport', 'body', body)
            const localVarPath = `/V1/reports/payroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerReport: async (body: DateRangeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getPortfolioManagerReport', 'body', body)
            const localVarPath = `/V1/reports/client/portfoliomanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadReport: async (body: DateRangeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getProjectLeadReport', 'body', body)
            const localVarPath = `/V1/reports/client/projectlead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and customer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueReport: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getRevenueReport', 'body', body)
            const localVarPath = `/V1/reports/revenue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill CustomerId and Date properties to get Customer\&#39;s Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetReportByCustomerId: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getTimesheetReportByCustomerId', 'body', body)
            const localVarPath = `/V1/reports/analyticsreport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to get report file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetReportFile: async (body: SendTimesheetReportEmailRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getTimesheetReportFile', 'body', body)
            const localVarPath = `/V1/reports/timesheetReportFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TrialBalanceRequest} [body] The request body containing trial balance filters and sorting options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialBalance: async (body?: TrialBalanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/reports/trialBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HrCommitmentsReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hRCommitmentsReport: async (body: HrCommitmentsReportRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hRCommitmentsReport', 'body', body)
            const localVarPath = `/V1/reports/hrcommitments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Project Lead email for sending reports
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to send for the project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTimesheetReport: async (email: string, body: SendTimesheetReportEmailRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('sendTimesheetReport', 'email', email)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendTimesheetReport', 'body', body)
            const localVarPath = `/V1/reports/sendTimesheetReport/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberDashboard: async (body: TimesheetReportRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('teammemberDashboard', 'body', body)
            const localVarPath = `/V1/reports/teammemberdahsboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timesheetReport: async (body: TimesheetReportRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('timesheetReport', 'body', body)
            const localVarPath = `/V1/reports/timesheetReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} accountId The account ID for which to generate the ledger.
         * @param {AccountLedgerRequest} [body] The request body containing ledger filters and pagination options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountLedger(accountId: string, body?: AccountLedgerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLedgerReportItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountLedger(accountId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getAccountLedger']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContributionReport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContributionReportVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContributionReport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getContributionReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCostAnalysisReport(body: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelCostAnalysisReportResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCostAnalysisReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getCostAnalysisReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and teammemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPayrollReport(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayRoll>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPayrollReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getPayrollReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioManagerReport(body: DateRangeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultManagerModelLoginVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioManagerReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getPortfolioManagerReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectLeadReport(body: DateRangeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultManagerModelLoginVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectLeadReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getProjectLeadReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and customer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenueReport(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Revenue>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenueReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getRevenueReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill CustomerId and Date properties to get Customer\&#39;s Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimesheetReportByCustomerId(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimesheetReportResponseVM>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimesheetReportByCustomerId(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getTimesheetReportByCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to get report file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimesheetReportFile(body: SendTimesheetReportEmailRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimesheetReportFile(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getTimesheetReportFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TrialBalanceRequest} [body] The request body containing trial balance filters and sorting options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialBalance(body?: TrialBalanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TrialBalanceReportItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialBalance(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getTrialBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {HrCommitmentsReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hRCommitmentsReport(body: HrCommitmentsReportRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HrCommitmentsReportVM>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hRCommitmentsReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.hRCommitmentsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Project Lead email for sending reports
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to send for the project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTimesheetReport(email: string, body: SendTimesheetReportEmailRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTimesheetReport(email, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.sendTimesheetReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async teammemberDashboard(body: TimesheetReportRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberDahsboardReportVM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.teammemberDashboard(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.teammemberDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async timesheetReport(body: TimesheetReportRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimesheetReportResponseVM>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.timesheetReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.timesheetReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} accountId The account ID for which to generate the ledger.
         * @param {AccountLedgerRequest} [body] The request body containing ledger filters and pagination options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLedger(accountId: string, body?: AccountLedgerRequest, options?: any): AxiosPromise<Array<AccountLedgerReportItem>> {
            return localVarFp.getAccountLedger(accountId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributionReport(options?: any): AxiosPromise<ContributionReportVM> {
            return localVarFp.getContributionReport(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostAnalysisReport(body: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelCostAnalysisReportResponseModel> {
            return localVarFp.getCostAnalysisReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and teammemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollReport(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<PayRoll>> {
            return localVarFp.getPayrollReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioManagerReport(body: DateRangeRequestModel, options?: any): AxiosPromise<ResultManagerModelLoginVM> {
            return localVarFp.getPortfolioManagerReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectLeadReport(body: DateRangeRequestModel, options?: any): AxiosPromise<ResultManagerModelLoginVM> {
            return localVarFp.getProjectLeadReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and customer Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenueReport(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<Revenue>> {
            return localVarFp.getRevenueReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill CustomerId and Date properties to get Customer\&#39;s Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetReportByCustomerId(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<TimesheetReportResponseVM>> {
            return localVarFp.getTimesheetReportByCustomerId(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to get report file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetReportFile(body: SendTimesheetReportEmailRequestModel, options?: any): AxiosPromise<object> {
            return localVarFp.getTimesheetReportFile(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TrialBalanceRequest} [body] The request body containing trial balance filters and sorting options.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialBalance(body?: TrialBalanceRequest, options?: any): AxiosPromise<Array<TrialBalanceReportItem>> {
            return localVarFp.getTrialBalance(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HrCommitmentsReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hRCommitmentsReport(body: HrCommitmentsReportRequestModel, options?: any): AxiosPromise<Array<HrCommitmentsReportVM>> {
            return localVarFp.hRCommitmentsReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Project Lead email for sending reports
         * @param {SendTimesheetReportEmailRequestModel} body Send Data to send for the project Lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTimesheetReport(email: string, body: SendTimesheetReportEmailRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendTimesheetReport(email, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        teammemberDashboard(body: TimesheetReportRequestModel, options?: any): AxiosPromise<TeammemberDahsboardReportVM> {
            return localVarFp.teammemberDashboard(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        timesheetReport(body: TimesheetReportRequestModel, options?: any): AxiosPromise<Array<TimesheetReportResponseVM>> {
            return localVarFp.timesheetReport(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @param {string} accountId The account ID for which to generate the ledger.
     * @param {AccountLedgerRequest} [body] The request body containing ledger filters and pagination options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getAccountLedger(accountId: string, body?: AccountLedgerRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getAccountLedger(accountId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getContributionReport(options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getContributionReport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getCostAnalysisReport(body: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getCostAnalysisReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and teammemberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getPayrollReport(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getPayrollReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getPortfolioManagerReport(body: DateRangeRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getPortfolioManagerReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateRangeRequestModel} body Fill TeammemberId and Date properties to get a Teammember\&#39;s projects between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getProjectLeadReport(body: DateRangeRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getProjectLeadReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body you can get filtered report by filling start and end date and customer Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getRevenueReport(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getRevenueReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body Fill CustomerId and Date properties to get Customer\&#39;s Timesheets between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getTimesheetReportByCustomerId(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getTimesheetReportByCustomerId(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendTimesheetReportEmailRequestModel} body Send Data to get report file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getTimesheetReportFile(body: SendTimesheetReportEmailRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getTimesheetReportFile(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TrialBalanceRequest} [body] The request body containing trial balance filters and sorting options.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getTrialBalance(body?: TrialBalanceRequest, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).getTrialBalance(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HrCommitmentsReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public hRCommitmentsReport(body: HrCommitmentsReportRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).hRCommitmentsReport(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Project Lead email for sending reports
     * @param {SendTimesheetReportEmailRequestModel} body Send Data to send for the project Lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public sendTimesheetReport(email: string, body: SendTimesheetReportEmailRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).sendTimesheetReport(email, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public teammemberDashboard(body: TimesheetReportRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).teammemberDashboard(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetReportRequestModel} body Fill StartDate and EndDate to get data between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public timesheetReport(body: TimesheetReportRequestModel, options?: RawAxiosRequestConfig) {
        return ReportApiFp(this.configuration).timesheetReport(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RepositoryApi - axios parameter creator
 * @export
 */
export const RepositoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RepositoryModel} body Fill id to Update or it will create a new Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRepository: async (body: RepositoryModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createRepository', 'body', body)
            const localVarPath = `/V1/repository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repoId Send Id to disable or enable the Teammember Repository
         * @param {string} teammemberId Send teammemberId to disable or enable the Teammember Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOrEnableTeammemberRepository: async (repoId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repoId' is not null or undefined
            assertParamExists('disableOrEnableTeammemberRepository', 'repoId', repoId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('disableOrEnableTeammemberRepository', 'teammemberId', teammemberId)
            const localVarPath = `/V1/repository/DisableOrEnableTeammemberRepository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (repoId !== undefined) {
                localVarQueryParameter['repo_id'] = repoId;
            }

            if (teammemberId !== undefined) {
                localVarQueryParameter['teammemberId'] = teammemberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRepositoriesManually: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/repository/FetchManually`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitListByProjectLead: async (projectLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectLeadId' is not null or undefined
            assertParamExists('getCommitListByProjectLead', 'projectLeadId', projectLeadId)
            const localVarPath = `/V1/repository/getCommitListByProjectLead/{projectLeadId}`
                .replace(`{${"projectLeadId"}}`, encodeURIComponent(String(projectLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitListByProjectLeadEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/repository/getCommitListByProjectLeadEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositoriesByTeamMember: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/repository/GetByTeamMember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositorylist: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/repository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gitConnectionErrorsForProjectLead: async (projectLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectLeadId' is not null or undefined
            assertParamExists('gitConnectionErrorsForProjectLead', 'projectLeadId', projectLeadId)
            const localVarPath = `/V1/repository/gitConnectionErrorsForProjectLead/{projectLeadId}`
                .replace(`{${"projectLeadId"}}`, encodeURIComponent(String(projectLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} repoId Send Id to remove the Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRepository: async (repoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'repoId' is not null or undefined
            assertParamExists('removeRepository', 'repoId', repoId)
            const localVarPath = `/V1/repository`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (repoId !== undefined) {
                localVarQueryParameter['repo_id'] = repoId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCommitsOfTeamMembersManually: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/repository/SyncCommitsOfTeamMembersManually`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepositoryApi - functional programming interface
 * @export
 */
export const RepositoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepositoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RepositoryModel} body Fill id to Update or it will create a new Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRepository(body: RepositoryModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRepository(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.createRepository']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repoId Send Id to disable or enable the Teammember Repository
         * @param {string} teammemberId Send teammemberId to disable or enable the Teammember Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableOrEnableTeammemberRepository(repoId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableOrEnableTeammemberRepository(repoId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.disableOrEnableTeammemberRepository']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchRepositoriesManually(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchRepositoriesManually(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.fetchRepositoriesManually']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitListByProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepositoryTeammemberCommit>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitListByProjectLead(projectLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.getCommitListByProjectLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitListByProjectLeadEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepositoryTeammemberCommit>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitListByProjectLeadEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.getCommitListByProjectLeadEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepositoriesByTeamMember(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepositoryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepositoriesByTeamMember(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.getRepositoriesByTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepositorylist(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepositoryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepositorylist(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.getRepositorylist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gitConnectionErrorsForProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GitConnectionIssues>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gitConnectionErrorsForProjectLead(projectLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.gitConnectionErrorsForProjectLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} repoId Send Id to remove the Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRepository(repoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRepository(repoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.removeRepository']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCommitsOfTeamMembersManually(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCommitsOfTeamMembersManually(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RepositoryApi.syncCommitsOfTeamMembersManually']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RepositoryApi - factory interface
 * @export
 */
export const RepositoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepositoryApiFp(configuration)
    return {
        /**
         * 
         * @param {RepositoryModel} body Fill id to Update or it will create a new Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRepository(body: RepositoryModel, options?: any): AxiosPromise<string> {
            return localVarFp.createRepository(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} repoId Send Id to disable or enable the Teammember Repository
         * @param {string} teammemberId Send teammemberId to disable or enable the Teammember Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableOrEnableTeammemberRepository(repoId: string, teammemberId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.disableOrEnableTeammemberRepository(repoId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchRepositoriesManually(options?: any): AxiosPromise<object> {
            return localVarFp.fetchRepositoriesManually(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitListByProjectLead(projectLeadId: string, options?: any): AxiosPromise<Array<RepositoryTeammemberCommit>> {
            return localVarFp.getCommitListByProjectLead(projectLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitListByProjectLeadEmail(options?: any): AxiosPromise<Array<RepositoryTeammemberCommit>> {
            return localVarFp.getCommitListByProjectLeadEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositoriesByTeamMember(options?: any): AxiosPromise<Array<RepositoryModel>> {
            return localVarFp.getRepositoriesByTeamMember(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositorylist(options?: any): AxiosPromise<Array<RepositoryModel>> {
            return localVarFp.getRepositorylist(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectLeadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gitConnectionErrorsForProjectLead(projectLeadId: string, options?: any): AxiosPromise<Array<GitConnectionIssues>> {
            return localVarFp.gitConnectionErrorsForProjectLead(projectLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} repoId Send Id to remove the Repository
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRepository(repoId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeRepository(repoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCommitsOfTeamMembersManually(options?: any): AxiosPromise<object> {
            return localVarFp.syncCommitsOfTeamMembersManually(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepositoryApi - object-oriented interface
 * @export
 * @class RepositoryApi
 * @extends {BaseAPI}
 */
export class RepositoryApi extends BaseAPI {
    /**
     * 
     * @param {RepositoryModel} body Fill id to Update or it will create a new Repository
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public createRepository(body: RepositoryModel, options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).createRepository(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} repoId Send Id to disable or enable the Teammember Repository
     * @param {string} teammemberId Send teammemberId to disable or enable the Teammember Repository
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public disableOrEnableTeammemberRepository(repoId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).disableOrEnableTeammemberRepository(repoId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public fetchRepositoriesManually(options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).fetchRepositoriesManually(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectLeadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public getCommitListByProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).getCommitListByProjectLead(projectLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public getCommitListByProjectLeadEmail(options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).getCommitListByProjectLeadEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public getRepositoriesByTeamMember(options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).getRepositoriesByTeamMember(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public getRepositorylist(options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).getRepositorylist(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectLeadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public gitConnectionErrorsForProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).gitConnectionErrorsForProjectLead(projectLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} repoId Send Id to remove the Repository
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public removeRepository(repoId: string, options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).removeRepository(repoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositoryApi
     */
    public syncCommitsOfTeamMembersManually(options?: RawAxiosRequestConfig) {
        return RepositoryApiFp(this.configuration).syncCommitsOfTeamMembersManually(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TDMApi - axios parameter creator
 * @export
 */
export const TDMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTDM: async (body: ManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createTDM', 'body', body)
            const localVarPath = `/V1/tdm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTDMs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/tdm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TDMApi - functional programming interface
 * @export
 */
export const TDMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TDMApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTDM(body: ManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTDM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TDMApi.createTDM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTDMs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManagerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTDMs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TDMApi.getTDMs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TDMApi - factory interface
 * @export
 */
export const TDMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TDMApiFp(configuration)
    return {
        /**
         * 
         * @param {ManagerModel} body Don\&#39;t fill id to Create new TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTDM(body: ManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.createTDM(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTDMs(options?: any): AxiosPromise<Array<ManagerModel>> {
            return localVarFp.getTDMs(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TDMApi - object-oriented interface
 * @export
 * @class TDMApi
 * @extends {BaseAPI}
 */
export class TDMApi extends BaseAPI {
    /**
     * 
     * @param {ManagerModel} body Don\&#39;t fill id to Create new TDM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TDMApi
     */
    public createTDM(body: ManagerModel, options?: RawAxiosRequestConfig) {
        return TDMApiFp(this.configuration).createTDM(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TDMApi
     */
    public getTDMs(options?: RawAxiosRequestConfig) {
        return TDMApiFp(this.configuration).getTDMs(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TDMsApi - axios parameter creator
 * @export
 */
export const TDMsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send id to get specific TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTDMById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTDMById', 'id', id)
            const localVarPath = `/V1/tdm/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTDM: async (body: ManagerModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTDM', 'body', body)
            const localVarPath = `/V1/tdm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TDMsApi - functional programming interface
 * @export
 */
export const TDMsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TDMsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTDMById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTDMById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TDMsApi.getTDMById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTDM(body: ManagerModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTDM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TDMsApi.updateTDM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TDMsApi - factory interface
 * @export
 */
export const TDMsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TDMsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get specific TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTDMById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTDMById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagerModel} body Fill id to Update existing TDM
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTDM(body: ManagerModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateTDM(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TDMsApi - object-oriented interface
 * @export
 * @class TDMsApi
 * @extends {BaseAPI}
 */
export class TDMsApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send id to get specific TDM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TDMsApi
     */
    public getTDMById(id: string, options?: RawAxiosRequestConfig) {
        return TDMsApiFp(this.configuration).getTDMById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagerModel} body Fill id to Update existing TDM
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TDMsApi
     */
    public updateTDM(body: ManagerModel, options?: RawAxiosRequestConfig) {
        return TDMsApiFp(this.configuration).updateTDM(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TMAssessmentApi - axios parameter creator
 * @export
 */
export const TMAssessmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMFindAssessment: async (body: FindAssessmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tMFindAssessment', 'body', body)
            const localVarPath = `/V1/tmAssessment/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMGetAssessmentById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tMGetAssessmentById', 'id', id)
            const localVarPath = `/V1/tmAssessment/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TMAssessmentApi - functional programming interface
 * @export
 */
export const TMAssessmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TMAssessmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tMFindAssessment(body: FindAssessmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tMFindAssessment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMAssessmentApi.tMFindAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tMGetAssessmentById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultClientAssessmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tMGetAssessmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMAssessmentApi.tMGetAssessmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TMAssessmentApi - factory interface
 * @export
 */
export const TMAssessmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TMAssessmentApiFp(configuration)
    return {
        /**
         * 
         * @param {FindAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMFindAssessment(body: FindAssessmentRequestModel, options?: any): AxiosPromise<ResultList1> {
            return localVarFp.tMFindAssessment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Assessment Id to get related Assessment details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMGetAssessmentById(id: string, options?: any): AxiosPromise<ResultClientAssessmentModel> {
            return localVarFp.tMGetAssessmentById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TMAssessmentApi - object-oriented interface
 * @export
 * @class TMAssessmentApi
 * @extends {BaseAPI}
 */
export class TMAssessmentApi extends BaseAPI {
    /**
     * 
     * @param {FindAssessmentRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMAssessmentApi
     */
    public tMFindAssessment(body: FindAssessmentRequestModel, options?: RawAxiosRequestConfig) {
        return TMAssessmentApiFp(this.configuration).tMFindAssessment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Assessment Id to get related Assessment details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMAssessmentApi
     */
    public tMGetAssessmentById(id: string, options?: RawAxiosRequestConfig) {
        return TMAssessmentApiFp(this.configuration).tMGetAssessmentById(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TMCourseApi - axios parameter creator
 * @export
 */
export const TMCourseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMFindCourse: async (body: FindCoursesRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tMFindCourse', 'body', body)
            const localVarPath = `/V1/tmCourse/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCourseStepStateRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourseStepState: async (id: string, body: UpdateCourseStepStateRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCourseStepState', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCourseStepState', 'body', body)
            const localVarPath = `/V1/course/{id}/step/updateState`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TMCourseApi - functional programming interface
 * @export
 */
export const TMCourseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TMCourseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tMFindCourse(body: FindCoursesRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tMFindCourse(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMCourseApi.tMFindCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCourseStepStateRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCourseStepState(id: string, body: UpdateCourseStepStateRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCourseStepState(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMCourseApi.updateCourseStepState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TMCourseApi - factory interface
 * @export
 */
export const TMCourseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TMCourseApiFp(configuration)
    return {
        /**
         * 
         * @param {FindCoursesRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tMFindCourse(body: FindCoursesRequestModel, options?: any): AxiosPromise<ResultList1> {
            return localVarFp.tMFindCourse(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateCourseStepStateRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourseStepState(id: string, body: UpdateCourseStepStateRequestModel, options?: any): AxiosPromise<ResultBoolean> {
            return localVarFp.updateCourseStepState(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TMCourseApi - object-oriented interface
 * @export
 * @class TMCourseApi
 * @extends {BaseAPI}
 */
export class TMCourseApi extends BaseAPI {
    /**
     * 
     * @param {FindCoursesRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMCourseApi
     */
    public tMFindCourse(body: FindCoursesRequestModel, options?: RawAxiosRequestConfig) {
        return TMCourseApiFp(this.configuration).tMFindCourse(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateCourseStepStateRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMCourseApi
     */
    public updateCourseStepState(id: string, body: UpdateCourseStepStateRequestModel, options?: RawAxiosRequestConfig) {
        return TMCourseApiFp(this.configuration).updateCourseStepState(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TMRoadMapApi - axios parameter creator
 * @export
 */
export const TMRoadMapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapAssessmentDetails: async (id: string, assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeammemberRoadMapAssessmentDetails', 'id', id)
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getTeammemberRoadMapAssessmentDetails', 'assessmentId', assessmentId)
            const localVarPath = `/V1/tmRoadMap/{id}/assessments/{assessmentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapCourseDetails: async (id: string, courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeammemberRoadMapCourseDetails', 'id', id)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('getTeammemberRoadMapCourseDetails', 'courseId', courseId)
            const localVarPath = `/V1/tmRoadMap/{id}/courses/{courseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapSteps: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeammemberRoadMapSteps', 'id', id)
            const localVarPath = `/V1/tmRoadMap/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMaps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/tmRoadMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartRoadMapAssessment: async (id: string, body: SubmitAssessmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restartRoadMapAssessment', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('restartRoadMapAssessment', 'body', body)
            const localVarPath = `/V1/tmRoadMap/{id}/assessments/restart`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {StartRoadMapAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTeammemberRoadMapAssessment: async (id: string, body: StartRoadMapAssessmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startTeammemberRoadMapAssessment', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('startTeammemberRoadMapAssessment', 'body', body)
            const localVarPath = `/V1/tmRoadMap/{id}/assessments/start`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTeammemberRoadMapCourse: async (id: string, courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startTeammemberRoadMapCourse', 'id', id)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('startTeammemberRoadMapCourse', 'courseId', courseId)
            const localVarPath = `/V1/tmRoadMap/{id}/courses/{courseId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentQuestionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAssessmentQuestionAnswer: async (id: string, body: SubmitAssessmentQuestionRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitAssessmentQuestionAnswer', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('submitAssessmentQuestionAnswer', 'body', body)
            const localVarPath = `/V1/tmRoadMap/{id}/assessments/questions/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRoadMapAssessment: async (id: string, body: SubmitAssessmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitRoadMapAssessment', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('submitRoadMapAssessment', 'body', body)
            const localVarPath = `/V1/tmRoadMap/{id}/assessments/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TMRoadMapApi - functional programming interface
 * @export
 */
export const TMRoadMapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TMRoadMapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberRoadMapAssessmentDetails(id: string, assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultClientAssessmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberRoadMapAssessmentDetails(id, assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.getTeammemberRoadMapAssessmentDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberRoadMapCourseDetails(id: string, courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultCourseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberRoadMapCourseDetails(id, courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.getTeammemberRoadMapCourseDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberRoadMapSteps(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultTmRoadMapModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberRoadMapSteps(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.getTeammemberRoadMapSteps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberRoadMaps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultList1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberRoadMaps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.getTeammemberRoadMaps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restartRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDateTime>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restartRoadMapAssessment(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.restartRoadMapAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {StartRoadMapAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTeammemberRoadMapAssessment(id: string, body: StartRoadMapAssessmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDateTime>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTeammemberRoadMapAssessment(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.startTeammemberRoadMapAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTeammemberRoadMapCourse(id: string, courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultCourseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTeammemberRoadMapCourse(id, courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.startTeammemberRoadMapCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentQuestionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitAssessmentQuestionAnswer(id: string, body: SubmitAssessmentQuestionRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultBoolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitAssessmentQuestionAnswer(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.submitAssessmentQuestionAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDateTime>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitRoadMapAssessment(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TMRoadMapApi.submitRoadMapAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TMRoadMapApi - factory interface
 * @export
 */
export const TMRoadMapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TMRoadMapApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapAssessmentDetails(id: string, assessmentId: string, options?: any): AxiosPromise<ResultClientAssessmentModel> {
            return localVarFp.getTeammemberRoadMapAssessmentDetails(id, assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapCourseDetails(id: string, courseId: string, options?: any): AxiosPromise<ResultCourseModel> {
            return localVarFp.getTeammemberRoadMapCourseDetails(id, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMapSteps(id: string, options?: any): AxiosPromise<ResultTmRoadMapModel> {
            return localVarFp.getTeammemberRoadMapSteps(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberRoadMaps(options?: any): AxiosPromise<ResultList1> {
            return localVarFp.getTeammemberRoadMaps(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restartRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: any): AxiosPromise<ResultDateTime> {
            return localVarFp.restartRoadMapAssessment(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {StartRoadMapAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTeammemberRoadMapAssessment(id: string, body: StartRoadMapAssessmentRequestModel, options?: any): AxiosPromise<ResultDateTime> {
            return localVarFp.startTeammemberRoadMapAssessment(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTeammemberRoadMapCourse(id: string, courseId: string, options?: any): AxiosPromise<ResultCourseModel> {
            return localVarFp.startTeammemberRoadMapCourse(id, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentQuestionRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAssessmentQuestionAnswer(id: string, body: SubmitAssessmentQuestionRequestModel, options?: any): AxiosPromise<ResultBoolean> {
            return localVarFp.submitAssessmentQuestionAnswer(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SubmitAssessmentRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: any): AxiosPromise<ResultDateTime> {
            return localVarFp.submitRoadMapAssessment(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TMRoadMapApi - object-oriented interface
 * @export
 * @class TMRoadMapApi
 * @extends {BaseAPI}
 */
export class TMRoadMapApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public getTeammemberRoadMapAssessmentDetails(id: string, assessmentId: string, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).getTeammemberRoadMapAssessmentDetails(id, assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public getTeammemberRoadMapCourseDetails(id: string, courseId: string, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).getTeammemberRoadMapCourseDetails(id, courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public getTeammemberRoadMapSteps(id: string, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).getTeammemberRoadMapSteps(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public getTeammemberRoadMaps(options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).getTeammemberRoadMaps(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SubmitAssessmentRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public restartRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).restartRoadMapAssessment(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {StartRoadMapAssessmentRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public startTeammemberRoadMapAssessment(id: string, body: StartRoadMapAssessmentRequestModel, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).startTeammemberRoadMapAssessment(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public startTeammemberRoadMapCourse(id: string, courseId: string, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).startTeammemberRoadMapCourse(id, courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SubmitAssessmentQuestionRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public submitAssessmentQuestionAnswer(id: string, body: SubmitAssessmentQuestionRequestModel, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).submitAssessmentQuestionAnswer(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SubmitAssessmentRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TMRoadMapApi
     */
    public submitRoadMapAssessment(id: string, body: SubmitAssessmentRequestModel, options?: RawAxiosRequestConfig) {
        return TMRoadMapApiFp(this.configuration).submitRoadMapAssessment(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagApi - axios parameter creator
 * @export
 */
export const TagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Send Tag Type to get the Related Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetTagsByType: async (type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('clientGetTagsByType', 'type', type)
            const localVarPath = `/V1/tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagApi - functional programming interface
 * @export
 */
export const TagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Send Tag Type to get the Related Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientGetTagsByType(type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientGetTagsByType(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagApi.clientGetTagsByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TagApi - factory interface
 * @export
 */
export const TagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Send Tag Type to get the Related Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientGetTagsByType(type: string, options?: any): AxiosPromise<Array<TagModel>> {
            return localVarFp.clientGetTagsByType(type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
export class TagApi extends BaseAPI {
    /**
     * 
     * @param {string} type Send Tag Type to get the Related Tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    public clientGetTagsByType(type: string, options?: RawAxiosRequestConfig) {
        return TagApiFp(this.configuration).clientGetTagsByType(type, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskTemplateApi - axios parameter creator
 * @export
 */
export const TaskTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Task template Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTaskTemplateStatus: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeTaskTemplateStatus', 'id', id)
            const localVarPath = `/V1/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTaskTemplateList: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/task/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTaskTemplateListSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/task/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TaskTemplateModel} body Fill id to Update or it will create a new Task template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaskTemplate: async (body: TaskTemplateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTaskTemplate', 'body', body)
            const localVarPath = `/V1/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskTemplateApi - functional programming interface
 * @export
 */
export const TaskTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Task template Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeTaskTemplateStatus(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeTaskTemplateStatus(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTemplateApi.changeTaskTemplateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTaskTemplateList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelTaskTemplateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTaskTemplateList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTemplateApi.geTaskTemplateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTaskTemplateListSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntitySummaryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTaskTemplateListSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTemplateApi.geTaskTemplateListSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TaskTemplateModel} body Fill id to Update or it will create a new Task template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTaskTemplate(body: TaskTemplateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskTemplateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTaskTemplate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskTemplateApi.saveTaskTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskTemplateApi - factory interface
 * @export
 */
export const TaskTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskTemplateApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Task template Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTaskTemplateStatus(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.changeTaskTemplateStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTaskTemplateList(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelTaskTemplateModel> {
            return localVarFp.geTaskTemplateList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTaskTemplateListSummary(options?: any): AxiosPromise<Array<EntitySummaryModel>> {
            return localVarFp.geTaskTemplateListSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TaskTemplateModel} body Fill id to Update or it will create a new Task template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaskTemplate(body: TaskTemplateModel, options?: any): AxiosPromise<TaskTemplateModel> {
            return localVarFp.saveTaskTemplate(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskTemplateApi - object-oriented interface
 * @export
 * @class TaskTemplateApi
 * @extends {BaseAPI}
 */
export class TaskTemplateApi extends BaseAPI {
    /**
     * 
     * @param {string} id Task template Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTemplateApi
     */
    public changeTaskTemplateStatus(id: string, options?: RawAxiosRequestConfig) {
        return TaskTemplateApiFp(this.configuration).changeTaskTemplateStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Pagination items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTemplateApi
     */
    public geTaskTemplateList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return TaskTemplateApiFp(this.configuration).geTaskTemplateList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTemplateApi
     */
    public geTaskTemplateListSummary(options?: RawAxiosRequestConfig) {
        return TaskTemplateApiFp(this.configuration).geTaskTemplateListSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TaskTemplateModel} body Fill id to Update or it will create a new Task template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskTemplateApi
     */
    public saveTaskTemplate(body: TaskTemplateModel, options?: RawAxiosRequestConfig) {
        return TaskTemplateApiFp(this.configuration).saveTaskTemplate(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeammemberApi - axios parameter creator
 * @export
 */
export const TeammemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCareerHistory: async (body: CareerHistoryRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addCareerHistory', 'body', body)
            const localVarPath = `/V1/teammember/saveCareerHistory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEducation: async (body: EducationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addEducation', 'body', body)
            const localVarPath = `/V1/teammember/saveEducation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeammember: async (body: TeammemberModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createTeammember', 'body', body)
            const localVarPath = `/V1/teammember/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileCv: async (body: UploadFileRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteProfileCv', 'body', body)
            const localVarPath = `/V1/teammember/removeCv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileCvByTeammemberId: async (teammemberId: string, body: UploadFileRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('deleteProfileCvByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteProfileCvByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/removeCv/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCertificateCv: async (certificateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateId' is not null or undefined
            assertParamExists('downloadCertificateCv', 'certificateId', certificateId)
            const localVarPath = `/V1/teammember/downloadCertificateCv/{certificateId}`
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCertificateCvByTeammemberId: async (certificateId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateId' is not null or undefined
            assertParamExists('downloadCertificateCvByTeammemberId', 'certificateId', certificateId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('downloadCertificateCvByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/downloadCertificateCv/{certificateId}/{teammemberId}`
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProfileCv: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/downloadProfileCv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProfileCvByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('downloadProfileCvByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/downloadProfileCv/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSkillCv: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('downloadSkillCv', 'skillId', skillId)
            const localVarPath = `/V1/teammember/downloadSkillCv/{skillId}`
                .replace(`{${"skillId"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSkillCvByTeammemberId: async (skillId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('downloadSkillCvByTeammemberId', 'skillId', skillId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('downloadSkillCvByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/downloadSkillCv/{skillId}/{teammemberId}`
                .replace(`{${"skillId"}}`, encodeURIComponent(String(skillId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCareerHistories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/careerHistories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCareerHistoriesByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('geTeammemberCareerHistoriesByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/careerHistories/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCertificates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCertificatesByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('geTeammemberCertificatesByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/certificates/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberContact: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberContactByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('geTeammemberContactByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/contact/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberEducations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/educations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberEducationsByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('geTeammemberEducationsByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/educations/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberLanguageSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/languageSkills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberLanguageSkillsByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('geTeammemberLanguageSkillsByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/languageSkills/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTeammembersByLinemanagerId: async (linemanagerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linemanagerId' is not null or undefined
            assertParamExists('getActiveTeammembersByLinemanagerId', 'linemanagerId', linemanagerId)
            const localVarPath = `/V1/teammember/activeTeammembers/{linemanagerId}`
                .replace(`{${"linemanagerId"}}`, encodeURIComponent(String(linemanagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByTeammemberId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/GetCommitmentByTeammemberId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperiencedetail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/experiencedetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperiencedetailByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getExperiencedetailByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/experiencedetail/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Send Teammember Email to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getTeammemberByEmail', 'email', email)
            const localVarPath = `/V1/teammember/GetTeammemberByEmail/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberById: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getTeammemberById', 'teammemberId', teammemberId)
            const localVarPath = `/V1/teammember/GetById/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectLeadId Send projectLeadId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByProjectLead: async (projectLeadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectLeadId' is not null or undefined
            assertParamExists('getTeammemberByProjectLead', 'projectLeadId', projectLeadId)
            const localVarPath = `/V1/teammember/getTeammemberByProjectLead/{projectLeadId}`
                .replace(`{${"projectLeadId"}}`, encodeURIComponent(String(projectLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByUid: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTeammemberByUid', 'userId', userId)
            const localVarPath = `/V1/teammember/GetTeammemberByUid/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related Line managers to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberLinemanagersForAdmin: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getTeammemberLinemanagersForAdmin', 'teammemberId', teammemberId)
            const localVarPath = `/V1/teammember/lineManagers/admin/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberList: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberListByRate: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberListSummaryDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/SummaryDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPersonalDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/personalDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPersonalDetailsByTeammemberId: async (teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('getTeammemberPersonalDetailsByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/personalDetails/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember Summary information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberSummaryByUid: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTeammemberSummaryByUid', 'userId', userId)
            const localVarPath = `/V1/teammember/GetTeammemberSummaryByUid`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberWithProfessional: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/teammember/GetTeammemberWithProfessional`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('removeAddress', 'addressId', addressId)
            const localVarPath = `/V1/teammember/address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddressByTeammemberId: async (addressId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('removeAddressByTeammemberId', 'addressId', addressId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeAddressByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/address/{addressId}/{teammemberId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareerHistory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCareerHistory', 'id', id)
            const localVarPath = `/V1/teammember/removeCareerHistory/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareerHistoryByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCareerHistoryByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeCareerHistoryByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/removeCareerHistory/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificate: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCertificate', 'id', id)
            const localVarPath = `/V1/teammember/removeCertificate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificateByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCertificateByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeCertificateByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/removeCertificate/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEducation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEducation', 'id', id)
            const localVarPath = `/V1/teammember/removeEducation/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEducationByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEducationByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeEducationByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/removeEducation/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Career Objective Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeJobPreferences: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeJobPreferences', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeJobPreferences', 'teammemberId', teammemberId)
            const localVarPath = `/V1/teammember/jobPreferences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Job Preferences Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeJobPreferencesByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeJobPreferencesByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeJobPreferencesByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/jobPreferences/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguageSkill: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeLanguageSkill', 'id', id)
            const localVarPath = `/V1/teammember/removeLanguageSkill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguageSkillByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeLanguageSkillByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeLanguageSkillByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/removeLanguageSkill/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePhone: async (phoneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('removePhone', 'phoneId', phoneId)
            const localVarPath = `/V1/teammember/phone/{phoneId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePhoneByTeammemberId: async (phoneId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('removePhoneByTeammemberId', 'phoneId', phoneId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removePhoneByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/phone/{phoneId}/{teammemberId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSkill: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeSkill', 'id', id)
            const localVarPath = `/V1/teammember/removeSkill/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSkillByTeammemberId: async (id: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeSkillByTeammemberId', 'id', id)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('removeSkillByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/removeSkill/{id}/{teammemberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddress: async (body: AddresssModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveAddress', 'body', body)
            const localVarPath = `/V1/teammember/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddressByTeammemberId: async (teammemberId: string, body: AddresssModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveAddressByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveAddressByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/address/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryByTeammemberId: async (teammemberId: string, body: CareerHistoryRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveCareerHistoryByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveCareerHistoryByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveCareerHistory/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryDescription: async (body: CareerHistoryRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveCareerHistoryDescription', 'body', body)
            const localVarPath = `/V1/teammember/saveCareerHistoryDescription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryDescriptionByTeammemberId: async (teammemberId: string, body: CareerHistoryRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveCareerHistoryDescriptionByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveCareerHistoryDescriptionByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveCareerHistoryDescription/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCertificate: async (body: CertificateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveCertificate', 'body', body)
            const localVarPath = `/V1/teammember/saveCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCertificateByTeammemberId: async (teammemberId: string, body: CertificateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveCertificateByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveCertificateByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveCertificate/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEducationByTeammemberId: async (teammemberId: string, body: EducationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveEducationByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveEducationByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveEducation/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExperienceDetail: async (body: ProfessionalDetailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveExperienceDetail', 'body', body)
            const localVarPath = `/V1/teammember/experiencedetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExperienceDetailByTeammemberId: async (teammemberId: string, body: ProfessionalDetailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveExperienceDetailByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveExperienceDetailByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/experiencedetail/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Career Objective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJobPreferences: async (body: JobPreferencesModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveJobPreferences', 'body', body)
            const localVarPath = `/V1/teammember/jobPreferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Job Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJobPreferencesByTeammemberId: async (teammemberId: string, body: JobPreferencesModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveJobPreferencesByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveJobPreferencesByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/jobPreferences/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLanguageSkill: async (body: LanguageSkillModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveLanguageSkill', 'body', body)
            const localVarPath = `/V1/teammember/saveLanguageSkill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLanguageSkillByTeammemberId: async (teammemberId: string, body: LanguageSkillModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('saveLanguageSkillByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveLanguageSkillByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveLanguageSkill/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonalDetail: async (body: PersonalDetailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePersonalDetail', 'body', body)
            const localVarPath = `/V1/teammember/personaldetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonalDetailByTeammemberId: async (teammemberId: string, body: PersonalDetailModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('savePersonalDetailByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePersonalDetailByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/personaldetail/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhone: async (body: PhoneModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePhone', 'body', body)
            const localVarPath = `/V1/teammember/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId teammember Id
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhoneByTeammemberId: async (teammemberId: string, body: PhoneModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('savePhoneByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('savePhoneByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/phone/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoleAndTitle: async (body: UpdateRoleAndTitleRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveRoleAndTitle', 'body', body)
            const localVarPath = `/V1/teammember/roleAndTitle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoleAndTitleByTeammemberEmail: async (email: string, body: UpdateRoleAndTitleRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('saveRoleAndTitleByTeammemberEmail', 'email', email)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveRoleAndTitleByTeammemberEmail', 'body', body)
            const localVarPath = `/V1/admin/teammember/roleAndTitle/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill: async (body: TeammemberSkillModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveSkill', 'body', body)
            const localVarPath = `/V1/teammember/saveSkill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Teammember email
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillByTeammemberEmail: async (email: string, body: TeammemberSkillModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('saveSkillByTeammemberEmail', 'email', email)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveSkillByTeammemberEmail', 'body', body)
            const localVarPath = `/V1/admin/teammember/saveSkill/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobName Send jobName to send a request to admin to add the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddJobRequest: async (jobName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobName' is not null or undefined
            assertParamExists('sendAddJobRequest', 'jobName', jobName)
            const localVarPath = `/V1/teammember/jobrequest/{jobName}`
                .replace(`{${"jobName"}}`, encodeURIComponent(String(jobName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillName Send skillName to send a request to admin to add the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddSkillRequest: async (skillName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillName' is not null or undefined
            assertParamExists('sendAddSkillRequest', 'skillName', skillName)
            const localVarPath = `/V1/coreskill/request/{skillName}`
                .replace(`{${"skillName"}}`, encodeURIComponent(String(skillName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressCode: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('sendAddressCode', 'addressId', addressId)
            const localVarPath = `/V1/teammember/sendAddressVerificationCode/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressCodeByTeammemberId: async (addressId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('sendAddressCodeByTeammemberId', 'addressId', addressId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('sendAddressCodeByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/sendAddressVerificationCode/{addressId}/{teammemberId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCode: async (phoneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('sendPhoneCode', 'phoneId', phoneId)
            const localVarPath = `/V1/teammember/sendPhoneVerificationCode/{phoneId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {string} teammemberId teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeByTeammemberId: async (phoneId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('sendPhoneCodeByTeammemberId', 'phoneId', phoneId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('sendPhoneCodeByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/sendPhoneVerificationCode/{phoneId}/{teammemberId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddressAsDefault: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('setAddressAsDefault', 'addressId', addressId)
            const localVarPath = `/V1/teammember/address/setasdefault/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddressAsDefaultByTeammemberId: async (addressId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('setAddressAsDefaultByTeammemberId', 'addressId', addressId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('setAddressAsDefaultByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/address/setasdefault/{addressId}/{teammemberId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPhoneAsDefault: async (phoneId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('setPhoneAsDefault', 'phoneId', phoneId)
            const localVarPath = `/V1/teammember/phone/setasdefault/{phoneId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPhoneAsDefaultByTeammemberId: async (phoneId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('setPhoneAsDefaultByTeammemberId', 'phoneId', phoneId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('setPhoneAsDefaultByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/phone/setasdefault/{phoneId}/{teammemberId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: async (body: TeammemberModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('signUp', 'body', body)
            const localVarPath = `/V1/teammember/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificateCv: async (certificateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateId' is not null or undefined
            assertParamExists('uploadCertificateCv', 'certificateId', certificateId)
            const localVarPath = `/V1/teammember/uploadCertificateCv/{certificateId}`
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificateCvByTeammemberId: async (certificateId: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificateId' is not null or undefined
            assertParamExists('uploadCertificateCvByTeammemberId', 'certificateId', certificateId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('uploadCertificateCvByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/teammember/uploadCertificateCv/{certificateId}/{teammemberId}`
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfileCv: async (body: UploadFileRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadProfileCv', 'body', body)
            const localVarPath = `/V1/teammember/uploadProfileCv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfileCvByTeammemberId: async (teammemberId: string, body: UploadFileRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('uploadProfileCvByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadProfileCvByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/uploadProfileCv/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skill skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSkillCv: async (skill: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skill' is not null or undefined
            assertParamExists('uploadSkillCv', 'skill', skill)
            const localVarPath = `/V1/teammember/uploadSkillCv/{skill}`
                .replace(`{${"skill"}}`, encodeURIComponent(String(skill)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skill skill
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSkillCvByTeammemberId: async (skill: string, teammemberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skill' is not null or undefined
            assertParamExists('uploadSkillCvByTeammemberId', 'skill', skill)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('uploadSkillCvByTeammemberId', 'teammemberId', teammemberId)
            const localVarPath = `/V1/admin/teammember/uploadSkillCv/{skill}/{teammemberId}`
                .replace(`{${"skill"}}`, encodeURIComponent(String(skill)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddress: async (addressId: string, body: ContactVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('verifyAddress', 'addressId', addressId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyAddress', 'body', body)
            const localVarPath = `/V1/teammember/verifyAddress/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddressByTeammemberId: async (addressId: string, teammemberId: string, body: ContactVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('verifyAddressByTeammemberId', 'addressId', addressId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('verifyAddressByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyAddressByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/verifyAddress/{addressId}/{teammemberId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCaptcha: async (body: CaptchaRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyCaptcha', 'body', body)
            const localVarPath = `/V1/teammember/verifyCaptcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCaptchaByTeammemberId: async (teammemberId: string, body: CaptchaRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('verifyCaptchaByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyCaptchaByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/verifyCaptcha/{teammemberId}`
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone: async (phoneId: string, body: ContactVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('verifyPhone', 'phoneId', phoneId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyPhone', 'body', body)
            const localVarPath = `/V1/teammember/verifyPhone/{phoneId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneByTeammemberId: async (phoneId: string, teammemberId: string, body: ContactVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneId' is not null or undefined
            assertParamExists('verifyPhoneByTeammemberId', 'phoneId', phoneId)
            // verify required parameter 'teammemberId' is not null or undefined
            assertParamExists('verifyPhoneByTeammemberId', 'teammemberId', teammemberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('verifyPhoneByTeammemberId', 'body', body)
            const localVarPath = `/V1/admin/teammember/verifyPhone/{phoneId}/{teammemberId}`
                .replace(`{${"phoneId"}}`, encodeURIComponent(String(phoneId)))
                .replace(`{${"teammemberId"}}`, encodeURIComponent(String(teammemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeammemberApi - functional programming interface
 * @export
 */
export const TeammemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeammemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCareerHistory(body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistoryResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCareerHistory(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.addCareerHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEducation(body: EducationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEducation(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.addEducation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeammember(body: TeammemberModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeammember(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.createTeammember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfileCv(body: UploadFileRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfileCv(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.deleteProfileCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfileCvByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.deleteProfileCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCertificateCv(certificateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCertificateCv(certificateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadCertificateCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCertificateCvByTeammemberId(certificateId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadCertificateCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadProfileCv(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadProfileCv(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadProfileCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadProfileCvByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadProfileCvByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadProfileCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSkillCv(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSkillCv(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadSkillCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSkillCvByTeammemberId(skillId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSkillCvByTeammemberId(skillId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.downloadSkillCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberCareerHistories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerHistoryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberCareerHistories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberCareerHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberCareerHistoriesByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CareerHistoryModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberCareerHistoriesByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberCareerHistoriesByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberCertificates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificateModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberCertificates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberCertificatesByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificateModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberCertificatesByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberCertificatesByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberContact(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberContact(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberContactByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberContactByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberContactByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberEducations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EducationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberEducations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberEducations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberEducationsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EducationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberEducationsByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberEducationsByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberLanguageSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberLanguageSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberLanguageSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geTeammemberLanguageSkillsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geTeammemberLanguageSkillsByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.geTeammemberLanguageSkillsByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveTeammembersByLinemanagerId(linemanagerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveTeammembersByLinemanagerId(linemanagerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getActiveTeammembersByLinemanagerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommitmentByTeammemberId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommitmentByTeammemberId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getCommitmentByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExperiencedetail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalDetailModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExperiencedetail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getExperiencedetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExperiencedetailByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalDetailModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExperiencedetailByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getExperiencedetailByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Send Teammember Email to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberById(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberById(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectLeadId Send projectLeadId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberByProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamMemberOfCommitmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberByProjectLead(projectLeadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberByProjectLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberByUid(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberByUid(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberByUid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related Line managers to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberLinemanagersForAdmin(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LineManagerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberLinemanagersForAdmin(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberLinemanagersForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberListByRate(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelTeammemberByRateResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberListByRate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberListByRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberListSummaryDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSummaryDetailsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberListSummaryDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberListSummaryDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberPersonalDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberPersonalDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberPersonalDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberPersonalDetailsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberPersonalDetailsByTeammemberId(teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberPersonalDetailsByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember Summary information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberSummaryByUid(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberSummaryByUid(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberSummaryByUid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeammemberWithProfessional(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeammemberModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeammemberWithProfessional(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.getTeammemberWithProfessional']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAddress(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAddress(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAddressByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAddressByTeammemberId(addressId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeAddressByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCareerHistory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCareerHistory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeCareerHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCareerHistoryByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCareerHistoryByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeCareerHistoryByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCertificate(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCertificate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCertificateByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCertificateByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeCertificateByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEducation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEducation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeEducation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEducationByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEducationByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeEducationByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Career Objective Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeJobPreferences(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeJobPreferences(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeJobPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Job Preferences Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeJobPreferencesByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeJobPreferencesByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeJobPreferencesByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLanguageSkill(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLanguageSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeLanguageSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLanguageSkillByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLanguageSkillByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeLanguageSkillByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePhone(phoneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePhone(phoneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removePhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePhoneByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePhoneByTeammemberId(phoneId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removePhoneByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSkill(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSkill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSkillByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSkillByTeammemberId(id, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.removeSkillByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAddress(body: AddresssModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAddress(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAddressByTeammemberId(teammemberId: string, body: AddresssModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAddressByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveAddressByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCareerHistoryByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistoryResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCareerHistoryByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveCareerHistoryByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCareerHistoryDescription(body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCareerHistoryDescription(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveCareerHistoryDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCareerHistoryDescriptionByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCareerHistoryDescriptionByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveCareerHistoryDescriptionByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCertificate(body: CertificateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCertificate(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCertificateByTeammemberId(teammemberId: string, body: CertificateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCertificateByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveCertificateByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEducationByTeammemberId(teammemberId: string, body: EducationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEducationByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveEducationByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveExperienceDetail(body: ProfessionalDetailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveExperienceDetail(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveExperienceDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveExperienceDetailByTeammemberId(teammemberId: string, body: ProfessionalDetailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveExperienceDetailByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveExperienceDetailByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Career Objective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveJobPreferences(body: JobPreferencesModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPreferencesModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveJobPreferences(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveJobPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Job Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveJobPreferencesByTeammemberId(teammemberId: string, body: JobPreferencesModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobPreferencesModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveJobPreferencesByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveJobPreferencesByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLanguageSkill(body: LanguageSkillModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLanguageSkill(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveLanguageSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLanguageSkillByTeammemberId(teammemberId: string, body: LanguageSkillModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLanguageSkillByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveLanguageSkillByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonalDetail(body: PersonalDetailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonalDetail(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.savePersonalDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePersonalDetailByTeammemberId(teammemberId: string, body: PersonalDetailModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePersonalDetailByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.savePersonalDetailByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePhone(body: PhoneModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePhone(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.savePhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId teammember Id
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePhoneByTeammemberId(teammemberId: string, body: PhoneModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePhoneByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.savePhoneByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRoleAndTitle(body: UpdateRoleAndTitleRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRoleAndTitle(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveRoleAndTitle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRoleAndTitleByTeammemberEmail(email: string, body: UpdateRoleAndTitleRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRoleAndTitleByTeammemberEmail(email, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveRoleAndTitleByTeammemberEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSkill(body: TeammemberSkillModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSkill(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Teammember email
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSkillByTeammemberEmail(email: string, body: TeammemberSkillModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeammemberSkillModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSkillByTeammemberEmail(email, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.saveSkillByTeammemberEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobName Send jobName to send a request to admin to add the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddJobRequest(jobName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddJobRequest(jobName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendAddJobRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillName Send skillName to send a request to admin to add the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddSkillRequest(skillName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddSkillRequest(skillName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendAddSkillRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddressCode(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddressCode(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendAddressCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAddressCodeByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAddressCodeByTeammemberId(addressId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendAddressCodeByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPhoneCode(phoneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPhoneCode(phoneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendPhoneCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {string} teammemberId teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPhoneCodeByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPhoneCodeByTeammemberId(phoneId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.sendPhoneCodeByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAddressAsDefault(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAddressAsDefault(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.setAddressAsDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAddressAsDefaultByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAddressAsDefaultByTeammemberId(addressId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.setAddressAsDefaultByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPhoneAsDefault(phoneId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPhoneAsDefault(phoneId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.setPhoneAsDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPhoneAsDefaultByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPhoneAsDefaultByTeammemberId(phoneId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.setPhoneAsDefaultByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUp(body: TeammemberModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUp(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.signUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCertificateCv(certificateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCertificateCv(certificateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadCertificateCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCertificateCvByTeammemberId(certificateId, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadCertificateCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProfileCv(body: UploadFileRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProfileCv(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadProfileCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProfileCvByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadProfileCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skill skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSkillCv(skill: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSkillCv(skill, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadSkillCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skill skill
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadSkillCvByTeammemberId(skill: string, teammemberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadSkillCvByTeammemberId(skill, teammemberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.uploadSkillCvByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAddress(addressId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAddress(addressId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAddressByTeammemberId(addressId: string, teammemberId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddresssModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAddressByTeammemberId(addressId, teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyAddressByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCaptcha(body: CaptchaRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCaptcha(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyCaptchaByTeammemberId(teammemberId: string, body: CaptchaRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyCaptchaByTeammemberId(teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyCaptchaByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhone(phoneId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhone(phoneId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyPhone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPhoneByTeammemberId(phoneId: string, teammemberId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PhoneModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPhoneByTeammemberId(phoneId, teammemberId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeammemberApi.verifyPhoneByTeammemberId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeammemberApi - factory interface
 * @export
 */
export const TeammemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeammemberApiFp(configuration)
    return {
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCareerHistory(body: CareerHistoryRequestModel, options?: any): AxiosPromise<CareerHistoryResponseModel> {
            return localVarFp.addCareerHistory(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEducation(body: EducationModel, options?: any): AxiosPromise<string> {
            return localVarFp.addEducation(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeammember(body: TeammemberModel, options?: any): AxiosPromise<string> {
            return localVarFp.createTeammember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileCv(body: UploadFileRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteProfileCv(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteProfileCvByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCertificateCv(certificateId: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadCertificateCv(certificateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} certificateId certificateName
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadCertificateCvByTeammemberId(certificateId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProfileCv(options?: any): AxiosPromise<string> {
            return localVarFp.downloadProfileCv(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadProfileCvByTeammemberId(teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadProfileCvByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSkillCv(skillId: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadSkillCv(skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} skillId skillId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSkillCvByTeammemberId(skillId: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadSkillCvByTeammemberId(skillId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCareerHistories(options?: any): AxiosPromise<Array<CareerHistoryModel>> {
            return localVarFp.geTeammemberCareerHistories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCareerHistoriesByTeammemberId(teammemberId: string, options?: any): AxiosPromise<Array<CareerHistoryModel>> {
            return localVarFp.geTeammemberCareerHistoriesByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCertificates(options?: any): AxiosPromise<Array<CertificateModel>> {
            return localVarFp.geTeammemberCertificates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberCertificatesByTeammemberId(teammemberId: string, options?: any): AxiosPromise<Array<CertificateModel>> {
            return localVarFp.geTeammemberCertificatesByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberContact(options?: any): AxiosPromise<ContactResponseModel> {
            return localVarFp.geTeammemberContact(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberContactByTeammemberId(teammemberId: string, options?: any): AxiosPromise<ContactResponseModel> {
            return localVarFp.geTeammemberContactByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberEducations(options?: any): AxiosPromise<Array<EducationModel>> {
            return localVarFp.geTeammemberEducations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberEducationsByTeammemberId(teammemberId: string, options?: any): AxiosPromise<Array<EducationModel>> {
            return localVarFp.geTeammemberEducationsByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberLanguageSkills(options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.geTeammemberLanguageSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geTeammemberLanguageSkillsByTeammemberId(teammemberId: string, options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.geTeammemberLanguageSkillsByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} linemanagerId Send linemanagerId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTeammembersByLinemanagerId(linemanagerId: string, options?: any): AxiosPromise<Array<TeammemberModel>> {
            return localVarFp.getActiveTeammembersByLinemanagerId(linemanagerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommitmentByTeammemberId(options?: any): AxiosPromise<Array<CommitmentModel>> {
            return localVarFp.getCommitmentByTeammemberId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperiencedetail(options?: any): AxiosPromise<ProfessionalDetailModel> {
            return localVarFp.getExperiencedetail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExperiencedetailByTeammemberId(teammemberId: string, options?: any): AxiosPromise<ProfessionalDetailModel> {
            return localVarFp.getExperiencedetailByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Send Teammember Email to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByEmail(email: string, options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberById(teammemberId: string, options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberById(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectLeadId Send projectLeadId to get the his/her related Teammembers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByProjectLead(projectLeadId: string, options?: any): AxiosPromise<Array<TeamMemberOfCommitmentModel>> {
            return localVarFp.getTeammemberByProjectLead(projectLeadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberByUid(userId: string, options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberByUid(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send TeammemberId to get all related Line managers to this Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberLinemanagersForAdmin(teammemberId: string, options?: any): AxiosPromise<Array<LineManagerModel>> {
            return localVarFp.getTeammemberLinemanagersForAdmin(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Fill TeamMember Id to get TeamMember\&#39;s Loans
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberList(body?: PaginationRequestModel, options?: any): AxiosPromise<Array<TeammemberModel>> {
            return localVarFp.getTeammemberList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] Pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberListByRate(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelTeammemberByRateResponseModel> {
            return localVarFp.getTeammemberListByRate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberListSummaryDetails(options?: any): AxiosPromise<Array<TeammemberSummaryDetailsModel>> {
            return localVarFp.getTeammemberListSummaryDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPersonalDetails(options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberPersonalDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberPersonalDetailsByTeammemberId(teammemberId: string, options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberPersonalDetailsByTeammemberId(teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId Send UserId to get the Teammember Summary information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberSummaryByUid(userId: string, options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberSummaryByUid(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeammemberWithProfessional(options?: any): AxiosPromise<TeammemberModel> {
            return localVarFp.getTeammemberWithProfessional(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddress(addressId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.removeAddress(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAddressByTeammemberId(addressId: string, teammemberId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.removeAddressByTeammemberId(addressId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareerHistory(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeCareerHistory(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Career history Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareerHistoryByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeCareerHistoryByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificate(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeCertificate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Certificate Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificateByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeCertificateByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEducation(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeEducation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Education Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEducationByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeEducationByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Career Objective Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeJobPreferences(id: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeJobPreferences(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Job Preferences Id to remove the Job Preferences from teammember\&#39;s information
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeJobPreferencesByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.removeJobPreferencesByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguageSkill(id: string, options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.removeLanguageSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Language Skill Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLanguageSkillByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.removeLanguageSkillByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePhone(phoneId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.removePhone(phoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePhoneByTeammemberId(phoneId: string, teammemberId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.removePhoneByTeammemberId(phoneId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSkill(id: string, options?: any): AxiosPromise<Array<TeammemberSkillModel>> {
            return localVarFp.removeSkill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSkillByTeammemberId(id: string, teammemberId: string, options?: any): AxiosPromise<Array<TeammemberSkillModel>> {
            return localVarFp.removeSkillByTeammemberId(id, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddress(body: AddresssModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveAddress(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {AddresssModel} body Save Address for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddressByTeammemberId(teammemberId: string, body: AddresssModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveAddressByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: any): AxiosPromise<CareerHistoryResponseModel> {
            return localVarFp.saveCareerHistoryByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryDescription(body: CareerHistoryRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveCareerHistoryDescription(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CareerHistoryRequestModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCareerHistoryDescriptionByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveCareerHistoryDescriptionByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCertificate(body: CertificateModel, options?: any): AxiosPromise<CertificateModel> {
            return localVarFp.saveCertificate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {CertificateModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCertificateByTeammemberId(teammemberId: string, body: CertificateModel, options?: any): AxiosPromise<CertificateModel> {
            return localVarFp.saveCertificateByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {EducationModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEducationByTeammemberId(teammemberId: string, body: EducationModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveEducationByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExperienceDetail(body: ProfessionalDetailModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveExperienceDetail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExperienceDetailByTeammemberId(teammemberId: string, body: ProfessionalDetailModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveExperienceDetailByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Career Objective
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJobPreferences(body: JobPreferencesModel, options?: any): AxiosPromise<JobPreferencesModel> {
            return localVarFp.saveJobPreferences(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {JobPreferencesModel} body Fill id to Update or it will create a new Job Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveJobPreferencesByTeammemberId(teammemberId: string, body: JobPreferencesModel, options?: any): AxiosPromise<JobPreferencesModel> {
            return localVarFp.saveJobPreferencesByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLanguageSkill(body: LanguageSkillModel, options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.saveLanguageSkill(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {LanguageSkillModel} body Body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLanguageSkillByTeammemberId(teammemberId: string, body: LanguageSkillModel, options?: any): AxiosPromise<Array<LanguageSkillModel>> {
            return localVarFp.saveLanguageSkillByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonalDetail(body: PersonalDetailModel, options?: any): AxiosPromise<string> {
            return localVarFp.savePersonalDetail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Send Id to get the Teammember information
         * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePersonalDetailByTeammemberId(teammemberId: string, body: PersonalDetailModel, options?: any): AxiosPromise<string> {
            return localVarFp.savePersonalDetailByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhone(body: PhoneModel, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.savePhone(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId teammember Id
         * @param {PhoneModel} body Save phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePhoneByTeammemberId(teammemberId: string, body: PhoneModel, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.savePhoneByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoleAndTitle(body: UpdateRoleAndTitleRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveRoleAndTitle(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRoleAndTitleByTeammemberEmail(email: string, body: UpdateRoleAndTitleRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveRoleAndTitleByTeammemberEmail(email, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkill(body: TeammemberSkillModel, options?: any): AxiosPromise<Array<TeammemberSkillModel>> {
            return localVarFp.saveSkill(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Teammember email
         * @param {TeammemberSkillModel} body Save skill for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSkillByTeammemberEmail(email: string, body: TeammemberSkillModel, options?: any): AxiosPromise<Array<TeammemberSkillModel>> {
            return localVarFp.saveSkillByTeammemberEmail(email, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} jobName Send jobName to send a request to admin to add the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddJobRequest(jobName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendAddJobRequest(jobName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} skillName Send skillName to send a request to admin to add the skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddSkillRequest(skillName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendAddSkillRequest(skillName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressCode(addressId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.sendAddressCode(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddressCodeByTeammemberId(addressId: string, teammemberId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.sendAddressCodeByTeammemberId(addressId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCode(phoneId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.sendPhoneCode(phoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId Phone Id
         * @param {string} teammemberId teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneCodeByTeammemberId(phoneId: string, teammemberId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.sendPhoneCodeByTeammemberId(phoneId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddressAsDefault(addressId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.setAddressAsDefault(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId addressId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAddressAsDefaultByTeammemberId(addressId: string, teammemberId: string, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.setAddressAsDefaultByTeammemberId(addressId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPhoneAsDefault(phoneId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.setPhoneAsDefault(phoneId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId phoneId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPhoneAsDefaultByTeammemberId(phoneId: string, teammemberId: string, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.setPhoneAsDefaultByTeammemberId(phoneId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp(body: TeammemberModel, options?: any): AxiosPromise<string> {
            return localVarFp.signUp(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificateCv(certificateId: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadCertificateCv(certificateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} certificateId certificateId
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadCertificateCvByTeammemberId(certificateId, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfileCv(body: UploadFileRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.uploadProfileCv(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId 
         * @param {UploadFileRequestModel} body Save cv for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.uploadProfileCvByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} skill skill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSkillCv(skill: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadSkillCv(skill, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} skill skill
         * @param {string} teammemberId Teammember Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadSkillCvByTeammemberId(skill: string, teammemberId: string, options?: any): AxiosPromise<string> {
            return localVarFp.uploadSkillCvByTeammemberId(skill, teammemberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddress(addressId: string, body: ContactVerificationRequest, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.verifyAddress(addressId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} addressId Address Id
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAddressByTeammemberId(addressId: string, teammemberId: string, body: ContactVerificationRequest, options?: any): AxiosPromise<Array<AddresssModel>> {
            return localVarFp.verifyAddressByTeammemberId(addressId, teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCaptcha(body: CaptchaRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.verifyCaptcha(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teammemberId Teammember Id
         * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyCaptchaByTeammemberId(teammemberId: string, body: CaptchaRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.verifyCaptchaByTeammemberId(teammemberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhone(phoneId: string, body: ContactVerificationRequest, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.verifyPhone(phoneId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneId Send UserId to get the Teammember information
         * @param {string} teammemberId Send teammemberId to get the Teammember information
         * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneByTeammemberId(phoneId: string, teammemberId: string, body: ContactVerificationRequest, options?: any): AxiosPromise<Array<PhoneModel>> {
            return localVarFp.verifyPhoneByTeammemberId(phoneId, teammemberId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeammemberApi - object-oriented interface
 * @export
 * @class TeammemberApi
 * @extends {BaseAPI}
 */
export class TeammemberApi extends BaseAPI {
    /**
     * 
     * @param {CareerHistoryRequestModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public addCareerHistory(body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).addCareerHistory(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EducationModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public addEducation(body: EducationModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).addEducation(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public createTeammember(body: TeammemberModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).createTeammember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UploadFileRequestModel} body Save cv for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public deleteProfileCv(body: UploadFileRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).deleteProfileCv(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId 
     * @param {UploadFileRequestModel} body Save cv for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public deleteProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).deleteProfileCvByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} certificateId certificateName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadCertificateCv(certificateId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadCertificateCv(certificateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} certificateId certificateName
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadCertificateCvByTeammemberId(certificateId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadProfileCv(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadProfileCv(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadProfileCvByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadProfileCvByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} skillId skillId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadSkillCv(skillId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadSkillCv(skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} skillId skillId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public downloadSkillCvByTeammemberId(skillId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).downloadSkillCvByTeammemberId(skillId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberCareerHistories(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberCareerHistories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberCareerHistoriesByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberCareerHistoriesByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberCertificates(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberCertificates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberCertificatesByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberCertificatesByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberContact(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberContact(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberContactByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberContactByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberEducations(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberEducations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberEducationsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberEducationsByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberLanguageSkills(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberLanguageSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public geTeammemberLanguageSkillsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).geTeammemberLanguageSkillsByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} linemanagerId Send linemanagerId to get the his/her related Teammembers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getActiveTeammembersByLinemanagerId(linemanagerId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getActiveTeammembersByLinemanagerId(linemanagerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getCommitmentByTeammemberId(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getCommitmentByTeammemberId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getExperiencedetail(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getExperiencedetail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getExperiencedetailByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getExperiencedetailByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Send Teammember Email to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberByEmail(email: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberById(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberById(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectLeadId Send projectLeadId to get the his/her related Teammembers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberByProjectLead(projectLeadId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberByProjectLead(projectLeadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId Send UserId to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberByUid(userId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberByUid(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send TeammemberId to get all related Line managers to this Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberLinemanagersForAdmin(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberLinemanagersForAdmin(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Fill TeamMember Id to get TeamMember\&#39;s Loans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] Pagination properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberListByRate(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberListByRate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberListSummaryDetails(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberListSummaryDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberPersonalDetails(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberPersonalDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberPersonalDetailsByTeammemberId(teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberPersonalDetailsByTeammemberId(teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId Send UserId to get the Teammember Summary information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberSummaryByUid(userId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberSummaryByUid(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public getTeammemberWithProfessional(options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).getTeammemberWithProfessional(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeAddress(addressId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeAddress(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId addressId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeAddressByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeAddressByTeammemberId(addressId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Career history Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeCareerHistory(id: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeCareerHistory(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Career history Id
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeCareerHistoryByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeCareerHistoryByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Certificate Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeCertificate(id: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeCertificate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Certificate Id
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeCertificateByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeCertificateByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Education Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeEducation(id: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeEducation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Education Id
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeEducationByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeEducationByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Career Objective Id to remove the Job Preferences from teammember\&#39;s information
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeJobPreferences(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeJobPreferences(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Job Preferences Id to remove the Job Preferences from teammember\&#39;s information
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeJobPreferencesByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeJobPreferencesByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Language Skill Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeLanguageSkill(id: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeLanguageSkill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Language Skill Id
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeLanguageSkillByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeLanguageSkillByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId phoneId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removePhone(phoneId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removePhone(phoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId phoneId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removePhoneByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removePhoneByTeammemberId(phoneId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeSkill(id: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeSkill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send skill Id to remove the skill from teammember\&#39;s information
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public removeSkillByTeammemberId(id: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).removeSkillByTeammemberId(id, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddresssModel} body Save Address for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveAddress(body: AddresssModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveAddress(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {AddresssModel} body Save Address for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveAddressByTeammemberId(teammemberId: string, body: AddresssModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveAddressByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {CareerHistoryRequestModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveCareerHistoryByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveCareerHistoryByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CareerHistoryRequestModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveCareerHistoryDescription(body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveCareerHistoryDescription(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {CareerHistoryRequestModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveCareerHistoryDescriptionByTeammemberId(teammemberId: string, body: CareerHistoryRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveCareerHistoryDescriptionByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CertificateModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveCertificate(body: CertificateModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveCertificate(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {CertificateModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveCertificateByTeammemberId(teammemberId: string, body: CertificateModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveCertificateByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {EducationModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveEducationByTeammemberId(teammemberId: string, body: EducationModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveEducationByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveExperienceDetail(body: ProfessionalDetailModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveExperienceDetail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {ProfessionalDetailModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveExperienceDetailByTeammemberId(teammemberId: string, body: ProfessionalDetailModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveExperienceDetailByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {JobPreferencesModel} body Fill id to Update or it will create a new Career Objective
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveJobPreferences(body: JobPreferencesModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveJobPreferences(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {JobPreferencesModel} body Fill id to Update or it will create a new Job Preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveJobPreferencesByTeammemberId(teammemberId: string, body: JobPreferencesModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveJobPreferencesByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LanguageSkillModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveLanguageSkill(body: LanguageSkillModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveLanguageSkill(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {LanguageSkillModel} body Body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveLanguageSkillByTeammemberId(teammemberId: string, body: LanguageSkillModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveLanguageSkillByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public savePersonalDetail(body: PersonalDetailModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).savePersonalDetail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Send Id to get the Teammember information
     * @param {PersonalDetailModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public savePersonalDetailByTeammemberId(teammemberId: string, body: PersonalDetailModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).savePersonalDetailByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhoneModel} body Save phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public savePhone(body: PhoneModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).savePhone(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId teammember Id
     * @param {PhoneModel} body Save phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public savePhoneByTeammemberId(teammemberId: string, body: PhoneModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).savePhoneByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveRoleAndTitle(body: UpdateRoleAndTitleRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveRoleAndTitle(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {UpdateRoleAndTitleRequestModel} body Save Role and Title for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveRoleAndTitleByTeammemberEmail(email: string, body: UpdateRoleAndTitleRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveRoleAndTitleByTeammemberEmail(email, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeammemberSkillModel} body Save skill for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveSkill(body: TeammemberSkillModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveSkill(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Teammember email
     * @param {TeammemberSkillModel} body Save skill for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public saveSkillByTeammemberEmail(email: string, body: TeammemberSkillModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).saveSkillByTeammemberEmail(email, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} jobName Send jobName to send a request to admin to add the job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendAddJobRequest(jobName: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendAddJobRequest(jobName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} skillName Send skillName to send a request to admin to add the skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendAddSkillRequest(skillName: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendAddSkillRequest(skillName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId Address Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendAddressCode(addressId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendAddressCode(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId Address Id
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendAddressCodeByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendAddressCodeByTeammemberId(addressId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId Phone Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendPhoneCode(phoneId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendPhoneCode(phoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId Phone Id
     * @param {string} teammemberId teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public sendPhoneCodeByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).sendPhoneCodeByTeammemberId(phoneId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public setAddressAsDefault(addressId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).setAddressAsDefault(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId addressId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public setAddressAsDefaultByTeammemberId(addressId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).setAddressAsDefaultByTeammemberId(addressId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId phoneId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public setPhoneAsDefault(phoneId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).setPhoneAsDefault(phoneId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId phoneId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public setPhoneAsDefaultByTeammemberId(phoneId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).setPhoneAsDefaultByTeammemberId(phoneId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeammemberModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public signUp(body: TeammemberModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).signUp(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} certificateId certificateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadCertificateCv(certificateId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadCertificateCv(certificateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} certificateId certificateId
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadCertificateCvByTeammemberId(certificateId: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadCertificateCvByTeammemberId(certificateId, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UploadFileRequestModel} body Save cv for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadProfileCv(body: UploadFileRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadProfileCv(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId 
     * @param {UploadFileRequestModel} body Save cv for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadProfileCvByTeammemberId(teammemberId: string, body: UploadFileRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadProfileCvByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} skill skill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadSkillCv(skill: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadSkillCv(skill, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} skill skill
     * @param {string} teammemberId Teammember Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public uploadSkillCvByTeammemberId(skill: string, teammemberId: string, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).uploadSkillCvByTeammemberId(skill, teammemberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId Address Id
     * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyAddress(addressId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyAddress(addressId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} addressId Address Id
     * @param {string} teammemberId Send teammemberId to get the Teammember information
     * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyAddressByTeammemberId(addressId: string, teammemberId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyAddressByTeammemberId(addressId, teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyCaptcha(body: CaptchaRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyCaptcha(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teammemberId Teammember Id
     * @param {CaptchaRequestModel} body Fill id to Update or it will create a new Teammember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyCaptchaByTeammemberId(teammemberId: string, body: CaptchaRequestModel, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyCaptchaByTeammemberId(teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId Send UserId to get the Teammember information
     * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyPhone(phoneId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyPhone(phoneId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneId Send UserId to get the Teammember information
     * @param {string} teammemberId Send teammemberId to get the Teammember information
     * @param {ContactVerificationRequest} body Verification code Phonenumber for teammemmber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeammemberApi
     */
    public verifyPhoneByTeammemberId(phoneId: string, teammemberId: string, body: ContactVerificationRequest, options?: RawAxiosRequestConfig) {
        return TeammemberApiFp(this.configuration).verifyPhoneByTeammemberId(phoneId, teammemberId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TechnologyApi - axios parameter creator
 * @export
 */
export const TechnologyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id Send id to get Technology
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTechnologyById', 'id', id)
            const localVarPath = `/V1/technologies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/technologies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TechnologyModel} body Will Create a new Technology(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTechnology: async (body: TechnologyModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTechnology', 'body', body)
            const localVarPath = `/V1/technologies/SaveTechnology`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TechnologyApi - functional programming interface
 * @export
 */
export const TechnologyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TechnologyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get Technology
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnologyById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnologyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechnologyApi.getTechnologyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTechnologyList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TechnologyModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTechnologyList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechnologyApi.getTechnologyList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TechnologyModel} body Will Create a new Technology(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTechnology(body: TechnologyModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TechnologyModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTechnology(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TechnologyApi.saveTechnology']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TechnologyApi - factory interface
 * @export
 */
export const TechnologyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TechnologyApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id Send id to get Technology
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getTechnologyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTechnologyList(options?: any): AxiosPromise<Array<TechnologyModel>> {
            return localVarFp.getTechnologyList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TechnologyModel} body Will Create a new Technology(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTechnology(body: TechnologyModel, options?: any): AxiosPromise<TechnologyModel> {
            return localVarFp.saveTechnology(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TechnologyApi - object-oriented interface
 * @export
 * @class TechnologyApi
 * @extends {BaseAPI}
 */
export class TechnologyApi extends BaseAPI {
    /**
     * 
     * @param {string} id Send id to get Technology
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnologyApi
     */
    public getTechnologyById(id: string, options?: RawAxiosRequestConfig) {
        return TechnologyApiFp(this.configuration).getTechnologyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnologyApi
     */
    public getTechnologyList(options?: RawAxiosRequestConfig) {
        return TechnologyApiFp(this.configuration).getTechnologyList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TechnologyModel} body Will Create a new Technology(don\&#39;t need id here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TechnologyApi
     */
    public saveTechnology(body: TechnologyModel, options?: RawAxiosRequestConfig) {
        return TechnologyApiFp(this.configuration).saveTechnology(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TextValueApi - axios parameter creator
 * @export
 */
export const TextValueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} category Send Category to getTextValues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategory: async (category: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getByCategory', 'category', category)
            const localVarPath = `/V1/textvalues/getByCategory/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TextValueModel} body Will Create a new TextValue(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTextValue: async (body: TextValueModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTextValue', 'body', body)
            const localVarPath = `/V1/textvalues/SaveTextValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextValueApi - functional programming interface
 * @export
 */
export const TextValueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextValueApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} category Send Category to getTextValues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCategory(category: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextValueModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCategory(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextValueApi.getByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TextValueModel} body Will Create a new TextValue(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTextValue(body: TextValueModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextValueModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTextValue(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TextValueApi.saveTextValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TextValueApi - factory interface
 * @export
 */
export const TextValueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextValueApiFp(configuration)
    return {
        /**
         * 
         * @param {string} category Send Category to getTextValues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCategory(category: string, options?: any): AxiosPromise<Array<TextValueModel>> {
            return localVarFp.getByCategory(category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TextValueModel} body Will Create a new TextValue(don\&#39;t need id here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTextValue(body: TextValueModel, options?: any): AxiosPromise<TextValueModel> {
            return localVarFp.saveTextValue(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextValueApi - object-oriented interface
 * @export
 * @class TextValueApi
 * @extends {BaseAPI}
 */
export class TextValueApi extends BaseAPI {
    /**
     * 
     * @param {string} category Send Category to getTextValues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextValueApi
     */
    public getByCategory(category: string, options?: RawAxiosRequestConfig) {
        return TextValueApiFp(this.configuration).getByCategory(category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TextValueModel} body Will Create a new TextValue(don\&#39;t need id here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextValueApi
     */
    public saveTextValue(body: TextValueModel, options?: RawAxiosRequestConfig) {
        return TextValueApiFp(this.configuration).saveTextValue(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TimesheetApi - axios parameter creator
 * @export
 */
export const TimesheetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAdjustment: async (body: UpdateAdjustmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminUpdateAdjustment', 'body', body)
            const localVarPath = `/V1/timesheet/admin/updateAdjustment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetEvaluationModel} body Save the Timesheet evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateTimesheet: async (body: TimesheetEvaluationModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('evaluateTimesheet', 'body', body)
            const localVarPath = `/V1/timesheet/evaluate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getById', 'id', id)
            const localVarPath = `/V1/timesheet/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdForAdmin: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getByIdForAdmin', 'id', id)
            const localVarPath = `/V1/timesheet/admin/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateRangeList: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getDateRangeList', 'body', body)
            const localVarPath = `/V1/timesheet/GetDateRangeList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill Id and Date properties to get a Timesheets by linemanagerId between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateRangeListByLinemanager: async (body: TimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getDateRangeListByLinemanager', 'body', body)
            const localVarPath = `/V1/timesheet/GetDateRangeListByLinemanager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send timesheet Id to get related evaluation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetEvaluation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTimesheetEvaluation', 'id', id)
            const localVarPath = `/V1/timesheet/evaluate/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to remove the Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTimesheet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeTimesheet', 'id', id)
            const localVarPath = `/V1/timesheet/remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimesheet: async (body: SaveTimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTimesheet', 'body', body)
            const localVarPath = `/V1/timesheet/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimesheetForAdmin: async (body: SaveTimesheetRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTimesheetForAdmin', 'body', body)
            const localVarPath = `/V1/timesheet/saveforadmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdjustment: async (body: UpdateAdjustmentRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateAdjustment', 'body', body)
            const localVarPath = `/V1/timesheet/updateAdjustment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimesheetApi - functional programming interface
 * @export
 */
export const TimesheetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TimesheetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateAdjustment(body: UpdateAdjustmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateAdjustment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.adminUpdateAdjustment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetEvaluationModel} body Save the Timesheet evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateTimesheet(body: TimesheetEvaluationModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateTimesheet(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.evaluateTimesheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdForAdmin(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetDetailResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdForAdmin(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.getByIdForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimesheetModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDateRangeList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.getDateRangeList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill Id and Date properties to get a Timesheets by linemanagerId between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDateRangeListByLinemanager(body: TimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimesheetModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDateRangeListByLinemanager(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.getDateRangeListByLinemanager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send timesheet Id to get related evaluation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimesheetEvaluation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetEvaluationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimesheetEvaluation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.getTimesheetEvaluation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to remove the Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTimesheet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTimesheet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.removeTimesheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTimesheet(body: SaveTimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTimesheet(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.saveTimesheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTimesheetForAdmin(body: SaveTimesheetRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTimesheetForAdmin(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.saveTimesheetForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdjustment(body: UpdateAdjustmentRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdjustment(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TimesheetApi.updateAdjustment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TimesheetApi - factory interface
 * @export
 */
export const TimesheetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TimesheetApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateAdjustment(body: UpdateAdjustmentRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.adminUpdateAdjustment(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetEvaluationModel} body Save the Timesheet evaluation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateTimesheet(body: TimesheetEvaluationModel, options?: any): AxiosPromise<object> {
            return localVarFp.evaluateTimesheet(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id: string, options?: any): AxiosPromise<TimesheetDetailResponseModel> {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to Get the Timesheet by Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdForAdmin(id: string, options?: any): AxiosPromise<TimesheetDetailResponseModel> {
            return localVarFp.getByIdForAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember Timesheets between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateRangeList(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<TimesheetModel>> {
            return localVarFp.getDateRangeList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetRequestModel} body Fill Id and Date properties to get a Timesheets by linemanagerId between two Dates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDateRangeListByLinemanager(body: TimesheetRequestModel, options?: any): AxiosPromise<Array<TimesheetModel>> {
            return localVarFp.getDateRangeListByLinemanager(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send timesheet Id to get related evaluation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimesheetEvaluation(id: string, options?: any): AxiosPromise<TimesheetEvaluationModel> {
            return localVarFp.getTimesheetEvaluation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to remove the Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTimesheet(id: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.removeTimesheet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimesheet(body: SaveTimesheetRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveTimesheet(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTimesheetForAdmin(body: SaveTimesheetRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.saveTimesheetForAdmin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdjustment(body: UpdateAdjustmentRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.updateAdjustment(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimesheetApi - object-oriented interface
 * @export
 * @class TimesheetApi
 * @extends {BaseAPI}
 */
export class TimesheetApi extends BaseAPI {
    /**
     * 
     * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public adminUpdateAdjustment(body: UpdateAdjustmentRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).adminUpdateAdjustment(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetEvaluationModel} body Save the Timesheet evaluation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public evaluateTimesheet(body: TimesheetEvaluationModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).evaluateTimesheet(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to Get the Timesheet by Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public getById(id: string, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to Get the Timesheet by Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public getByIdForAdmin(id: string, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).getByIdForAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body Fill TeammemberId and Date properties to get a Teammember Timesheets between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public getDateRangeList(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).getDateRangeList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetRequestModel} body Fill Id and Date properties to get a Timesheets by linemanagerId between two Dates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public getDateRangeListByLinemanager(body: TimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).getDateRangeListByLinemanager(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send timesheet Id to get related evaluation details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public getTimesheetEvaluation(id: string, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).getTimesheetEvaluation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to remove the Timesheet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public removeTimesheet(id: string, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).removeTimesheet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public saveTimesheet(body: SaveTimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).saveTimesheet(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveTimesheetRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public saveTimesheetForAdmin(body: SaveTimesheetRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).saveTimesheetForAdmin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateAdjustmentRequestModel} body Fill Id to update specific Timesheet otherwise it will add new Timesheet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimesheetApi
     */
    public updateAdjustment(body: UpdateAdjustmentRequestModel, options?: RawAxiosRequestConfig) {
        return TimesheetApiFp(this.configuration).updateAdjustment(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ForgotPasswordRequestModel} body Send Email(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (body: ForgotPasswordRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('forgotPassword', 'body', body)
            const localVarPath = `/V1/authentication/ForgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Get Login link for client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginLinkForClient: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getLoginLinkForClient', 'email', email)
            const localVarPath = `/V1/authentication/GetLoginLinkForClient/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getUserByEmail', 'email', email)
            const localVarPath = `/V1/authentication/GetUserByEmail/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/authentication/getUserList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationByIp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/authentication/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} role role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRole: async (role: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('getUsersByRole', 'role', role)
            const localVarPath = `/V1/authentication/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterWithCustomTokenModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithCustomToken: async (body: RegisterWithCustomTokenModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loginWithCustomToken', 'body', body)
            const localVarPath = `/V1/authentication/LoginWithCustomToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginRequestModel} body Send Email and Password to log in(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithEmailandPassword: async (body: LoginRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loginWithEmailandPassword', 'body', body)
            const localVarPath = `/V1/authentication/LoginWithEmailandPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterModel} body Send Email and OAuth Access token to login with google(don\&#39;t need Password here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithGoogle: async (body: RegisterModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('loginWithGoogle', 'body', body)
            const localVarPath = `/V1/authentication/LoginWithGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterModel} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (body: RegisterModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('register', 'body', body)
            const localVarPath = `/V1/authentication/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserDevice: async (body: UserDevices, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('removeUserDevice', 'body', body)
            const localVarPath = `/V1/authentication/RemoveUserDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (body: ValidateResetPasswordRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('resetPassword', 'body', body)
            const localVarPath = `/V1/authentication/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken, Device Type (Browser &#x3D; 0, IOS &#x3D; 1, Android &#x3D; 2) and Device Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserDevice: async (body: UserDevices, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendUserDevice', 'body', body)
            const localVarPath = `/V1/authentication/SendUserDevice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VerifyUserRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail: async (body: VerifyUserRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendVerificationEmail', 'body', body)
            const localVarPath = `/V1/authentication/SendVerificationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetUserRoleModel} body Send Roles to be set for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserRole: async (body: SetUserRoleModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setUserRole', 'body', body)
            const localVarPath = `/V1/authentication/SetUserRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetToken: async (body: ValidateResetPasswordRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('validateResetToken', 'body', body)
            const localVarPath = `/V1/authentication/ValidateResetToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVerificationEmail: async (body: ValidateResetPasswordRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('validateVerificationEmail', 'body', body)
            const localVarPath = `/V1/authentication/ValidateVerificationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ForgotPasswordRequestModel} body Send Email(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(body: ForgotPasswordRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Get Login link for client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginLinkForClient(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginLinkForClient(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getLoginLinkForClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLocationByIp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IpToLocationResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLocationByIp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserLocationByIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} role role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByRole(role: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByRole(role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUsersByRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterWithCustomTokenModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithCustomToken(body: RegisterWithCustomTokenModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiObjectResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithCustomToken(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.loginWithCustomToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginRequestModel} body Send Email and Password to log in(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithEmailandPassword(body: LoginRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthenticateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithEmailandPassword(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.loginWithEmailandPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterModel} body Send Email and OAuth Access token to login with google(don\&#39;t need Password here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithGoogle(body: RegisterModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirebaseAuthLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithGoogle(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.loginWithGoogle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterModel} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(body: RegisterModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirebaseAuthLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserDevice(body: UserDevices, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserDevice(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.removeUserDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken, Device Type (Browser &#x3D; 0, IOS &#x3D; 1, Android &#x3D; 2) and Device Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserDevice(body: UserDevices, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserDevice(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.sendUserDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VerifyUserRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationEmail(body: VerifyUserRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationEmail(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.sendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetUserRoleModel} body Send Roles to be set for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserRole(body: SetUserRoleModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserRole(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.setUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateResetToken(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiObjectResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateResetToken(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.validateResetToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateVerificationEmail(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateVerificationEmail(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.validateVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @param {ForgotPasswordRequestModel} body Send Email(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(body: ForgotPasswordRequestModel, options?: any): AxiosPromise<Result> {
            return localVarFp.forgotPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Get Login link for client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginLinkForClient(email: string, options?: any): AxiosPromise<Result> {
            return localVarFp.getLoginLinkForClient(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Send Email to get the User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByEmail(email: string, options?: any): AxiosPromise<UserRecord> {
            return localVarFp.getUserByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserList(options?: any): AxiosPromise<Array<UserModel>> {
            return localVarFp.getUserList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationByIp(options?: any): AxiosPromise<IpToLocationResponseModel> {
            return localVarFp.getUserLocationByIp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} role role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRole(role: string, options?: any): AxiosPromise<Array<UserModel>> {
            return localVarFp.getUsersByRole(role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterWithCustomTokenModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithCustomToken(body: RegisterWithCustomTokenModel, options?: any): AxiosPromise<ApiObjectResult> {
            return localVarFp.loginWithCustomToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginRequestModel} body Send Email and Password to log in(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithEmailandPassword(body: LoginRequestModel, options?: any): AxiosPromise<AuthenticateResponse> {
            return localVarFp.loginWithEmailandPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterModel} body Send Email and OAuth Access token to login with google(don\&#39;t need Password here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithGoogle(body: RegisterModel, options?: any): AxiosPromise<FirebaseAuthLink> {
            return localVarFp.loginWithGoogle(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterModel} body Create new User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(body: RegisterModel, options?: any): AxiosPromise<FirebaseAuthLink> {
            return localVarFp.register(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserDevice(body: UserDevices, options?: any): AxiosPromise<Result> {
            return localVarFp.removeUserDevice(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(body: ValidateResetPasswordRequestModel, options?: any): AxiosPromise<Result> {
            return localVarFp.resetPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserDevices} body Fill FirebaseToken, Device Type (Browser &#x3D; 0, IOS &#x3D; 1, Android &#x3D; 2) and Device Model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserDevice(body: UserDevices, options?: any): AxiosPromise<Result> {
            return localVarFp.sendUserDevice(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VerifyUserRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail(body: VerifyUserRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.sendVerificationEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetUserRoleModel} body Send Roles to be set for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserRole(body: SetUserRoleModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.setUserRole(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateResetToken(body: ValidateResetPasswordRequestModel, options?: any): AxiosPromise<ApiObjectResult> {
            return localVarFp.validateResetToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateResetPasswordRequestModel} body Send token to login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVerificationEmail(body: ValidateResetPasswordRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.validateVerificationEmail(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {ForgotPasswordRequestModel} body Send Email(don\&#39;t need OAuthAccessToken here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public forgotPassword(body: ForgotPasswordRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).forgotPassword(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Get Login link for client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getLoginLinkForClient(email: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getLoginLinkForClient(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Send Email to get the User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserByEmail(email: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserList(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserLocationByIp(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserLocationByIp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} role role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsersByRole(role: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUsersByRole(role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterWithCustomTokenModel} body Send token to login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginWithCustomToken(body: RegisterWithCustomTokenModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).loginWithCustomToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginRequestModel} body Send Email and Password to log in(don\&#39;t need OAuthAccessToken here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginWithEmailandPassword(body: LoginRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).loginWithEmailandPassword(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterModel} body Send Email and OAuth Access token to login with google(don\&#39;t need Password here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public loginWithGoogle(body: RegisterModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).loginWithGoogle(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterModel} body Create new User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public register(body: RegisterModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).register(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserDevices} body Fill FirebaseToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public removeUserDevice(body: UserDevices, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).removeUserDevice(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public resetPassword(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).resetPassword(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserDevices} body Fill FirebaseToken, Device Type (Browser &#x3D; 0, IOS &#x3D; 1, Android &#x3D; 2) and Device Model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sendUserDevice(body: UserDevices, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).sendUserDevice(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VerifyUserRequestModel} body Send token to login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sendVerificationEmail(body: VerifyUserRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).sendVerificationEmail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetUserRoleModel} body Send Roles to be set for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public setUserRole(body: SetUserRoleModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).setUserRole(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateResetPasswordRequestModel} body Send Token(don\&#39;t need OAuthAccessToken here)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public validateResetToken(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).validateResetToken(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateResetPasswordRequestModel} body Send token to login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public validateVerificationEmail(body: ValidateResetPasswordRequestModel, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).validateVerificationEmail(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VMApi - axios parameter creator
 * @export
 */
export const VMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {VmStatusRequestModel} body Terminate vm model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus: async (body: VmStatusRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('changeStatus', 'body', body)
            const localVarPath = `/V1/vm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VmModel} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVM: async (body: VmModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createVM', 'body', body)
            const localVarPath = `/V1/vm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} callerPrivateIp callerPrivateIp
         * @param {string} calleePublicIpPort calleePublicIpPort
         * @param {boolean} status status
         * @param {number} latency latency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVMMonitor: async (callerPrivateIp: string, calleePublicIpPort: string, status: boolean, latency: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callerPrivateIp' is not null or undefined
            assertParamExists('createVMMonitor', 'callerPrivateIp', callerPrivateIp)
            // verify required parameter 'calleePublicIpPort' is not null or undefined
            assertParamExists('createVMMonitor', 'calleePublicIpPort', calleePublicIpPort)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('createVMMonitor', 'status', status)
            // verify required parameter 'latency' is not null or undefined
            assertParamExists('createVMMonitor', 'latency', latency)
            const localVarPath = `/V1/vm/vmMonitor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callerPrivateIp !== undefined) {
                localVarQueryParameter['callerPrivateIp'] = callerPrivateIp;
            }

            if (calleePublicIpPort !== undefined) {
                localVarQueryParameter['calleePublicIpPort'] = calleePublicIpPort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (latency !== undefined) {
                localVarQueryParameter['latency'] = latency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<WazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWazuh: async (body: Array<WazuhRequestModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createWazuh', 'body', body)
            const localVarPath = `/V1/vm/wazuh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<VmWazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWazuhResult: async (body: Array<VmWazuhRequestModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createWazuhResult', 'body', body)
            const localVarPath = `/V1/vm/wazuhResult`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to get VM log
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLog: async (id: string, body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActionLog', 'id', id)
            const localVarPath = `/V1/vm/log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityWatchForVM: async (body: ActivityWatchRequestVM, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getActivityWatchForVM', 'body', body)
            const localVarPath = `/V1/vm/GetActivityWatchForVM`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ipAddress Send ipAddress to Get Last Sonar Qube Data Push Date time
         * @param {string} projectName Send projectName to Get Last Sonar Qube Data Push Date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastSonarQubeDataPushDatetime: async (ipAddress: string, projectName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ipAddress' is not null or undefined
            assertParamExists('getLastSonarQubeDataPushDatetime', 'ipAddress', ipAddress)
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getLastSonarQubeDataPushDatetime', 'projectName', projectName)
            const localVarPath = `/V1/vm/SonarQube/lastDataPushDateTime/{ipAddress}/{projectName}`
                .replace(`{${"ipAddress"}}`, encodeURIComponent(String(ipAddress)))
                .replace(`{${"projectName"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastWazuhResultForVM: async (vmId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vmId' is not null or undefined
            assertParamExists('getLastWazuhResultForVM', 'vmId', vmId)
            const localVarPath = `/V1/vm/wazuh/getLastResult`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (vmId !== undefined) {
                localVarQueryParameter['vmId'] = vmId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send Id to get VM detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVM: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVM', 'id', id)
            const localVarPath = `/V1/vm/getById/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVMList: async (body?: PaginationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/vm/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email Send Email to Get VM Related Logins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVMLoginBasedOnTeammemberEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getVMLoginBasedOnTeammemberEmail', 'email', email)
            const localVarPath = `/V1/vm/connectionAssistant/getVMLoginBasedOnTeammemberEmail/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VmSonarQubeResultRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sonarQubeDataPush: async (body: VmSonarQubeResultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sonarQubeDataPush', 'body', body)
            const localVarPath = `/V1/vm/SonarQube/dataPush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {VmPushActivityWatchRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMActivityWatch: async (body: VmPushActivityWatchRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('vMActivityWatch', 'body', body)
            const localVarPath = `/V1/vm/activityWatch/dataPush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ipAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMActivityWatchGetLastRecorded: async (ipAddress: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ipAddress' is not null or undefined
            assertParamExists('vMActivityWatchGetLastRecorded', 'ipAddress', ipAddress)
            const localVarPath = `/V1/vm/activityWatch/getLastRecorded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ipAddress !== undefined) {
                localVarQueryParameter['ipAddress'] = ipAddress;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMSecurityPolicy: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/vm/vm_security_policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VMApi - functional programming interface
 * @export
 */
export const VMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VMApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {VmStatusRequestModel} body Terminate vm model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStatus(body: VmStatusRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStatus(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.changeStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VmModel} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVM(body: VmModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.createVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} callerPrivateIp callerPrivateIp
         * @param {string} calleePublicIpPort calleePublicIpPort
         * @param {boolean} status status
         * @param {number} latency latency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVMMonitor(callerPrivateIp: string, calleePublicIpPort: string, status: boolean, latency: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVMMonitor(callerPrivateIp, calleePublicIpPort, status, latency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.createVMMonitor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<WazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWazuh(body: Array<WazuhRequestModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWazuh(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.createWazuh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<VmWazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWazuhResult(body: Array<VmWazuhRequestModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWazuhResult(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.createWazuhResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to get VM log
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLog(id: string, body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelVmActionLogResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLog(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getActionLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityWatchForVM(body: ActivityWatchRequestVM, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmActivityWatchReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityWatchForVM(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getActivityWatchForVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ipAddress Send ipAddress to Get Last Sonar Qube Data Push Date time
         * @param {string} projectName Send projectName to Get Last Sonar Qube Data Push Date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastSonarQubeDataPushDatetime(ipAddress: string, projectName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastSonarQubeDataPushDatetime(ipAddress, projectName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getLastSonarQubeDataPushDatetime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastWazuhResultForVM(vmId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmWazuhModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastWazuhResultForVM(vmId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getLastWazuhResultForVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send Id to get VM detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVM(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVM(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getVM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVMList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginationResponseModelVmModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVMList(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getVMList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email Send Email to Get VM Related Logins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVMLoginBasedOnTeammemberEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultIEnumerable1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVMLoginBasedOnTeammemberEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.getVMLoginBasedOnTeammemberEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VmSonarQubeResultRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sonarQubeDataPush(body: VmSonarQubeResultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sonarQubeDataPush(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.sonarQubeDataPush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {VmPushActivityWatchRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vMActivityWatch(body: VmPushActivityWatchRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vMActivityWatch(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.vMActivityWatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ipAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vMActivityWatchGetLastRecorded(ipAddress: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VmLastPushedDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vMActivityWatchGetLastRecorded(ipAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.vMActivityWatchGetLastRecorded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vMSecurityPolicy(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VmSecurityPolicyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vMSecurityPolicy(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VMApi.vMSecurityPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VMApi - factory interface
 * @export
 */
export const VMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VMApiFp(configuration)
    return {
        /**
         * 
         * @param {VmStatusRequestModel} body Terminate vm model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus(body: VmStatusRequestModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.changeStatus(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VmModel} body string content to save as vms in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVM(body: VmModel, options?: any): AxiosPromise<VmModel> {
            return localVarFp.createVM(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} callerPrivateIp callerPrivateIp
         * @param {string} calleePublicIpPort calleePublicIpPort
         * @param {boolean} status status
         * @param {number} latency latency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVMMonitor(callerPrivateIp: string, calleePublicIpPort: string, status: boolean, latency: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.createVMMonitor(callerPrivateIp, calleePublicIpPort, status, latency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<WazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWazuh(body: Array<WazuhRequestModel>, options?: any): AxiosPromise<boolean> {
            return localVarFp.createWazuh(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<VmWazuhRequestModel>} body string content to save as WAZUH in database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWazuhResult(body: Array<VmWazuhRequestModel>, options?: any): AxiosPromise<boolean> {
            return localVarFp.createWazuhResult(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to get VM log
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLog(id: string, body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelVmActionLogResponseModel> {
            return localVarFp.getActionLog(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ActivityWatchRequestVM} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityWatchForVM(body: ActivityWatchRequestVM, options?: any): AxiosPromise<VmActivityWatchReport> {
            return localVarFp.getActivityWatchForVM(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ipAddress Send ipAddress to Get Last Sonar Qube Data Push Date time
         * @param {string} projectName Send projectName to Get Last Sonar Qube Data Push Date time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastSonarQubeDataPushDatetime(ipAddress: string, projectName: string, options?: any): AxiosPromise<string> {
            return localVarFp.getLastSonarQubeDataPushDatetime(ipAddress, projectName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} vmId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastWazuhResultForVM(vmId: string, options?: any): AxiosPromise<VmWazuhModel> {
            return localVarFp.getLastWazuhResultForVM(vmId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send Id to get VM detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVM(id: string, options?: any): AxiosPromise<VmModel> {
            return localVarFp.getVM(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PaginationRequestModel} [body] pagination properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVMList(body?: PaginationRequestModel, options?: any): AxiosPromise<PaginationResponseModelVmModel> {
            return localVarFp.getVMList(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email Send Email to Get VM Related Logins
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVMLoginBasedOnTeammemberEmail(email: string, options?: any): AxiosPromise<ResultIEnumerable1> {
            return localVarFp.getVMLoginBasedOnTeammemberEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VmSonarQubeResultRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sonarQubeDataPush(body: VmSonarQubeResultRequest, options?: any): AxiosPromise<string> {
            return localVarFp.sonarQubeDataPush(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {VmPushActivityWatchRequestModel} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMActivityWatch(body: VmPushActivityWatchRequestModel, options?: any): AxiosPromise<string> {
            return localVarFp.vMActivityWatch(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ipAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMActivityWatchGetLastRecorded(ipAddress: string, options?: any): AxiosPromise<VmLastPushedDataResponse> {
            return localVarFp.vMActivityWatchGetLastRecorded(ipAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vMSecurityPolicy(options?: any): AxiosPromise<Array<VmSecurityPolicyResponse>> {
            return localVarFp.vMSecurityPolicy(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VMApi - object-oriented interface
 * @export
 * @class VMApi
 * @extends {BaseAPI}
 */
export class VMApi extends BaseAPI {
    /**
     * 
     * @param {VmStatusRequestModel} body Terminate vm model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public changeStatus(body: VmStatusRequestModel, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).changeStatus(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VmModel} body string content to save as vms in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public createVM(body: VmModel, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).createVM(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} callerPrivateIp callerPrivateIp
     * @param {string} calleePublicIpPort calleePublicIpPort
     * @param {boolean} status status
     * @param {number} latency latency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public createVMMonitor(callerPrivateIp: string, calleePublicIpPort: string, status: boolean, latency: number, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).createVMMonitor(callerPrivateIp, calleePublicIpPort, status, latency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<WazuhRequestModel>} body string content to save as WAZUH in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public createWazuh(body: Array<WazuhRequestModel>, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).createWazuh(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<VmWazuhRequestModel>} body string content to save as WAZUH in database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public createWazuhResult(body: Array<VmWazuhRequestModel>, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).createWazuhResult(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to get VM log
     * @param {PaginationRequestModel} [body] pagination properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getActionLog(id: string, body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getActionLog(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ActivityWatchRequestVM} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getActivityWatchForVM(body: ActivityWatchRequestVM, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getActivityWatchForVM(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ipAddress Send ipAddress to Get Last Sonar Qube Data Push Date time
     * @param {string} projectName Send projectName to Get Last Sonar Qube Data Push Date time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getLastSonarQubeDataPushDatetime(ipAddress: string, projectName: string, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getLastSonarQubeDataPushDatetime(ipAddress, projectName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} vmId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getLastWazuhResultForVM(vmId: string, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getLastWazuhResultForVM(vmId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send Id to get VM detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getVM(id: string, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getVM(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaginationRequestModel} [body] pagination properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getVMList(body?: PaginationRequestModel, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getVMList(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email Send Email to Get VM Related Logins
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public getVMLoginBasedOnTeammemberEmail(email: string, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).getVMLoginBasedOnTeammemberEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VmSonarQubeResultRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public sonarQubeDataPush(body: VmSonarQubeResultRequest, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).sonarQubeDataPush(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VmPushActivityWatchRequestModel} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public vMActivityWatch(body: VmPushActivityWatchRequestModel, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).vMActivityWatch(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ipAddress 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public vMActivityWatchGetLastRecorded(ipAddress: string, options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).vMActivityWatchGetLastRecorded(ipAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VMApi
     */
    public vMSecurityPolicy(options?: RawAxiosRequestConfig) {
        return VMApiFp(this.configuration).vMSecurityPolicy(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerificationApi - axios parameter creator
 * @export
 */
export const VerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/verify/getDownloadUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/V1/verify/getStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IdentityImageTypeRequestModel} body The type of identity image(0&#x3D;Face, 1&#x3D;Signature, 2&#x3D;Passport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl: async (body: IdentityImageTypeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getUploadUrl', 'body', body)
            const localVarPath = `/V1/verify/getUploadUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<IdentityImageUrlRequestModel>} body The url of identity image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveImageUrl: async (body: Array<IdentityImageUrlRequestModel>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveImageUrl', 'body', body)
            const localVarPath = `/V1/verify/saveImageUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerificationApi - functional programming interface
 * @export
 */
export const VerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDownloadUrl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityImageUrlsResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDownloadUrl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.getDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdentityGetStatusResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.getStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IdentityImageTypeRequestModel} body The type of identity image(0&#x3D;Face, 1&#x3D;Signature, 2&#x3D;Passport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadUrl(body: IdentityImageTypeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AzureStorageUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadUrl(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.getUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<IdentityImageUrlRequestModel>} body The url of identity image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveImageUrl(body: Array<IdentityImageUrlRequestModel>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveImageUrl(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.saveImageUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VerificationApi - factory interface
 * @export
 */
export const VerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerificationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDownloadUrl(options?: any): AxiosPromise<IdentityImageUrlsResponseModel> {
            return localVarFp.getDownloadUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(options?: any): AxiosPromise<Array<IdentityGetStatusResponseModel>> {
            return localVarFp.getStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IdentityImageTypeRequestModel} body The type of identity image(0&#x3D;Face, 1&#x3D;Signature, 2&#x3D;Passport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadUrl(body: IdentityImageTypeRequestModel, options?: any): AxiosPromise<AzureStorageUrl> {
            return localVarFp.getUploadUrl(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<IdentityImageUrlRequestModel>} body The url of identity image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveImageUrl(body: Array<IdentityImageUrlRequestModel>, options?: any): AxiosPromise<string> {
            return localVarFp.saveImageUrl(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerificationApi - object-oriented interface
 * @export
 * @class VerificationApi
 * @extends {BaseAPI}
 */
export class VerificationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public getDownloadUrl(options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).getDownloadUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public getStatus(options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).getStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IdentityImageTypeRequestModel} body The type of identity image(0&#x3D;Face, 1&#x3D;Signature, 2&#x3D;Passport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public getUploadUrl(body: IdentityImageTypeRequestModel, options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).getUploadUrl(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<IdentityImageUrlRequestModel>} body The url of identity image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public saveImageUrl(body: Array<IdentityImageUrlRequestModel>, options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).saveImageUrl(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WeeklyTimesheetAuditApi - axios parameter creator
 * @export
 */
export const WeeklyTimesheetAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClientTimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientTimesheetReaction: async (body: ClientTimesheetReactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientTimesheetReaction', 'body', body)
            const localVarPath = `/V1/notification/client/TimesheetReaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WeeklyTimesheetAuditModel} body all parameters required to approve a Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeeklyTimesheetAudit: async (body: WeeklyTimesheetAuditModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createWeeklyTimesheetAudit', 'body', body)
            const localVarPath = `/V1/weeklyTimesheetAudit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to get specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTimesheetAuditById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWeeklyTimesheetAuditById', 'id', id)
            const localVarPath = `/V1/weeklyTimesheetAudit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a WeeklyTimesheetAudits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTimesheetAuditsByDateRange: async (body: DateRangeRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getWeeklyTimesheetAuditsByDateRange', 'body', body)
            const localVarPath = `/V1/weeklyTimesheetAudit/getListByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linemanagerTimesheetReaction: async (body: TimesheetReactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('linemanagerTimesheetReaction', 'body', body)
            const localVarPath = `/V1/notification/linemanagerTimesheetReaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id Send id to revoke specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeWeeklyTimesheetAudit: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeWeeklyTimesheetAudit', 'id', id)
            const localVarPath = `/V1/weeklyTimesheetAudit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeeklyTimesheetAuditApi - functional programming interface
 * @export
 */
export const WeeklyTimesheetAuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeeklyTimesheetAuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClientTimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientTimesheetReaction(body: ClientTimesheetReactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientTimesheetReaction(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.clientTimesheetReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WeeklyTimesheetAuditModel} body all parameters required to approve a Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWeeklyTimesheetAudit(body: WeeklyTimesheetAuditModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWeeklyTimesheetAudit(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.createWeeklyTimesheetAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to get specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyTimesheetAuditById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyTimesheetAuditById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.getWeeklyTimesheetAuditById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a WeeklyTimesheetAudits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyTimesheetAuditsByDateRange(body: DateRangeRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WeeklyTimesheetAuditModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyTimesheetAuditsByDateRange(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.getWeeklyTimesheetAuditsByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linemanagerTimesheetReaction(body: TimesheetReactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linemanagerTimesheetReaction(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.linemanagerTimesheetReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id Send id to revoke specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeWeeklyTimesheetAudit(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeWeeklyTimesheetAudit(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyTimesheetAuditApi.revokeWeeklyTimesheetAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WeeklyTimesheetAuditApi - factory interface
 * @export
 */
export const WeeklyTimesheetAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeeklyTimesheetAuditApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientTimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientTimesheetReaction(body: ClientTimesheetReactionRequest, options?: any): AxiosPromise<Result> {
            return localVarFp.clientTimesheetReaction(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WeeklyTimesheetAuditModel} body all parameters required to approve a Commitment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeeklyTimesheetAudit(body: WeeklyTimesheetAuditModel, options?: any): AxiosPromise<string> {
            return localVarFp.createWeeklyTimesheetAudit(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to get specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTimesheetAuditById(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getWeeklyTimesheetAuditById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DateRangeRequestModel} body Fill Date properties to get a WeeklyTimesheetAudits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyTimesheetAuditsByDateRange(body: DateRangeRequestModel, options?: any): AxiosPromise<Array<WeeklyTimesheetAuditModel>> {
            return localVarFp.getWeeklyTimesheetAuditsByDateRange(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimesheetReactionRequest} body Fill Line manager Reaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linemanagerTimesheetReaction(body: TimesheetReactionRequest, options?: any): AxiosPromise<Result> {
            return localVarFp.linemanagerTimesheetReaction(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id Send id to revoke specific WeeklyTimesheetAudit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeWeeklyTimesheetAudit(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.revokeWeeklyTimesheetAudit(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeeklyTimesheetAuditApi - object-oriented interface
 * @export
 * @class WeeklyTimesheetAuditApi
 * @extends {BaseAPI}
 */
export class WeeklyTimesheetAuditApi extends BaseAPI {
    /**
     * 
     * @param {ClientTimesheetReactionRequest} body Fill Line manager Reaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public clientTimesheetReaction(body: ClientTimesheetReactionRequest, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).clientTimesheetReaction(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WeeklyTimesheetAuditModel} body all parameters required to approve a Commitment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public createWeeklyTimesheetAudit(body: WeeklyTimesheetAuditModel, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).createWeeklyTimesheetAudit(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to get specific WeeklyTimesheetAudit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public getWeeklyTimesheetAuditById(id: string, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).getWeeklyTimesheetAuditById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DateRangeRequestModel} body Fill Date properties to get a WeeklyTimesheetAudits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public getWeeklyTimesheetAuditsByDateRange(body: DateRangeRequestModel, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).getWeeklyTimesheetAuditsByDateRange(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimesheetReactionRequest} body Fill Line manager Reaction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public linemanagerTimesheetReaction(body: TimesheetReactionRequest, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).linemanagerTimesheetReaction(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id Send id to revoke specific WeeklyTimesheetAudit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyTimesheetAuditApi
     */
    public revokeWeeklyTimesheetAudit(id: string, options?: RawAxiosRequestConfig) {
        return WeeklyTimesheetAuditApiFp(this.configuration).revokeWeeklyTimesheetAudit(id, options).then((request) => request(this.axios, this.basePath));
    }
}



